if (typeof I$==="undefined"){I$=(function() {
    var o = {},
        f = function() {return !1;},
        cache = {};
    var is = function(data,type){
        return o.toString.call(data)==='[object '+type+']';
    };
    return function(key,func) {
        var result = cache[key],
            isfunc = is(func,'Function');
        // func is data
        if (func!=null&&!isfunc){
            result = func;
        }
        // do function defined
        if (isfunc){
            var arr = [];
            for(var i=2,l=arguments.length;i<l;i++){
                arr.push(arguments.callee(arguments[i]));
            }
            var exports = {};
            arr.push.call(arr,exports,{},f,[]);
            var ret = func.apply(null,arr)||exports;
            if (!result||!is(ret,'Object')){
                // for non-object return
                result = ret;
            }else{
                // for namespace return
                // bad performance for-in in v8 for instance
                if (!!Object.keys){
                    for(var ls=Object.keys(ret),i=0,l=ls.length,x;i<l;i++){
                        x = ls[i];
                        result[x] = ret[x];
                    }
                }else{
                    for(var x in ret){
                        result[x] = ret[x];
                    }
                }
            }
        }
        // init data
        if (result==null){
            result = {};
        }
        cache[key] = result;
        // return
        return result;
    };
})();;}
I$('19c9fc0aab6a6b9db67f02f7d86454f4',function (_p,_o,_f,_r){
    var _extpro = Function.prototype;
    /**
     * AOP增强操作，增强操作接受一个输入参数包含以下信息
     *
     *  | 参数名称 | 参数类型  | 参数描述 |
     *  | :--     | :--      | :-- |
     *  | args    | Array    | 函数调用时实际输入参数，各增强操作中可以改变值后将影响至后续的操作 |
     *  | value   | Variable | 输出结果 |
     *  | stopped | Boolean  | 是否结束操作，终止后续操作 |
     *
     * @method external:Function#_$aop
     * @param  {Function} arg0 - 前置操作，接受一个输入参数，见描述信息
     * @param  {Function} arg1 - 后置操作，接受一个输入参数，见描述信息
     * @return {Function}        增强后操作函数
     */
    _extpro._$aop = function(_before,_after){
        var _after = _after||_f,
            _before = _before||_f,
            _handler = this;
        return function(){
            var _event = {args:_r.slice.call(arguments,0)};
            _before(_event);
            if (!_event.stopped){
                _event.value = _handler.apply(this,_event.args);
                _after(_event);
            }
            return _event.value;
        };
    };
    /**
     * 绑定接口及参数，使其的调用对象保持一致
     *
     *  ```javascript
     *  var scope = {a:0};
     * 
     *  var func = function(a,b){
     *      // 第一个参数 ：1
     *      console.log(a);
     *      // 第二个参数 ： 2
     *      consoel.log(b);
     *      // 当前this.a ： 0
     *      console.log(this.a);
     *  };
     * 
     *  func._$bind(scope,"1")(2);
     *  ```
     *
     * @method external:Function#_$bind
     * @see    external:Function#_$bind2
     * @param  {Object} arg0 - 需要保持一致的对象，null表示window对象，此参数外的其他参数作为绑定参数
     * @return {Function}      返回绑定后的函数
     */
    _extpro._$bind = function() {
        var _args = arguments,
            _object = arguments[0],
            _function = this;
        return function(){
            // not use slice for chrome 10 beta and Array.apply for android
            var _argc = _r.slice.call(_args,1);
            _r.push.apply(_argc,arguments);
            return _function.apply(_object||null,_argc);
        };
    };
    /**
     * 绑定接口及参数，使其的调用对象保持一致，
     * 该接口与_$bind接口的差别在于绑定时参数和调用时参数的顺序不一样，
     * _$bind优先传入绑定时参数，_$bind2优先传入调用时参数
     *
     *  ```javascript
     *  var scope = {a:0};
     * 
     *  var func = function(a,b){
     *      // 第一个参数 ：2
     *      console.log(a);
     *      // 第二个参数 ： 1
     *      consoel.log(b);
     *      // 当前this.a ： 0
     *      console.log(this.a);
     *  };
     * 
     *  func._$bind(scope,"1")(2);
     *  ```
     *
     * @method external:Function#_$bind2
     * @see    external:Function#_$bind
     * @param  {Object} arg0 - 需要保持一致的对象，null表示window对象，此参数外的其他参数作为绑定参数
     * @return {Function}      返回绑定后的事件函数
     */
    _extpro._$bind2 = function() {
        var _args = arguments,
            _object = _r.shift.call(_args),
            _function = this;
        return function(){
            _r.push.apply(arguments,_args);
            return _function.apply(_object||null,arguments);
        };
    };
    // for compatiable
    var _extpro = String.prototype;
    if (!_extpro.trim){
         _extpro.trim = (function(){
            var _reg = /(?:^\s+)|(?:\s+$)/g;
            return function(){
                return this.replace(_reg,'');
            };
         })();
    }
    if (!this.console){
        this.console = {
            log:_f,
            error:_f
        };
    }

    if (CMPT){
        NEJ = this.NEJ||{};
        // copy object properties
        // only for nej compatiable
        NEJ.copy = function(a,b){
            a = a||{};
            b = b||_o;
            for(var x in b){
                if (b.hasOwnProperty(x)){
                    a[x] = b[x];
                }
            }
            return a;
        };
        // NEJ namespace
        NEJ = NEJ.copy(
            NEJ,{
                O:_o,R:_r,F:_f,
                P:function(_namespace){
                    if (!_namespace||!_namespace.length){
                        return null;
                    }
                    var _package = window;
                    for(var a=_namespace.split('.'),
                            l=a.length,i=(a[0]=='window')?1:0;i<l;
                            _package=_package[a[i]]=_package[a[i]]||{},i++);
                    return  _package;
                }
            }
        );
        
        return NEJ;
    }

    return _p;
});
I$('89e021bb13a7e256c6dba2bea646adb2',function (_p,_o,_f,_r){
    /**
     * 遍历对象
     * @param  {Object}   对象
     * @param  {Function} 迭代回调
     * @param  {Object}   回调执行对象
     * @return {String}   循环中断时的key值
     */
    _p.__forIn = function(_obj,_callback,_this){
        if (!_obj||!_callback){
            return null;
        }
        var _keys = Object.keys(_obj);
        for(var i=0,l=_keys.length,_key,_ret;i<l;i++){
            _key = _keys[i];
            _ret = _callback.call(
                _this||null,
                _obj[_key],_key,_obj
            );
            if (!!_ret){
                return _key;
            }
        }
        return null;
    };
    /**
     * 遍历列表
     * @param  {Array}    列表
     * @param  {Function} 迭代回调
     * @param  {Object}   回调执行对象
     * @return {Void}
     */
    _p.__forEach = function(_list,_callback,_this){
        _list.forEach(_callback,_this);
    };
    /**
     * 集合转数组
     * @param  {Object} 集合
     * @return {Array}  数组
     */
    _p.__col2array = function(_list){
        return _r.slice.call(_list,0);
    };
    /**
     * YYYY-MM-DDTHH:mm:ss.sssZ格式时间串转时间戳
     * @param  {String} 时间串
     * @return {Number} 时间戳
     */
    _p.__str2time = function(_str){
        return Date.parse(_str);
    };
    
    return _p;
});
I$('836fd3ea8c2cdd6a7842e1315a393abe',function (NEJ,_p,_o,_f,_r){
    var _platform  = this.navigator.platform,
        _useragent = this.navigator.userAgent;
    /**
     * 平台判断信息
     * 
     * ```javascript
     * NEJ.define([
     *     'base/platform'
     * ],function(_m){
     *     var _is = _m._$IS;
     *     // 是否MAC系统
     *     console.log(_is.mac);
     *     // 是否IPhone
     *     console.log(_is.iphone);
     *     // ...
     * });
     * ```
     * 
     * @const    module:base/platform._$IS
     * @see      module:base/platform._$is
     * @type     {Object}
     * @property {Boolean} mac     - 是否Mac系统
     * @property {Boolean} win     - 是否windows系统
     * @property {Boolean} linux   - 是否linux系统
     * @property {Boolean} ipad    - 是否Ipad
     * @property {Boolean} iphone  - 是否IPhone
     * @property {Boolean} android - 是否Android系统
     * @property {Boolean} ios     - 是否IOS系统
     * @property {Boolean} tablet  - 是否平板
     * @property {Boolean} desktop - 是否桌面系统
     */
    var _is = {
        mac     : _platform,
        win     : _platform,
        linux   : _platform,
        ipad    : _useragent,
        ipod    : _useragent,
        iphone  : _platform,
        android : _useragent
    };
    _p._$IS = _is;
    for(var x in _is){
        _is[x] = new RegExp(x,'i').test(_is[x]);
    }
    _is.ios = _is.ipad||_is.iphone||_is.ipod;
    _is.tablet = _is.ipad;
    _is.desktop = _is.mac||_is.win||(_is.linux&&!_is.android);
    /**
     * 判断是否指定平台
     * 
     * ```javascript
     * NEJ.define([
     *     'base/platform'
     * ],function(_m){
     *     // 是否MAC系统
     *     console.log(_m._$is('mac'));
     *     // 是否iphone
     *     console.log(_m._$is('iphone'));
     *     // ...
     * });
     * ```
     * 
     * @method module:base/platform._$is
     * @see    module:base/platform._$IS
     * @param  {String} arg0 - 平台名称
     * @return {Boolean}       是否指定平台
     */
    _p._$is = function(_platform){
        return !!_is[_platform];
    };
    // parse kernel information
    /**
     * 引擎内核信息
     * 
     * ```javascript
     * NEJ.define([
     *     'base/platform'
     * ],function(_m){
     *     var _kernel = _m._$KERNEL;
     *     // 打印平台信息
     *     console.log(_kernel.engine);
     *     console.log(_kernel.release);
     *     console.log(_kernel.browser);
     *     console.log(_kernel.version);
     * });
     * ```
     * 
     * @const    module:base/platform._$KERNEL
     * @type     {Object}
     * @property {String} engine  - 布局引擎，trident/webkit/gecko/presto...
     * @property {Number} release - 布局引擎版本
     * @property {String} browser - 浏览器名称，ie/chrome/safari/opera/firefox/maxthon...
     * @property {Number} version - 浏览器版本
     * @property {Object} prefix  - 平台前缀，html5/css3 attribute/method/constructor
     */
    var _kernel = {
        engine:'unknow',
        release:'unknow',
        browser:'unknow',
        version:'unknow',
        prefix:{css:'',pro:'',clz:''}
    };
    _p._$KERNEL  = _kernel;
    if (/msie\s+(.*?);/i.test(_useragent)||
        /trident\/.+rv:([\d\.]+)/i.test(_useragent)){
        _kernel.engine  = 'trident';
        _kernel.browser = 'ie';
        _kernel.version = RegExp.$1;
        _kernel.prefix  = {css:'ms',pro:'ms',clz:'MS',evt:'MS'};
        // 4.0-ie8 5.0-ie9 6.0-ie10 7.0-ie11
        // adjust by document mode setting in develop toolbar
        var _test = {6:'2.0',7:'3.0',8:'4.0',9:'5.0',10:'6.0',11:'7.0'};
        _kernel.release = _test[document.documentMode]||
                          _test[parseInt(_kernel.version)];
    }else if(/webkit\/?([\d.]+?)(?=\s|$)/i.test(_useragent)){
        _kernel.engine  = 'webkit';
        _kernel.release = RegExp.$1||'';
        _kernel.prefix  = {css:'webkit',pro:'webkit',clz:'WebKit'};
    }else if(/rv\:(.*?)\)\s+gecko\//i.test(_useragent)){
        _kernel.engine  = 'gecko';
        _kernel.release = RegExp.$1||'';
        _kernel.browser = 'firefox';
        _kernel.prefix  = {css:'Moz',pro:'moz',clz:'Moz'};
        if (/firefox\/(.*?)(?=\s|$)/i.test(_useragent))
            _kernel.version = RegExp.$1||'';
    }else if(/presto\/(.*?)\s/i.test(_useragent)){
        _kernel.engine  = 'presto';
        _kernel.release = RegExp.$1||'';
        _kernel.browser = 'opera';
        _kernel.prefix  = {css:'O',pro:'o',clz:'O'};
        if (/version\/(.*?)(?=\s|$)/i.test(_useragent))
            _kernel.version = RegExp.$1||'';
    }
    if (_kernel.browser=='unknow'){
        var _test = ['chrome','maxthon','safari'];
        for(var i=0,l=_test.length,_name;i<l;i++){
            _name = _test[i]=='safari'?'version':_test[i];
            if (new RegExp(_name+'/(.*?)(?=\\s|$)','i').test(_useragent)){
                _kernel.browser = _test[i];
                _kernel.version = RegExp.$1.trim();
                break;
            }
        }
    }
    /**
     * 引擎特性支持信息
     * 
     * ```javascript
     * NEJ.define([
     *     'base/platform'
     * ],function(_m){
     *     var _support = _m._$SUPPORT;
     *     // 打印平台是否支持CSS3 3D特效
     *     console.log(_support.css3d);
     * });
     * ```
     * @const    module:base/platform._$SUPPORT
     * @see      module:base/platform._$support
     * @type     {Object}
     * @property {Boolean} css3d  - 是否支持CSS3 3D
     */
    _p._$SUPPORT = {};
    /**
     * 判断平台是否支持指定特性
     * 
     * ```javascript
     * NEJ.define([
     *     'base/platform'
     * ],function(_m){
     *     // 是否支持CSS3 3D特效
     *     console.log(_m._$support('css3d'));
     * });
     * ```
     * 
     * @method module:base/platform._$support
     * @see    module:base/platform._$SUPPORT
     * @param  {String} arg0 - 特性标识
     * @return {Boolean}       是否支持指定特性
     */
    _p._$support = function(_feature){
        return !!_p._$SUPPORT[_feature];
    };
    
    if (CMPT){
        NEJ.copy(NEJ.P('nej.p'),_p);
    }
    
    return _p;
},'19c9fc0aab6a6b9db67f02f7d86454f4');
I$('51215da15c0ae87c65064f5ad7c3de94',function(_h,_m,_p,_o,_f,_r){if (_m._$KERNEL.engine==='trident'&&_m._$KERNEL.release<='4.0'){I$('2784fd70125d65a71cd800ffb7b9446d',function (){
        /**
         * 遍历对象
         * @param  {Object}   对象
         * @param  {Function} 迭代回调
         * @param  {Object}   回调执行对象
         * @return {String}   循环中断时的key值
         */
        _h.__forIn = function(_obj,_callback,_this){
            if (!_obj||!_callback){
                return;
            }
            // iterate
            var _ret;
            for(var x in _obj){
                if (!_obj.hasOwnProperty(x)) continue;
                _ret = _callback.call(_this,_obj[x],x,_obj);
                if (!!_ret){
                    return x;
                }
            }
        };
        /**
         * 遍历列表
         * @param  {Array}    列表
         * @param  {Function} 迭代回调
         * @param  {Object}   回调执行对象
         * @return {Void}
         */
        _h.__forEach = function(_list,_callback,_this){
            for(var i=0,l=_list.length;i<l;i++){
                _callback.call(_this,_list[i],i,_list);
            }
        };
        /**
         * 集合转数组
         * @param  {Object} 集合
         * @return {Array}  数组
         */
        _h.__col2array = function(_list){
            var _result = [];
            if (!!_list&&!!_list.length){
                for(var i=0,l=_list.length;i<l;i++){
                    _result.push(_list[i]);
                }
            }
            return _result;
        };
        /**
         * YYYY-MM-DDTHH:mm:ss.sssZ格式时间串转时间戳
         * @param  {String} 时间串
         * @return {Number} 时间戳
         */
        _h.__str2time = (function(){
            var _reg = /-/g;
            return function(_str){
                // only support YYYY/MM/DDTHH:mm:ss
                return Date.parse(_str.replace(_reg,'/').split('.')[0]);
            };
        })();
    });}return _h;},'89e021bb13a7e256c6dba2bea646adb2','836fd3ea8c2cdd6a7842e1315a393abe');
I$('3f115371e3e07e18707a0c434f8a73ce',function (NEJ,_h,_p,_o,_f,_r){
    /*
     * 查看数据是否指定类型
     * @param  {Variable} 数据
     * @param  {String}   类型
     * @return {Boolean}  是否指定类型
     */
    var _isTypeOf = function(_data,_type){
        try{
            _type = _type.toLowerCase();
            if (_data===null) return _type=='null';
            if (_data===undefined) return _type=='undefined';
            return _o.toString.call(_data).toLowerCase()=='[object '+_type+']';
        }catch(e){
            return !1;
        }
    };
    /**
     * 判断是否函数类型
     *
     * ```javascript
     * NEJ.define([
     *     'base/util'
     * ],function(_u){
     *     // 返回false
     *     var is = _u._$isFunction(123);
     *     // 返回true
     *     var is = _u._$isFunction(function(){});
     * });
     * ```
     *
     * @method module:base/util._$isFunction
     * @param  {Variable} arg0 - 待检测类型的数据
     * @return {Boolean}         是否函数类型
     */
    _p._$isFunction = function(_data){
        return _isTypeOf(_data,'function');
    };
    /**
     * 判断是否字符串
     *
     * ```javascript
     * NEJ.define([
     *     'base/util'
     * ],function(_u){
     *     // 返回false
     *     var is = _u._$isString(123);
     *     // 返回true
     *     var is = _u._$isString("123");
     * });
     * ```
     *
     * @method module:base/util._$isString
     * @param  {Variable} arg0 - 待检测类型的数据
     * @return {Boolean}         是否字符串
     */
    _p._$isString = function(_data){
        return _isTypeOf(_data,'string');
    };
    /**
     * 判断是否数字
     *
     * ```javascript
     * NEJ.define([
     *     'base/util'
     * ],function(_u){
     *     // 返回false
     *     var is = _u._$isNumber("123");
     *     // 返回true
     *     var is = _u._$isNumber(123);
     *     var is = _u._$isNumber(-123);
     *     var is = _u._$isNumber(Number.MAX_VALUE);
     * });
     * ```
     *
     * @method module:base/util._$isNumber
     * @param  {Variable} arg0 - 待检测类型的数据
     * @return {Boolean}         是否数值类型
     */
    _p._$isNumber = function(_data){
        return _isTypeOf(_data,'number');
    };
    /**
     * 判断是否布尔值
     *
     * ```javascript
     * NEJ.define([
     *     'base/util'
     * ],function(_u){
     *     // 返回false
     *     var is = _u._$isBoolean(0);
     *     // 返回true
     *     var is = _u._$isBoolean(false);
     * });
     * ```
     *
     * @method module:base/util._$isBoolean
     * @param  {Variable} arg0 - 待检测类型的数据
     * @return {Boolean}         是否布尔值
     */
    _p._$isBoolean = function(_data){
        return _isTypeOf(_data,'boolean');
    };
    /**
     * 判断是否日期
     *
     * ```javascript
     * NEJ.define([
     *     'base/util'
     * ],function(_u){
     *     // 返回false
     *     var is = _u._$isDate(0);
     *     // 返回true
     *     var is = _u._$isDate(new Date());
     * });
     * ```
     *
     * @method module:base/util._$isDate
     * @param  {Variable} arg0 - 待检测类型的数据
     * @return {Boolean}         是否日期
     */
    _p._$isDate = function(_data){
        return _isTypeOf(_data,'date');
    };
    /**
     * 判断是否数组
     *
     * ```javascript
     * NEJ.define([
     *     'base/util'
     * ],function(_u){
     *     // 返回false
     *     var is = _u._$isArray(0);
     *     // 返回true
     *     var is = _u._$isArray([1,2]);
     * });
     * ```
     *
     * @method module:base/util._$isArray
     * @param  {Variable} arg0 - 待检测类型的数据
     * @return {Boolean}         是否数组
     */
    _p._$isArray = function(_data){
        return _isTypeOf(_data,'array');
    };
    /**
     * 判断是否对象
     *
     * ```javascript
     * NEJ.define([
     *     'base/util'
     * ],function(_u){
     *     // 返回false
     *     var is = _u._$isObject(function(){});
     *     // 返回true
     *     var is = _u._$isObject({});
     *     var is = _u._$isObject({a:"a"});
     * });
     * ```
     *
     * @method module:base/util._$isObject
     * @param  {Variable} arg0 - 待检测类型的数据
     * @return {Boolean}         是否对象
     */
    _p._$isObject = function(_data){
        return _isTypeOf(_data,'object');
    };
    /**
     * 计算字符串长度，中文算两个字符
     *
     * ```javascript
     * NEJ.define([
     *     'base/util'
     * ],function(_u){
     *     // 字符串长度为5
     *     var len = _u._$length('你i他');
     * });
     * ```
     *
     * @method module:base/util._$length
     * @param  {String} arg0 - 待计算长度字符串
     * @return {Number}        字符串长度
     */
    _p._$length = (function(){
        var _reg = /[^\x00-\xff]/g;
        return function(_content){
            return (''+(_content||'')).replace(_reg,'**').length;
        };
    })();
    /**
     * 遍历对象
     * 
     * ```javascript
     * NEJ.define([
     *     'base/util'
     * ],function(_u){
     *       var obj = {a:{id:1,name:'a'},b:{id:2,name:'b'},...};
     * 
     *       // 遍历对象    
     *       _u._$loop(obj,function(_item,_key){
     *           // TODO
     *       });
     * 
     *       // 从对象里查找id为2的元素，如果有返回KEY，没有返回null
     *       var key = _u._$loop(obj,function(_item){
     *           return _item.id==2;
     *       });
     * });
     * ```
     * 
     * @method module:base/util._$loop
     * @see    module:base/util._$forIn
     * @param  {Object}   arg0 - 对象
     * @param  {Function} arg1 - 回调，如果返回true，则中断遍历
     * @param  {Object}   arg2 - 回调函数调用时this对象
     * @return {String}          返回中断时的标识，没有中断则统一返回null
     */
    _p._$loop = function(_obj,_callback,_this){
        if (_p._$isObject(_obj)&&
            _p._$isFunction(_callback)){
            return _h.__forIn.apply(_h,arguments);
        }
        return null;
    };
    /**
     * 线性查找指定项
     *
     * ```javascript
     * NEJ.define([
     *     'base/util'
     * ],function(_u){
     *     var list = ["你","我","他"];
     *     // 返回下标1
     *     var index = _u._$indexOf(list,"我");
     *     // 没有找到，返回-1
     *     var index = _u._$indexOf(list,"他们");
     *     // 如果第二个参数是过滤接口，根据接口的规则查找
     *     // 以下规则排除第一个下标
     *     var index = _u._$indexOf(list,function(_item,_index,_list){
     *           return _item==='他';
     *     });
     * });
     * ```
     *
     * @method module:base/util._$indexOf
     * @param  {Array}    arg0 - 待搜索列表
     * @param  {Variable} arg1 - 指定项，如果为function则表示过滤接口
     * @return {Number}          给定项所在的位置索引，以0开始，没有项返回-1
     */
    _p._$indexOf = function(_list,_item){
        var _filter = _p._$isFunction(_item) ? _item
                    : function(_value){return _value===_item;},
            _index  = _p._$forIn(_list,_filter);
        return _index!=null?_index:-1;
    };
    /**
     * 二分法查找指定项
     * 
     * 验证函数输入输出说明
     * 
     * |      | 类型          | 结果说明 |
     * | :--  | :--      | :-- |
     * | 输入  | Variable | 中间项元素 |
     * | 输出  | Number   | < 0  目标元素在低位区间 |
     * |      |          | = 0  匹配到目标元素 |
     * |      |          | > 0  目标元素在高位区间 |
     *
     * ```javascript
     * NEJ.define([
     *     'base/util'
     * ],function(_u){
     *     // 二分查找id为2的项的索引值
     *     var list = [{id:1,name:'aaa'},{id:2,name:'bbbb'},...];
     *     var index = _u._$binSearch(list,function(_item){
     *         return _item.id-2;
     *     });
     * });
     * ```
     *
     * @method module:base/util._$binSearch
     * @param  {Array}    arg0 - 待查找列表
     * @param  {Function} arg1 - 验证函数
     * @return {Number}          找到匹配项索引，找不到返回-1
     */
    _p._$binSearch = (function(){
        var _docheck;
        // do binary search
        var _doSearch = function(_list,_low,_high){
            if (_low>_high) return -1;
            var _middle = Math.ceil((_low+_high)/2),
                _result = _docheck(_list[_middle],_middle,_list);
            if (_result==0)
                return _middle;
            if (_result<0)
                return _doSearch(_list,_low,_middle-1);
            return _doSearch(_list,_middle+1,_high);
        };
        return function(_list,_check){
            _docheck = _check||_f;
            return _doSearch(_list,0,_list.length-1);
        };
    })();
    /**
     * 逆序遍历列表，支持中断
     * 
     * 回调函数输入输出说明
     * 
     * |      | 类型          | 说明 |
     * | :--  | :--      | :-- |
     * | 输入  | Variable | 值 |
     * |      | Number   | 下标 |
     * |      | Array    | 列表对象 |
     * | 输出  | Boolean  | 是否匹配 |
     * 
     * ```javascript
     * NEJ.define([
     *     'base/util'
     * ],function(_u){
     *     // 删除id为3的项，并退出循环
     *     var list = [{id:1,name:'aaa'},{id:2,name:'bbbb'},...];
     *     _u._$reverseEach(list,function(_item,_index,_list){
     *         if (_item.id==3){
     *             _list.splice(_index,1);
     *             return !0;
     *         }
     *     });
     * });
     * ```
     *
     * @method module:base/util._$reverseEach
     * @see    module:base/util._$forEach
     * @param  {Array}    arg0 - 列表
     * @param  {Function} arg1 - 回调，如果返回true，则中断遍历
     * @param  {Object}   arg2 - 回调函数调用时this对象
     * @return {Number}          返回遍历中断时的索引值，没有中断则返回null
     */
    _p._$reverseEach = function(_list,_callback,_this){
        if (!!_list&&!!_list.length&&_p._$isFunction(_callback)){
            for(var i=_list.length-1;i>=0;i--){
                if (!!_callback.call(_this,_list[i],i,_list)){
                    return i;
                }
            }
        }
        return null;
    };
    /**
     * 正序遍历列表，不支持中断
     * 
     * 回调函数输入输出说明
     * 
     * |      | 类型          | 说明 |
     * | :--  | :--      | :-- |
     * | 输入  | Variable | 值 |
     * |      | Number   | 下标 |
     * |      | Array    | 列表对象 |
     * | 输出  | Boolean  | 是否匹配 |
     * 
     * ```javascript
     * NEJ.define([
     *     'base/util'
     * ],function(_u){
     *     var list = [1,2,3];
     *     _u._$forEach(list,function(_item,_index,_list){
     *         // TODO somthing
     *     });
     * });
     * ```
     *
     * @method module:base/util._$forEach
     * @see    module:base/util._$reverseEach
     * @param  {Array}    arg0 - 列表
     * @param  {Function} arg1 - 回调，如果返回true，则中断遍历
     * @param  {Object}   arg2 - 回调函数调用时this对象
     * @return {Void}
     */
    _p._$forEach = function(_list,_callback,_this){
        if (!!_list&&!!_list.length&&
            _p._$isFunction(_callback)){
            if (!_list.forEach){
                _p._$forIn.apply(_p,arguments);
            }else{
                _h.__forEach(_list,_callback,_this);
            }
        }
    };
    /**
     * 遍历列表或对象，如果带length属性，则作为数组遍历，如果要遍历带length属性的对象用_$loop接口，支持中断退出
     *
     * 回调函数输入输出说明
     * 
     * |      | 类型          | 说明 |
     * | :--  | :--      | :-- |
     * | 输入  | Variable | 值 |
     * |      | Number   | 下标 |
     * |      | Object_Array | 列表或者集合对象 |
     * | 输出  | Boolean  | 是否匹配 |
     * 
     * ```javascript
     * NEJ.define([
     *     'base/util'
     * ],function(_u){
     *       // 从有序列表里查找id为2的元素，如果有则返回索引，没有返回null
     *       var list = [{id:1,name:'a'},{id:2,name:'b'},...];
     *       var index = _u._$forIn(list,function(_item){
     *           return _item.id==2;
     *       });
     *
     *       // 从对象里查找id为2的元素，如果有返回KEY，没有返回null
     *       var obj = {a:{id:1,name:'a'},b:{id:2,name:'b'},...};
     *       var key = _u._$forIn(obj,function(_item){
     *           return _item.id==2;
     *       });
     * });
     * ```
     *
     * @method module:base/util._$forIn
     * @param  {Object|Array} arg0 - 列表或者对象
     * @param  {Function}     arg1 - 回调，如果返回true，则中断遍历
     * @param  {Object}       arg2 - 回调函数调用时this对象
     * @return {String|Number}       返回中断时的索引或者标识，没有中断则统一返回null
     */
    _p._$forIn = function(_list,_callback,_this){
        if (!_list||!_p._$isFunction(_callback)){
            return null;
        }
        if (_p._$isNumber(_list.length)){
            // list see as array
            for(var i=0,l=_list.length;i<l;i++){
                if (!!_callback.call(_this,_list[i],i,_list)){
                    return i;
                }
            }
        }else if (_p._$isObject(_list)){
            // list is object
            return _p._$loop(_list,_callback,_this);
        }
        return null;
    };
    /**
     * 编码字符串，
     * 编码规则对象中r正则表达式参数提取字符串需要编码的内容，
     * 然后使用编码规则对象中的映射表进行替换
     *
     * ```javascript
     * NEJ.define([
     *     'base/util'
     * ],function(_u){
     *     // 把字符串99999根据规则9替换成t，结果：ttttt
     *     var str = _u._$encode({r:/\d/g,'9':'t'},'99999');
     * });
     * ```
     *
     * @method module:base/util._$encode
     * @param  {Object} arg0 - 编码规则
     * @param  {String} arg1 - 待编码的字串
     * @return {String}        编码后的字串
     */
    _p._$encode = function(_map,_content){
        _content = ''+_content;
        if (!_map||!_content){
            return _content||'';
        }
        return _content.replace(_map.r,function($1){
            var _result = _map[!_map.i?$1.toLowerCase():$1];
            return _result!=null?_result:$1;
        });
    };
    /**
     * 编码html代码，'<' -> '&amp;lt;'
     *
     * ```javascript
     * NEJ.define([
     *     'base/util'
     * ],function(_u){
     *     // 编码，结果：&amp;lt;a&amp;gt;util&amp;lt;/a&amp;gt;&amp;amp;
     *     var str = _u._$escape('<a>util</a>&');
     * });
     * ```
     *
     * @method module:base/util._$escape
     * @see    module:base/util._$unescape
     * @param  {String} arg0 - 待编码串
     * @return {String}        编码后的串
     */
    _p._$escape = (function(){
        var _reg = /<br\/?>$/,
            _map = {
                r:/\<|\>|\&|\r|\n|\s|\'|\"/g,
                '<':'&lt;','>':'&gt;','&':'&amp;',' ':'&nbsp;',
                '"':'&quot;',"'":'&#39;','\n':'<br/>','\r':''
            };
        return function(_content){
            _content = _p._$encode(_map,_content);
            return _content.replace(_reg,'<br/><br/>');
        };
    })();
    /**
     * 反编码html代码，'&amp;lt;' -> '<' 
     *
     * ```javascript
     * NEJ.define([
     *     'base/util'
     * ],function(_u){
     *     // 反编码，结果：<&a>util</a>
     *     var str = _u._$unescape('&amp;lt;&amp;amp;a&amp;gt;util&amp;lt;/a&amp;gt;');
     * });
     * ```
     *
     * @method module:base/util._$unescape
     * @see    module:base/util._$escape
     * @param  {String} arg0 - 待反编码串
     * @return {String}        反编码后的串
     */
    _p._$unescape = (function(){
        var _map = {r:/\&(?:lt|gt|amp|nbsp|#39|quot)\;|\<br\/\>/gi,'&lt;':'<','&gt;':'>','&amp;':'&','&nbsp;':' ','&#39;':"'",'&quot;':'"','<br/>':'\n'};
        return function(_content){
            return _p._$encode(_map,_content);
        };
    })();
    /**
     * 格式化时间，yyyy|yy|MM|cM|eM|M|dd|d|HH|H|mm|ms|ss|m|s|w
     *
     * 各标识说明：
     * 
     * | 标识  | 说明 |
     * | :--  | :-- |
     * | yyyy | 四位年份，如2001 |
     * | yy   | 两位年费，如01 |
     * | MM   | 两位月份，如08 |
     * | M    | 一位月份，如8 |
     * | dd   | 两位日期，如09 |
     * | d    | 一位日期，如9 |
     * | HH   | 两位小时，如07 |
     * | H    | 一位小时，如7 |
     * | mm   | 两位分钟，如03 |
     * | m    | 一位分钟，如3 |
     * | ss   | 两位秒数，如09 |
     * | s    | 一位秒数，如9 |
     * | ms   | 毫秒数，如234 |
     * | w    | 中文星期几，如一 |
     * | ct   | 12小时制中文后缀，上午/下午 |
     * | et   | 12小时制英文后缀，A.M./P.M. |
     * | cM   | 中文月份，如三 |
     * | eM   | 英文月份，如Mar |
     *
     * ```javascript
     * NEJ.define([
     *     'base/util'
     * ],function(_u){
     *     // 根据格式输出时间，比如:2012-01-11,连接符可自定义
     *     var str = _u._$format(new Date(),'yyyy-MM-dd');
     * });
     * ```
     *
     * @method module:base/util._$format
     * @param  {Number|String|Date} arg0 - 时间
     * @param  {String}             arg1 - 格式
     * @return {String}                    指定格式的时间串
     */
    _p._$format = (function(){
        var _map = {i:!0,r:/\byyyy|yy|MM|cM|eM|M|dd|d|HH|H|mm|ms|ss|m|s|w|ct|et\b/g},
            _12cc = ['上午','下午'],
            _12ec = ['A.M.','P.M.'],
            _week = ['日','一','二','三','四','五','六'],
            _cmon = ['一','二','三','四','五','六','七','八','九','十','十一','十二'],
            _emon = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sept','Oct','Nov','Dec'];
        var _fmtnmb = function(_number){
            _number = parseInt(_number)||0;
            return (_number<10?'0':'')+_number;
        };
        var _fmtclc = function(_hour){
            return _hour<12?0:1;
        };
        return function(_time,_format,_12time){
            if (!_time||!_format)
                return '';
            _time = _p._$var2date(_time);
            _map.yyyy = _time.getFullYear();
            _map.yy   = (''+_map.yyyy).substr(2);
            _map.M    = _time.getMonth()+1;
            _map.MM   = _fmtnmb(_map.M);
            _map.eM   = _emon[_map.M-1];
            _map.cM   = _cmon[_map.M-1];
            _map.d    = _time.getDate();
            _map.dd   = _fmtnmb(_map.d);
            _map.H    = _time.getHours();
            _map.HH   = _fmtnmb(_map.H);
            _map.m    = _time.getMinutes();
            _map.mm   = _fmtnmb(_map.m);
            _map.s    = _time.getSeconds();
            _map.ss   = _fmtnmb(_map.s);
            _map.ms   = _time.getMilliseconds();
            _map.w    = _week[_time.getDay()];
            var _cc   = _fmtclc(_map.H);
            _map.ct   = _12cc[_cc];
            _map.et   = _12ec[_cc];
            if (!!_12time){
                _map.H = _map.H%12;
            }
            return _p._$encode(_map,_format);
        };
    })();
    /**
     * 日期字符串转日期对象
     * 
     * 字符串日期格式同ECMA规范定义：YYYY-MM-DDTHH:mm:ss.sssZ
     * 
     * 各标识说明：
     * 
     * | 标识 | 说明 |
     * | :--  | :-- |
     * | YYYY | 四位年份，0000-9999，如2001 |
     * | -    | 年月日分隔符 |
     * | MM   | 两位月份，01-12，如03 |
     * | DD   | 两位日期，01-31，如07 |
     * | T    | 时间起始标识 |
     * | HH   | 两位小时，00-24，如05 |
     * | :    | 时分秒分隔符 |
     * | mm   | 两位分钟，00-59，如30 |
     * | ss   | 两位秒数，00-59，如08 |
     * | .    | 秒/毫秒分隔符 |
     * | sss  | 三位毫秒数，000-999，如004 |
     * | Z    | 时区偏移 |
     *
     * ```javascript
     * NEJ.define([
     *     'base/util'
     * ],function(_u){
     *     // 输入YYYY-MM-DDTHH:mm:ss.sssZ格式字符串，生成日期对象
     *     var date = _u._$var2date('2013-07-29T13:12:45.300');
     *
     *     // 输入YYYY-MM-DDTHH:mm:ss格式字符串，生成日期对象
     *     var date = _u._$var2date('2013-07-29T13:12:45');
     *
     *     // 输入YYYY-MM-DD格式字符串，生成日期对象
     *     var date = _u._$var2date('2013-07-29');
     * });
     * ```
     *
     * @method module:base/util._$var2date
     * @param  {String} arg0 - 日期串
     * @return {Date}          日期对象
     */
    _p._$var2date = function(_time){
        var _date = _time;
        if (_p._$isString(_time)){
            _date = new Date(
                _h.__str2time(_time)
            );
        }
        if (!_p._$isDate(_date)){
            _date = new Date(_time);
        }
        return _date;
    };
    /**
     * 浮点数值保留指定位数小数点
     *
     * ```javascript
     * NEJ.define([
     *     'base/util'
     * ],function(_u){
     *     // 保留2位小数，返回3.14
     *     var value = _u._$fixed(3.14159,2);
     * });
     * ```
     *
     * @method module:base/util._$fixed
     * @param  {Float}  arg0 - 浮点数
     * @param  {Number} arg1 - 小数位
     * @return {Number}        浮点数
     */
    _p._$fixed = function(_float,_fraction){
        return parseFloat(new Number(_float).toFixed(_fraction));
    };
    /**
     * 相对路径转绝对路径
     *
     * ```javascript
     * NEJ.define([
     *     'base/util'
     * ],function(_u){
     *     // 相对路径../a/b.html转绝对路径http://a.b.com:8010/a/b.html
     *     var url = _u._$absolute(
     *         '../a/b.html',
     *         'http://a.b.com:8010/z/'
     *     );
     * });
     * ```
     * 
     * @method module:base/util._$absolute
     * @param  {String} arg0 - 相对路径
     * @param  {String} arg1 - 绝对路径ROOT，必须以http://开始，默认为location目录
     * @return {String}        绝对路径地址
     */
    _p._$absolute = (function(){
        var _reg0 = /([^\/:])\/.*$/,
            _reg1 = /\/[^\/]+$/,
            _reg2 = /[#\?]/,
            _base = location.href.split(/[?#]/)[0],
            _anchor = document.createElement('a');
        var _isAbsolute = function(_uri){
            return (_uri||'').indexOf('://')>0;
        };
        var _doFormat = function(_uri){
            return (_uri||'').split(_reg2)[0]
                             .replace(_reg1,'/');
        };
        var _doMergeURI = function(_uri,_root){
            // for /a/b/c
            if (_uri.indexOf('/')==0)
                return _root.replace(_reg0,'$1')+_uri;
            // for a/b or ./a/b or ../a/b
            return _doFormat(_root)+_uri;
        };
        _base = _doFormat(_base);
        return function(_uri,_root){
            _uri = (_uri||'').trim();
            if (!_isAbsolute(_root))
                _root = _base;
            if (!_uri) return _root;
            if (_isAbsolute(_uri))
                return _uri;
            _uri = _doMergeURI(_uri,_root);
            _anchor.href = _uri;
            _uri = _anchor.href;
            return _isAbsolute(_uri) ? _uri :
                   _anchor.getAttribute('href',4); // ie6/7
        };
    })();
    /**
     * 从URL地址中提取源信息
     * 
     * * http://a.b.com:8080/a/b/ -> http://a.b.com:8080
     * * /a/b -> 
     *
     * ```javascript
     * NEJ.define([
     *     'base/util'
     * ],function(_u){
     *     // 提取url地址的源信息
     *     // 返回http://a.b.com:8080
     *     var origin = _u._$url2origin("http://a.b.com:8080/a/b/");
     * });
     * ```
     *
     * @method module:base/util._$url2origin
     * @param  {String} arg0 - URL地址
     * @return {String}        源信息
     */
    _p._$url2origin = (function(){
        var _reg = /^([\w]+?:\/\/.*?(?=\/|$))/i;
        return function(_url){
            if (_reg.test(_url||''))
                return RegExp.$1.toLowerCase();
            return '';
        };
    })();
    /**
     * key-value字符串转对象
     *
     * ```javascript
     * NEJ.define([
     *     'base/util'
     * ],function(_u){
     *     var str = "abc=abc,123=123";
     *     // 返回对象{abc:"abc",123:"123"}
     *     var obj = _u._$string2object(_str,",");
     * });
     * ```
     *
     * @method module:base/util._$string2object
     * @see    module:base/util._$object2string
     * @param  {String}           arg0 - 待处理数据
     * @param  {String|RegExp}    arg1 - 分隔符
     * @param  {Boolean|Function} arg2 - 是否反编码
     * @return {Object}           转换后对象
     */
    _p._$string2object = function(_string,_split,_decode){
        var _obj = {};
        // decode function
        var _func = _decode;
        if (!_p._$isFunction(_func)){
            _func = function(v){
                return !_decode?v:decodeURIComponent(v);
            };
        }
        // parse string
        _p._$forEach(
            (_string||'').split(_split),
            function(_name){
                var _brr = _name.split('=');
                if (!_brr||!_brr.length) return;
                var _key = _brr.shift();
                if (!!_key){
                    _obj[_func(_key)] = _func(_brr.join('='));
                }
            }
        );
        return _obj;
    };
    /**
     * key-value对象转成key=value对后用分隔符join
     * 
     * 对象中不同类型的取值规则如下：
     * 
     * | 类型            |  取值规则 |
     * | :--       | :-- |
     * | Function  |  过滤掉，不输出 |
     * | Date      |  转成时间戳，getTime取值 |
     * | Array     |  值用逗号分隔，如[1,2,3] -> 1,2,3 |
     * | Object    |  使用JSON转成字符串 |
     *
     * ```javascript
     * NEJ.define([
     *     'base/util'
     * ],function(_u){
     *     // 返回字符串 abc=abc,123=123
     *     var obj = {
     *         abc:"abc",
     *         123:"123"
     *     };
     *     var str = _u._$object2string(obj);
     *
     *     // 返回字符串
     *     // a=1871406603152186&b=1,2,3&d={"a":"a","b":"b"}&e=e&f=1&g=true
     *     var obj = {
     *         a:new Date,
     *         b:[1,2,3],
     *         c:function(){},
     *         d:{a:'a',b:'b'},
     *         e:'e',
     *         f:1,
     *         g:true
     *     };
     *     var str = _u._$object2string(obj,'&');
     * });
     * ```
     *
     * @method module:base/util._$object2string
     * @see    module:base/util._$string2object
     * @param  {Object}  arg0 - 对象
     * @param  {String}  arg1 - 分隔符，默认为逗号
     * @param  {Boolean|Function} arg2 - 是否编码
     * @return {String}         key-value串
     */
    _p._$object2string = function(_object,_split,_encode){
        if (!_object) return '';
        var _arr = [];
        // encode function
        var _func = _encode;
        if (!_p._$isFunction(_func)){
            _func = function(v){
                return !_encode?v:encodeURIComponent(v);
            };
        }
        // parse object
        _p._$loop(
            _object,function(_value,_key){
                if (_p._$isFunction(_value)){
                    return;
                }
                if (_p._$isDate(_value)){
                    _value = _value.getTime();
                }else if(_p._$isArray(_value)){
                    _value = _value.join(',');
                }else if(_p._$isObject(_value)){
                    _value = JSON.stringify(_value);
                }
                _arr.push(_func(_key)+'='+_func(_value));
            }
        );
        return _arr.join(_split||',');
    };
    /**
     * 查询串转对象
     *
     * ```javascript
     * NEJ.define([
     *     'base/util'
     * ],function(_u){
     *     // 返回对象{abc:"abc",123:"123"}
     *     var obj = _u._$query2object("abc=abc&123=123");
     * });
     * ```
     *
     * @method module:base/util._$query2object
     * @see    module:base/util._$object2query
     * @see    module:base/util._$string2object
     * @param  {String} arg0 - 查询串
     * @return {Object}        转换出来的对象
     */
    _p._$query2object = function(_query){
        return _p._$string2object(_query,'&',!0);
    };
    /**
     * 对象转查询串
     *
     * ```javascript
     * NEJ.define([
     *     'base/util'
     * ],function(_u){
     *     // 返回对象123=123&abc=abc
     *     var query = _u._$object2query({abc:"abc",123:"123"});
     * });
     * ```
     *
     * @method module:base/util._$object2query
     * @see    module:base/util._$query2object
     * @see    module:base/util._$object2string
     * @param  {Object} arg0 - 对象
     * @return {String}        查询串
     */
    _p._$object2query = function(_object){
        return _p._$object2string(_object,'&',!0);
    };
    /**
     * 集合转数组，集合具有length属性
     *
     * ```javascript
     * NEJ.define([
     *     'base/util'
     * ],function(_u){
     *     // 返回数组['1','2','3']
     *     var map = {0:'0',1:'1',2:'2',length:3};
     *     var arr = _u._$object2array(map);
     *
     *     // 多用于对节点集合的转换
     *     var nodes = document.body.childNodes;
     *     var arr = _u._$object2array(nodes);
     * });
     * ```
     *
     * @method module:base/util._$object2array
     * @see    module:base/util._$array2object
     * @param  {Object} arg0 - 集合，必须有length属性
     * @return {Array}         数组
     */
    _p._$object2array = function(_object){
        return _h.__col2array(_object);
    };
    /**
     * 数组转对象，将列表中元素按照指定KEY组成对象<br/>
     *
     * ```javascript
     * NEJ.define([
     *     'base/util'
     * ],function(_u){
     *     // 输出结果为 {2:{id:2,name:'b'},...}
     *     var arr = [{id:1,name:'a'},{id:2,name:'b'},...];
     *     var obj = _u._$array2object(
     *         arr,function(_item){
     *             // 过滤name为a的项
     *             if (_item.name=='a'){
     *                 return;
     *             }
     *             // 组对象的KEY用每项的id
     *             return _item.id;
     *         }
     *     );
     *
     *     // 默认使用每项的值组对象
     *     var brr = ['a','b','c',...];
     *     // 输出 {a:'a',b:'b',c:'c',...}
     *     var obj = _u._$array2object(brr);
     * });
     * ```
     *
     * @method module:base/util._$array2object
     * @see    module:base/util._$object2array
     * @param  {Array}    arg0 - 列表
     * @param  {Function} arg1 - 过滤函数，返回每一项的KEY，没有返回则过滤当前项
     * @return {Object}   对象
     */
    _p._$array2object = function(_list,_filter){
        var _result = {};
        _p._$forEach(
            _list,function(_item){
                var _key = _item;
                if (!!_filter){
                    _key = _filter(_item);
                }
                if (_key!=null){
                    _result[_key] = _item;
                }
            }
        );
        return _result;
    };
    /**
     * 格式化数字为指定位数，不足位数前面用0补足
     *
     * ```javascript
     * NEJ.define([
     *     'base/util'
     * ],function(_u){
     *     // 2    -> 002
     *     // 22   -> 022
     *     // 222  -> 222
     *     // 2222 -> 2222
     *     var str = _u._$number2string(2,3);
     * });
     * ```
     *
     * @method module:base/util._$number2string
     * @param  {Number} arg0 - 数值
     * @param  {Number} arg1 - 位数，至少1位
     * @return {String}        格式化后字符串
     */
    _p._$number2string = function(_number,_limit){
        var _len1 = (''+_number).length,
            _len2 = Math.max(1,parseInt(_limit)||0),
            _delta = _len2-_len1;
        if (_delta>0){
            _number = new Array(_delta+1).join('0')+_number;
        }
        return ''+_number;
    };
    /**
     * 安全删除属性，
     * 部分浏览器（如低版本IE）禁止直接delete节点上的属性
     *
     * ```javascript
     * NEJ.define([
     *     'base/util'
     * ],function(_u){
     *     // 节点上保存的数据
     *     _node.data = {a:'aaaaa',b:'bbbbb'};
     *     _node.test = 'aaaaa';
     *
     *     // 删除单个属性
     *     _u._$safeDelete(_node,'test');
     *     // 批量删除
     *     _u._$safeDelete(_node,['test','data']);
     * });
     * ```
     *
     * @method module:base/util._$safeDelete
     * @param  {Object}       arg0 - 对象
     * @param  {String|Array} arg1 - 属性
     * @return {Void}
     */
    _p._$safeDelete = function(_object,_name){
        if (!_p._$isArray(_name)){
            try{
                delete _object[_name];
            }catch(e){
                _object[_name] = undefined;
            }
        }else{
            _p._$forEach(
                _name,function(_item){
                    _p._$safeDelete(_object,_item);
                }
            );
        }
    };
    /**
     * 随机一个字符串
     *
     * ```javascript
     * NEJ.define([
     *     'base/util'
     * ],function(_u){
     *     // 可能返回"13d1r1dt2"
     *     var seed = _u._$randString(9);
     * });
     * ```
     *
     * @method module:base/util._$randString
     * @param  {String} arg0 - 字符串长度
     * @return {String}        随机字符串
     */
    _p._$randString = (function(){
        var _chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz';
        return function(_length){
            _length = _length||10;
            var _result = [];
            for(var i=0,_rnum;i<_length;++i){
                _rnum = Math.floor(Math.random()*_chars.length);
                _result.push(_chars.charAt(_rnum));
            }
            return _result.join('');
        };
    })();
    /**
     * 随机生成一个给定范围的整数
     *
     * ```javascript
     * NEJ.define([
     *     'base/util'
     * ],function(_u){
     *     // 可能返回3
     *     var seed = _u._$randNumber(0,9);
     * });
     * ```
     * 
     * @method module:base/util._$randNumber
     * @see    module:base/util._$randNumberString
     * @param  {Number} arg0 - 小区间，包含
     * @param  {Number} arg1 - 大区间，不包含
     * @return {Number}        随机整数
     */
    _p._$randNumber = function(_min,_max){
        return Math.floor(Math.random()*(_max-_min)+_min);
    };
    /**
     * 随机生成一个全部为数字的字符串
     *
     * ```javascript
     * NEJ.define([
     *     'base/util'
     * ],function(_u){
     *     // 可能返回123456789
     *     var seed = _u._$randNumberString(9);
     * });
     * ```
     *
     * @deprecated
     * @method module:base/util._$randNumberString
     * @see    module:base/util._$randNumber
     * @see    module:base/util._$uniqueID
     * @param  {Number} arg0 - 随机字符串的长度[1,30]
     * @return {String}        随机生成的字符串
     */
    _p._$randNumberString = function(_length){
        _length = Math.max(0,Math.min(_length||8,30));
        var _min = Math.pow(10,_length-1),_max = _min*10;
        return _p._$randNumber(_min,_max).toString();
    };
    /**
     * 生成系统中的唯一标识，每次调用均生成一个新的标识
     *
     * ```javascript
     * NEJ.define([
     *     'base/util'
     * ],function(_p){
     *    // 可能返回123456789
     *    var _id1 = _p._$uniqueID(),
     *        _id2 = _p._$uniqueID();
     *    // _id1 != _id2
     * });
     * ```
     *
     * @method module:base/util._$uniqueID
     * @return {String} 唯一标识
     */
    _p._$uniqueID = (function(){
        var _seed = +new Date;
        return function(){
            return ''+(_seed++);
        };
    })();
    /**
     * 读取上下文中指定名字空间的值
     *
     * ```javascript
     * NEJ.define([
     *     'base/util'
     * ],function(_u){
     *     var obj = {
     *         a:{
     *             b:{
     *                 c:{
     *                     d:'ddddd'
     *                 }
     *             }
     *         }
     *     };
     *     // 输出 ddddd
     *     var value = _u._$query(obj,'a.b.c.d');
     *     // 输出 undefined
     *     var value = _u._$query(null,'a.b.c.d');
     * });
     * ```
     *
     * @method module:base/util._$query
     * @param  {Object} arg0 - 上下文
     * @param  {String} arg1 - 名字空间
     * @return {Varaible}      查询到的值
     */
    _p._$query = function(_context,_namespace){
        _context = _context||_o;
        var _arr = (_namespace||'').split('.');
        for(var i=0,l=_arr.length;i<l;i++){
            _context = _context[_arr[i]];
            if (!_context) break;
        }
        return _context;
    };
    /**
     * 合并数据，同名属性右侧覆盖左侧，
     * 最后一个如果是函数则用做数据过滤，
     * 第一个参数作为合并数据结果集对象，如果为空则新建对象
     * 
     * 过滤接口输入输出说明
     * 
     * |      | 类型          | 说明 |
     * | :--  | :--      | :-- |
     * | 输入  | Variable | 值 |
     * |      | String   | 键 |
     * | 输出  | Boolean  | 是否过滤 |
     * 
     * ```javascript
     * NEJ.define([
     *     'base/util'
     * ],function(_u){
     *     // 合并多个数据至obj0中
     *     var obj0 = {a:0,b:1},
     *         obj1 = {a:"a",b:"b",c:"c"},
     *         obj2 = {c:"c",d:"d",e:"f"},
     *         ... ;
     *     var obj = _u._$merge(obj0,obj1,obj2,...);
     *
     *     // 带过滤接口合并
     *     // 阻止a属性的覆盖
     *     var obj = _u._$merge(
     *         obj0,obj1,obj2,...,
     *         function(_value,_key){
     *             return _key=='a';
     *         }
     *     );
     * });
     * ```
     *
     * @method module:base/util._$merge
     * @see    module:base/util._$fetch
     * @param  {Object}   arg0 - 原始对象
     * @param  {Object}   arg1 - 待拷贝对象
     * @param  {Function} arg2 - 过滤接口
     * @return {Object}          拷贝后对象
     */
    _p._$merge = function(){
        var _last = arguments.length-1,
            _filter = arguments[_last];
        // check filter function for last args
        if (_p._$isFunction(_filter)){
            _last -= 1;
        }else{
            _filter = _f;
        }
        // args0 as result
        var _result = arguments[0]||{};
        // merge
        for(var i=1;i<=_last;i++){
            _p._$loop(arguments[i],function(v,k){
                if (!_filter(v,k)){
                    _result[k] = v;
                }
            });
        }
        return _result;
    };
    /**
     * 根据原始对象属性，从目标对象提取非空值
     *
     * ```javascript
     * NEJ.define([
     *     'base/util'
     * ],function(_u){
     *     var obj0 = {a:0,b:1},
     *         obj1 = {a:"a",b:"b",c:"c"};
     *     // 根据obj0的属性,从obj1拷贝非null属性到obj0中
     *     // 结果是obj0.a = "a",obj.b = "b",没有拷贝c属性;
     *     var obj = _u._$fetch(obj0,obj1);
     * });
     * ```
     *
     * @method module:base/util._$fetch
     * @see    module:base/util._$merge
     * @param  {Object} arg0 - 原始对象
     * @param  {Object} arg1 - 目标对象
     * @return {Object}        合并后的对象
     */
    _p._$fetch = function(_object,_config){
        if (!!_config){
            _p._$loop(_object,function(v,k,m){
                var _value = _config[k];
                if (_value!=null){
                    m[k] = _value;
                }
            });
        }
        return _object;
    };
    /**
     * 判断对象自生是否包含元素
     * 
     * ```javascript
     * NEJ.define([
     *     'base/util'
     * ],function(_u){
     *     // 判断空对象是否有属性
     *     // 输出 false
     *     var has = _u._$hasProperty({});
     *       
     *     // 判断非空对象是否有属性
     *     // 输出 true
     *     var has = _u._$hasProperty({a:'a',b:'b',c:'c'});
     *       
     *     // 判断空数组是否有属性
     *     // 输出 false
     *     var has = _u._$hasProperty([]);
     *       
     *     // 判断非空数组是否有属性
     *     // 输出 true
     *     var has = _u._$hasProperty([1,2,3]);
     * });
     * ```
     * 
     * @method module:base/util._$hasProperty
     * @param  {Object|Array} arg0 - 对象
     * @return {Boolean}             是否有元素
     */
    _p._$hasProperty = function(_obj){
        // for null
        if (!_obj){
            return !1;
        }
        // for object with length
        if (_obj.length!=null){
            return _obj.length>0;
        }
        // for object
        var _length = 0;
        _p._$loop(_obj,function(){
            _length++;
            return _length>0;
        });
        return _length>0;
    };
    
    if (CMPT){
        NEJ.Q  = _p._$query;
        NEJ.X  = _p._$merge;
        NEJ.EX = _p._$fetch;
        NEJ.copy(this.NEJ,NEJ);
        NEJ.copy(NEJ.P('nej.u'),_p);
    }

    return _p;
},'19c9fc0aab6a6b9db67f02f7d86454f4','51215da15c0ae87c65064f5ad7c3de94');
I$('f82595aeedc5254355e7112328302ad1',function (NEJ,_u,_p,_o,_f,_r){
    var _cache = {};
    /*
     * URL地址转源信息
     * http://a.b.com:8080/a/bc/ -> http://a.b.com:8080
     * @param  {String} URL地址
     * @return {String} 源信息
     */
    _p.__url2host = (function(){
        var _reg = /^([\w]+?:\/\/.*?(?=\/|$))/i;
        return function(_url){
            _url = _url||'';
            if (_reg.test(_url))
                return RegExp.$1;
            return location.protocol+'//'+location.host;
        };
    })();
    /**
     * 设置NEJ配置信息
     * @param  {String}   配置标识
     * @param  {Variable} 配置信息
     * @return {Void}
     */
    _p.__set = function(_key,_value){
        _cache[_key] = _value;
    };
    /**
     * 获取NEJ配置信息
     * @param  {String}   配置标识
     * @return {Variable} 配置信息
     */
    _p.__get = function(_key){
        return _cache[_key];
    };

    // init
    /*
     * 初始化配置信息
     * @param  {Object} 配置信息
     * @return {Void}
     */
    var _doInit = (function(){
        var _conf = {
            'portrait':{name:'portrait',dft:'portrait/'},
            'ajax.swf':{name:'ajax',dft:'nej_proxy_flash.swf'},
            'chart.swf':{name:'chart',dft:'nej_flex_chart.swf'},
            'audio.swf':{name:'audio',dft:'nej_player_audio.swf'},
            'video.swf':{name:'video',dft:'nej_player_video.swf'},
            'clipboard.swf':{name:'clipboard',dft:'nej_clipboard.swf'},
            'upload.image.swf':{name:'uploadimage',dft:'nej_upload_image.swf'}
        };
        var _doInitProxy = function(_list){
            var _map = {};
            if (!_list||!_list.length){
                return _map;
            }
            for(var i=0,l=_list.length,_path;i<l;i++){
                _path = _list[i];
                if (_path.indexOf('://')>0)
                    _map[_p.__url2host(_path)] = _path;
            }
            return _map;
        };
        return function(_config){
            // check path config
            _p.__set('root',_config.root||'/res/');
            var _root = _p.__get('root');
            _u._$loop(_conf,function(v,k,m){
                _p.__set(k,_config[v.name]||(_root+v.dft));
            });
            // csrf config
            var _csrf = _config.p_csrf;
            if (_csrf===!0){
                _csrf = {
                    cookie:'AntiCSRF',
                    param:'AntiCSRF'
                };
            }
            _csrf = _csrf || _o;
            _p.__set('csrf',{
                param:_csrf.param||'',
                cookie:_csrf.cookie||''
            });
            // ajax by frame proxy
            _p.__set('frames',_doInitProxy(_config.p_frame));
            // ajax by flash proxy
            _p.__set('flashs',_doInitProxy(_config.p_flash));
        };
    })();
    _doInit(this.NEJ_CONF||_o);

    return _p;
},'19c9fc0aab6a6b9db67f02f7d86454f4','3f115371e3e07e18707a0c434f8a73ce');
I$('c140c0fcc2433e99d1fea24ed31fe24d',function(_h,_m,_p,_o,_f,_r){if (_m._$KERNEL.engine==='trident'){I$('6da2f5ebaafb62afee6f0e0e930eea17',function (){
        _h.__set(
            'storage.swf',
            (this.NEJ_CONF||_o).storage||
            (_h.__get('root')+'nej_storage.swf')
        );
    });}
if (_m._$KERNEL.engine==='trident'&&_m._$KERNEL.release<='3.0'){I$('c6df035cd7140b993a8c524adb4222ad',function (){
        _h.__set(
            'blank.png',
            (this.NEJ_CONF||_o).blank||
            (_h.__get('root')+'nej_blank.gif')
        );
    });}return _h;},'f82595aeedc5254355e7112328302ad1','836fd3ea8c2cdd6a7842e1315a393abe');
I$('7eab47413373d227196261a81b63bad2',function (NEJ,_h,_p,_o,_f,_r){
    /**
     * 取Frame跨域Ajax代理文件，通过NEJ_CONF的p_frame配置给定域名的代理文件地址
     *
     * @method module:base/config._$getFrameProxy
     * @see    module:base/config._$get
     * @param  {String} arg0 - 请求地址或者域名
     * @return {String}        代理文件地址
     */
    _p._$getFrameProxy = function(_url){
        var _host = _h.__url2host(_url);
        return _p._$get('frames')[_host]||
              (_host+'/res/nej_proxy_frame.html');
    };
    /**
     * 取Flash跨域Ajax配置文件，通过NEJ_CONF的p_flash配置给定域名的代理文件地址
     *
     * @method module:base/config._$getFlashProxy
     * @see    module:base/config._$get
     * @param  {String} arg0 - 请求地址或者域名
     * @return {String}        代理文件地址
     */
    _p._$getFlashProxy = function(_url){
        return _p._$get('flashs')[_h.__url2host(_url)];
    };
    /**
     * 获取NEJ配置信息，通过NEJ_CONF配置相关信息
     *
     * ```javascript
     *  window.NEJ_CONF = {
     *      // resource root
     *      // defalut value -> '/res/'
     *      root : '/nej/'
     *      // blank image for ie6-ie7
     *      // default value -> $root+'nej_blank.gif'
     *      blank : '/res/nej_blank.gif'
     *      // localstorage flash
     *      // default value -> $root+'nej_storage.swf'
     *      storage : '/res/nej_storage.swf'
     *      // audio player flash
     *      // default value -> $root+'nej_player_audio.swf'
     *      audio : '/res/nej_player_audio.swf'
     *      // video player flash
     *      // default value -> $root+'nej_player_video.swf'
     *      video : '/res/nej_player_video.swf'
     *      // clipboard flash
     *      // default value -> $root+'nej_clipboard.swf'
     *      clipboard : '/res/nej_clipboard.swf'
     *      // https request proxy
     *      // default value -> $root+'nej_proxy_flash.swf'
     *      ajax : '/res/nej_proxy_flash.swf'
     *      // portrait root
     *      // default value -> $root+'portrait/'
     *      portrait : '/res/portrait/'
     *      // cross domain xhr request for ie6-ie9
     *      // if path not start with http[s]://
     *      // will use /res/nej_proxy_frame.html as default
     *      p_frame:['http://c.d.com/html/nej_proxy_frame.html']
     *      // flash crossdomain.xml file path
     *      // default value -> http://a.b.com/crossdomain.xml
     *      p_flash:['http://a.b.com/proxy/crossdomain.xml']
     *      // CSRF cookie name and parameter name
     *      // set p_csrf:true to use URS config {cookie:'AntiCSRF',param:'AntiCSRF'}
     *      // default value -> {cookie:'',param:''}
     *      p_csrf:{cookie:'AntiCSRF',param:'AntiCSRF'}
     *  };
     * ```
     *
     * 配置标识支持
     *
     * | 标识                          | 说明 |
     * | :--              | :-- |
     * | portrait         | 表情根路径 |
     * | blank.png        | 空白图片文件地址 |
     * | ajax.swf         | Ajax代理Flash文件地址 |
     * | chart.swf        | 图标Flash文件地址 |
     * | audio.swf        | 实现Audio功能的Flash文件地址 |
     * | video.swf        | 实现Video功能的Flash文件地址 |
     * | clipboard.swf    | 实现剪切板功能的Flash文件地址 |
     * | upload.image.swf | 实现图片上传功能的Flash文件地址 |
     * | storage.swf      | 实现本地存储功能的Flash文件地址 |
     *
     * @method module:base/config._$get
     * @param  {String}   arg0 - 配置标识
     * @return {Variable}        配置信息
     */
    _p._$get = function(_key){
        return _h.__get(_key);
    };

    if (CMPT){
        NEJ.copy(NEJ.P('nej.c'),_p);
    }

    return _p;
},'19c9fc0aab6a6b9db67f02f7d86454f4','c140c0fcc2433e99d1fea24ed31fe24d');
I$('ca81292dba9c26802fbbda1e893ea19b',function (NEJ,_c,_p,_o,_f,_r){
    var _seed = +new Date;
    /**
     * 找不到指定内容的错误码
     *
     * @const {Number} module:base/constant._$CODE_NOTFUND
     */
    _p._$CODE_NOTFUND = 10000-_seed;
    /**
     * 需要指定的参数未指定的错误码
     *
     * @const {Number} module:base/constant._$CODE_NOTASGN
     */
    _p._$CODE_NOTASGN = 10001-_seed;
    /**
     * 不支持操作的错误码
     *
     * @const {Number} module:base/constant._$CODE_NOTSPOT
     */
    _p._$CODE_NOTSPOT = 10002-_seed;
    /**
     * 操作超时的错误码
     *
     * @const {Number} module:base/constant._$CODE_TIMEOUT
     */
    _p._$CODE_TIMEOUT = 10003-_seed;
    /**
     * 字符串作为脚本执行异常的错误码
     *
     * @const {Number} module:base/constant._$CODE_ERREVAL
     */
    _p._$CODE_ERREVAL = 10004-_seed;
    /**
     * 回调执行异常的错误码
     *
     * @const {Number} module:base/constant._$CODE_ERRCABK
     */
    _p._$CODE_ERRCABK = 10005-_seed;
    /**
     * 服务器返回异常的错误码
     *
     * @const {Number} module:base/constant._$CODE_ERRSERV
     */
    _p._$CODE_ERRSERV = 10006-_seed;
    /**
     * 异常终止的错误码
     *
     * @const {Number} module:base/constant._$CODE_ERRABRT
     */
    _p._$CODE_ERRABRT = 10007-_seed;
    /**
     * 请求头content-type统一名称
     *
     * @const {Number} module:base/constant._$HEAD_CT
     */
    _p._$HEAD_CT      = 'Content-Type';
    /**
     * 文本请求头content-type值
     *
     * @const {String} module:base/constant._$HEAD_CT_PLAN
     */
    _p._$HEAD_CT_PLAN = 'text/plain';
    /**
     * 文件请求头content-type值
     *
     * @const {String} module:base/constant._$HEAD_CT_FILE
     */
    _p._$HEAD_CT_FILE = 'multipart/form-data';
    /**
     * 表单请求头content-type值
     *
     * @const {String} module:base/constant._$HEAD_CT_FORM
     */
    _p._$HEAD_CT_FORM = 'application/x-www-form-urlencoded';
    /**
     * 空图片BASE64编码地址，低版本浏览器使用图片地址
     *
     * @const {String} module:base/constant._$BLANK_IMAGE
     */
    _p._$BLANK_IMAGE  = _c._$get('blank.png')||'data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';

    if (CMPT){
        NEJ.copy(NEJ.P('nej.g'),_p);
    }

    return _p;
},'19c9fc0aab6a6b9db67f02f7d86454f4','7eab47413373d227196261a81b63bad2');
I$('29e075e23a8f0b7ec637c0da9509d27a',function (_u,_p){
    var _cache = {};
    /**
     * 添加可链式调用的接口
     *
     * 添加可链式接口
     * ```javascript
     * NEJ.define([
     *     'base/chain'
     * ],function(_l){
     *     var _map = {};
     *
     *      _map._$api1 = function(){
     *          // TODO
     *      }
     *      
     *      _map._$api2 = function(){
     *          // TODO
     *      }
     * 
     *     _l._$merge(_map);
     * });
     * ```
     *
     * 使用链式调用接口
     * ```javascript
     * NEJ.define([
     *     '/path/to/api.js',
     *     'util/chain/chainable'
     * ],function(_x,$){
     *     // 使用链式调用api
     *     $('body > p')._$api1()._$api2();
     * });
     * ```
     * 
     * @method module:base/chain._$merge
     * @param  {Object} arg0 - 接口集合
     * @return {Void}
     */
    _p._$merge = function(_map){
        _u._$merge(_cache,_map);
    };
    /**
     * 导出链式接口列表
     * 
     * @method module:base/chain._$dump
     * @return {Object} 链式接口列表
     */
    _p._$dump = function(){
        return _cache;
    };
    /**
     * 清除链式列表
     * 
     * @method module:base/chain._$clear
     * @return {Void}
     */
    _p._$clear = function(){
        _cache = {};
    };
    
    return _p;
},'3f115371e3e07e18707a0c434f8a73ce');
I$('2a9f11c0adc5beeee637009a72792826',function (_u,_m,_p,_o,_f,_r){
    /**
     * 验证事件信息
     * @param  {Node}     节点
     * @param  {String}   事件类型
     * @param  {Function} 处理函数
     * @return {Object}   验证后事件信息 type/handler
     */
    _p.__checkEvent = (function(){
            // need change event name
        var _tmap = {
                touchstart:'mousedown',
                touchmove:'mousemove',
                touchend:'mouseup'
            },
            // need prefix
            _pfix = _m._$KERNEL.prefix,
            _emap = {
                transitionend:'TransitionEnd',
                animationend:'AnimationEnd',
                animationstart:'AnimationStart',
                animationiteration:'AnimationIteration',
                visibilitychange:'visibilitychange',
                fullscreenchange:'fullscreenchange'
            };
        var _fmap = {
            enter:function(_element,_type,_handler){
                var _result = {
                    type:'keypress'
                };
                if (!!_handler){
                    _result.handler = function(_event){
                        if (_event.keyCode===13){
                            _handler.call(_element,_event);
                        }
                    };
                }
                return _result;
            }
        };
        var _doPrefix = function(_name){
            return (_pfix.evt||_pfix.pro)+_name;
        };
        return function(_element,_type,_handler){
            var _result = {
                type:_type,
                handler:_handler
            };
            if (!(('on'+_type) in _element)){
                // check name convert
                var _name = _tmap[_type];
                if (!!_name){
                    _result.type = _name;
                    return _result;
                }
                // check prefix complete
                var _name = _emap[_type];
                if (!!_name){
                    _result.type = _doPrefix(_name);
                    return _result;
                }
                // check event update
                var _func = _fmap[_type];
                if (!!_func){
                    return _func.apply(null,arguments);
                }
            }
            return _result;
        };
    })();
    /**
     * 添加事件
     * @param  {Node}     节点
     * @param  {String}   事件
     * @param  {Function} 处理函数
     * @param  {Boolean}  是否捕捉阶段
     * @return {Void}
     */
    _p.__addEvent = function(){
        var _args = arguments;
        if (DEBUG){
            if (!(('on'+_args[1]) in _args[0])){
                console.log('not support event['+_args[1]+'] for '+_args[0]);
            }
        }
        _args[0].addEventListener(
            _args[1],_args[2],_args[3]
        );
    };
    /**
     * 删除事件
     * @param  {Node}     节点
     * @param  {String}   事件
     * @param  {Function} 处理函数
     * @param  {Boolean}  是否捕捉阶段
     * @return {Void}
     */
    _p.__delEvent = function(){
        var _args = arguments;
        _args[0].removeEventListener(
            _args[1],_args[2],_args[3]
        );
    };
    /**
     * 触发对象的某个事件
     * @param  {String|Node} 节点ID或者对象
     * @param  {String}      鼠标事件类型
     * @return {Void}
     */
    _p.__dispatchEvent = function(_element,_type,_options){
        var _event = document.createEvent('Event');
        _event.initEvent(_type,!0,!0);
        _u._$merge(_event,_options);
        _element.dispatchEvent(_event);
    };
    
    return _p;
},'3f115371e3e07e18707a0c434f8a73ce','836fd3ea8c2cdd6a7842e1315a393abe');
I$('e14dc9d0fd6e97467653b3f422e8b10e',function(b1725258635327,_h,_u,_p,_o,_f,_r){if (b1725258635327._$KERNEL.engine==='trident'&&b1725258635327._$KERNEL.release>='6.0'){I$('8c3cff3574e1e6242fc27104a388b033',function (){
        /**
         * 验证事件信息
         * @param  {Node}     节点
         * @param  {String}   事件类型
         * @param  {Function} 处理函数
         * @return {Object}   验证后事件信�? type/handler
         */
        _h.__checkEvent = (function(){
            var _emap = {
                touchcancel:'MSPointerCancel',
                touchstart:'MSPointerDown',
                touchmove:'MSPointerMove',
                touchend:'MSPointerUp',
                fullscreenchange:'MSFullscreenChange'
            };
            return _h.__checkEvent._$aop(function(_event){
                var _args = _event.args;
                // check event convert
                var _name = _emap[_args[1]];
                if (!!_name){
                    _event.stopped = !0;
                    _event.value = {
                        type:_name,
                        handler:_args[2]
                    };
                }
            });
        })();
    });}
if (b1725258635327._$KERNEL.engine==='trident'&&b1725258635327._$KERNEL.release=='5.0'){I$('f9456e5f60323a3bdf8f5a96bbf90d35',function (){
        /**
         * 验证事件信息
         * @param  {Node}     节点
         * @param  {String}   事件类型
         * @param  {Function} 处理函数
         * @return {Object}   验证后事件信�? type/handler
         */
        _h.__checkEvent = (function(){
            var _vmap = {};
            var _fmap = {
                input:function(_element,_type,_handler){
                    // for check type only
                    if (!_handler){
                        return {type:_type};
                    }
                    // fix input backspace/delete/ctrl+x bug
                    return {
                        type:_type,
                        handler:function(_event){
                            var _id = _element.id;
                            _vmap[_id] = _element.value;
                            _handler.call(_element,_event);
                        },
                        link:[[
                            document,'selectionchange',
                            function(_event){
                                var _id = _element.id;
                                if (_element!=document.activeElement){
                                    delete _vmap[_id];
                                    return;
                                }
                                if (_vmap[_id]!==_element.value){
                                    _vmap[_id] = _element.value;
                                    _handler.call(_element,_event);
                                }
                            }
                        ]]
                    };
                }
            };
            return _h.__checkEvent._$aop(function(_event){
                var _args = _event.args;
                // check event update
                var _func = _fmap[_args[1]];
                if (!!_func){
                    _event.stopped = !0;
                    _event.value = _func.apply(null,_args);
                }
            });
        })();
    });}
if (b1725258635327._$KERNEL.engine==='trident'&&b1725258635327._$KERNEL.release>='5.0'){I$('ab42495c9e518fafd51e7d00e8086ebf',function (){
        // must use attach/detach for event
        var _attached = {
            'propertychange':1
        };
        /**
         * 添加事件
         * @param  {Node}     节点
         * @param  {String}   事件
         * @param  {Function} 处理函数
         * @param  {Boolean}  是否捕捉阶段
         * @return {Void}
         */
        _h.__addEvent = 
        _h.__addEvent._$aop(function(_event){
            var _args = _event.args;
            if (_attached[_args[1]]!=null&&!!_args[0].attachEvent){
                _event.stopped = !0;
                _args[0].attachEvent('on'+_args[1],_args[2]);
            }
        });
        /**
         * 删除事件
         * @param  {Node}     节点
         * @param  {String}   事件
         * @param  {Function} 处理函数
         * @param  {Boolean}  是否捕捉阶段
         * @return {Void}
         */
        _h.__delEvent = 
        _h.__delEvent._$aop(function(_event){
            var _args = _event.args,
                _alias = _attached[_args[1]];
            if (_attached[_args[1]]!=null&&!!_args[0].detachEvent){
                _event.stopped = !0;
                _args[0].detachEvent('on'+_args[1],_args[2]);
            }
        });
    });}
if (b1725258635327._$KERNEL.engine==='trident'&&b1725258635327._$KERNEL.release<='4.0'){I$('bbdfa34321e0ed3cbdb8598c0d340a4d',function (){
        /**
         * 验证事件信息
         * @param  {Node}     节点
         * @param  {String}   事件类型
         * @param  {Function} 处理函数
         * @return {Object}   验证后事件信�? type/handler
         */
        _h.__checkEvent = (function(){
            var _lmap = {};
            var _fmap = {
                input:function(_element,_type,_handler){
                    var _result = {
                        type:'propertychange'
                    };
                    if (!!_handler){
                        var _id = _element.id;
                        var _hack = function(_event){
                            if (!!_element.value&&!_lmap['x-'+_id]){
                                _lmap['x-'+_id] = !0;
                                _handler.call(_element,_event);
                            }
                        };
                        _result.handler = function(_event){
                            // for input.value or textarea.value
                            if (('value' in _element)&&
                                _event.propertyName=='value'){
                                // lock cycle trigger
                                if (!!_lmap[_id]){
                                    return;
                                }
                                _lmap[_id] = !0;
                                _handler.call(_element,_event);
                                delete _lmap[_id];
                            }
                        };
                        _result.link = [
                            [_element,'keyup',_hack],
                            [_element,'mouseup',_hack],
                            [_element,'mousemove',_hack]
                        ];
                        _result.destroy = function(){
                            delete _lmap[_id];
                            delete _lmap['x-'+_id];
                        };
                    }
                    return _result;
                },
                load:function(_element,_type,_handler){
                    var _result = {
                        type:'readystatechange'
                    };
                    if (!!_handler){
                        _result.handler = function(_event){
                            if (_element.readyState=='loaded'||
                                _element.readyState=='complete'){
                                _handler.call(_element,_event);
                            }
                        };
                    }
                    return _result;
                }
            };
            return _h.__checkEvent._$aop(function(_event){
                var _args = _event.args;
                // check event update
                var _func = _fmap[_args[1]];
                if (!!_func){
                    _event.stopped = !0;
                    _event.value = _func.apply(null,_args);
                }
                // use element for this in handler
                if (!!_args[2]){
                    _args[2] = _args[2]._$bind(_args[0]);
                }
            });
        })();
        /**
         * 添加事件
         * @param  {Node}     节点
         * @param  {String}   事件
         * @param  {Function} 处理函数
         * @param  {Boolean}  是否捕捉阶段
         * @return {Void}
         */
        _h.__addEvent = function(){
            var _args = arguments;
            if (DEBUG){
                if (!(('on'+_args[1]) in _args[0])){
                    console.log('not support event['+_args[1]+'] for '+_args[0]);
                }
            }
            _args[0].attachEvent('on'+_args[1],_args[2]);
        };
        /**
         * 删除事件
         * @param  {Node}     节点
         * @param  {String}   事件
         * @param  {Function} 处理函数
         * @param  {Boolean}  是否捕捉阶段
         * @return {Void}
         */
        _h.__delEvent = function(){
            var _args = arguments;
            _args[0].detachEvent('on'+_args[1],_args[2]);
        };
        /**
         * 触发对象的某个事�?
         * @param  {String|Node} 节点ID或�?�对�?
         * @param  {String}      鼠标事件类型
         * @return {Void}
         */
        _h.__dispatchEvent = (function(){
            var _omap = {
                propertychange:{propertyName:'value'}
            };
            return function(_element,_type,_options){
                var _event = document.createEventObject();
                try{
                    _u._$merge(_event,_omap[_type],_options);
                    _element.fireEvent('on'+_type,_event);
                }catch(ex){
                    // ignore unrecognized event name
                    console.error(ex.message);
                    console.error(ex.stack);
                }
            };
        })();
    });}
if (b1725258635327._$KERNEL.engine==='gecko'){I$('36230c460a7b8b13ce054944989dc4ef',function (){
        /**
         * 验证事件信息
         * @param  {Node}     节点
         * @param  {String}   事件类型
         * @param  {Function} 处理函数
         * @return {Object}   验证后事件信�? type/handler
         */
        _h.__checkEvent = (function(){
            var _nreg = /^(?:transitionend|animationend|animationstart|animationiteration)$/i;
            var _fmap = {
                mousewheel:function(_element,_type,_handler){
                    var _result = {
                        type:'MozMousePixelScroll'
                    };
                    if (!!_handler){
                        _result.handler = function(_event){
                            var _delta = _event.detail;
                            _event.wheelDelta = -_delta;
                            _event.wheelDeltaY = -_delta;
                            _event.wheelDeltaX = 0;
                            _handler.call(_element,_event);
                        };
                    }
                    return _result;
                }
            };
            return _h.__checkEvent._$aop(function(_event){
                var _args = _event.args;
                // check animation event
                if (_nreg.test(_args[1])){
                    _event.stopped = !0;
                    _event.value = {
                        type:_args[1],
                        handler:_args[2]
                    };
                }
                // check event update
                var _func = _fmap[_args[1]];
                if (!!_func){
                    _event.stopped = !0;
                    _event.value = _func.apply(null,_args);
                }
            });
        })();
    });}return _h;},'836fd3ea8c2cdd6a7842e1315a393abe','2a9f11c0adc5beeee637009a72792826','3f115371e3e07e18707a0c434f8a73ce');
I$('72b60541618971d03c8b74f45c039218',function (NEJ,_e,_u,_x,_h,_p,_o,_f,_r){
    // {id:{type:[{type:'click',func:function,sfun:function,capt:true},...]}}
    // id   - element id
    // type - event name, no on prefix
    // func - event after wrapper
    // capt - capture flag
    // sfun - event before wrapper
    // link - events link to this event [[element,type,handler,capture],...]
    var _xcache = {},
        _y = {}; // chainable methods
    /*
     * 取事件类型列表
     * @param  {String} 事件类型
     * @return {Array}  事件列表
     */
    var _getTypeList = (function(){
        var _reg = /[\s,;]+/;
        return function(_type){
            var _type = (_type||'').trim().toLowerCase();
            return !_type?null:_type.split(_reg);
        };
    })();
    /*
     * 取鼠标相对于BODY的偏移
     * @param  {Event}  事件对象
     * @param  {String} 类型，X/Y
     * @param  {String} 滚动偏移名称，Left/Top
     * @return {Void}
     */
    var _getClientOffset = function(_event,_type,_name){
        var _key1 = 'page'+_type;
        return _event[_key1]!=null?_event[_key1]:(
            _event['client'+_type]+
            _e._$getPageBox()['scroll'+_name]
        );
    };
    /*
     * 取鼠标相对于页面的偏移
     * @param  {Event}  事件对象
     * @param  {String} 类型，X/Y
     * @param  {String} 滚动偏移名称，Left/Top
     * @return {Void}
     */
    var _getPageOffset = function(_event,_type,_name){
        var _key3 = 'scroll'+_name;
            _node = _p._$getElement(_event),
            _xret = _getClientOffset(_event,_type,_name);
        while(!!_node&&
                _node!=document.body&&
                _node!=document.documentElement){
            _xret += _node[_key3]||0;
            _node = _node.parentNode;
        }
        return _xret;
    };
    /*
     * 格式化添加删除事件接口参数
     * @param  {String|Node} 节点ID或者对象
     * @param  {String}      事件类型，不带on前缀，不区分大小写，多个事件用空格分隔
     * @param  {Function}    事件处理函数
     * @param  {Boolean}     是否捕获阶段事件，IE低版本浏览器忽略此参数
     * return  {Object}      格式化后参数
     */
    var _doFormatArgs = function(_element,_type,_handler,_capture){
        var _result = {};
        // check element
        _element = _e._$get(_element);
        if (!_element){
            return null;
        }
        _e._$id(_element);
        _result.element = _element;
        // check event handler
        if (!_u._$isFunction(_handler)){
            return null;
        }
        _result.handler = _handler;
        // check type
        var _type = _getTypeList(_type);
        if (!_type){
            return null;
        }
        // save info
        _result.type = _type;
        _result.capture = !!_capture;
        return _result;
    };
    /**
     * 节点添加事件，
     * 支持添加自定义事件，
     * 对于自定义事件的实现逻辑由其他模块负责实现
     *
     * 结构举例
     * ```html
     *   <div id="abc">123</div>
     * ```
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/event'
     *   ],function(_v){
     *       // 添加系统预定义事件
     *       _v._$addEvent(
     *           'abc','mouseover',function(_event){
     *               // TODO something
     *           },false
     *       );
     *
     *       // 添加自定义事件，回车事件
     *       _v._$addEvent(
     *           'abc','enter',function(_event){
     *               // TODO something
     *           },false
     *       );
     *
     *       // 添加多个事件，用空格分隔
     *       _v._$addEvent(
     *           'abc','mouseover click mousedown',
     *           function(_event){
     *               // TODO something
     *           },false
     *       );
     *   });
     * ```
     *
     * 带自定义事件的类构造或者对象
     * ```javascript
     * NEJ.define([
     *     'base/klass',
     *     'base/event',
     *     'util/event',
     *     'util/event/event'
     * ],function(_k,_v,_t0,_t1,_p){
     *     // 定义类
     *     _p._$$Klass = _k._$klass();
     *     var _pro = _p._$$Klass._$extend(_t0._$$EventTarget);
     *     
     *     // TODO
     *     
     *     // 添加自定义事件支持
     *     // 对节点的事件同样支持此自定义事件
     *     _t1._$$CustomEvent._$allocate({
     *         element:_p._$$Klass,
     *         event:['ok','fail']
     *     });
     * 
     *     // 使用事件接口添加/删除/调度事件
     *     var _handler = function(_event){
     *         // TODO
     *     };
     *     _v._$addEvent(_p._$$Klass,'ok',_handler);
     *     _v._$delEvent(_p._$$Klass,'ok',_handler);
     * });
     * ```
     * 
     * @method module:base/event._$addEvent
     * @see    module:base/event._$delEvent
     * @param  {String|Node|Object} arg0 - 节点或者类构造或者对象
     * @param  {String}      arg1 - 事件类型，不带on前缀，不区分大小写，多个事件用空格分隔
     * @param  {Function}    arg2 - 事件处理函数
     * @param  {Boolean}     arg3 - 是否捕获阶段事件，IE低版本浏览器忽略此参数
     * @return {Void}
     */
    /**
     * @method CHAINABLE._$addEvent
     * @see module:base/event._$addEvent
     */
    _p._$addEvent = 
    _y._$addEvent = (function(){
        // cache event
        // type/handler/link
        var _doCacheEvent = function(_type,_source,_real){
            var _id = _e._$id(_source.element),
                _cch_id = _xcache[_id]||{},
                _cch_tp = _cch_id[_type]||[];
            _cch_tp.push({
                type:_real.type||_type,
                func:_real.handler||_source.handler,
                sfun:_source.handler,
                capt:_source.capture,
                link:_real.link,
                destroy:_real.destroy
            });
            _cch_id[_type] = _cch_tp;
            _xcache[_id] = _cch_id;
        };
        return function(){
            var _args = _doFormatArgs.apply(null,arguments);
            if (!_args) return;
            _u._$forEach(
                _args.type,function(_name){
                    var _argc = _h.__checkEvent(
                        _args.element,
                        _name,_args.handler
                    );
                    // add event
                    _h.__addEvent(
                        _args.element,_argc.type,
                        _argc.handler,_args.capture
                    );
                    // add event link
                    _u._$forIn(
                        _argc.link,function(_item){
                            _item[3] = !!_item[3];
                            _h.__addEvent.apply(_h,_item);
                            _item[0] = _e._$id(_item[0]);
                        }
                    );
                    // cache event
                    _doCacheEvent(_name,_args,_argc);
                }
            );
        };
    })();
    /**
     * 节点删除事件，输入参数必须保证与添加接口_$addEvent输入参数完全一致
     *
     * 结构举例
     * ```html
     *   <div id="abc">123</div>
     * ```
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/event'
     *   ],function(_v){
     *       // 事件回调业务逻辑
     *       var _doCallback = function(_event){
     *           // TODO something
     *           alert('0');
     *       };
     *
     *       // 添加事件
     *       _v._$addEvent('abc','mouseover',_doCallback,false);
     *       // 删除事件，这里参数必须保持完全一致
     *       _v._$delEvent('abc','mouseover',_doCallback,false);
     *
     *       // 比如以下方式虽然回调的业务逻辑一致，但是无法删除之前添加的事件
     *       _v._$delEvent(
     *           'abc',"mouseover",function(_event){
     *               // TODO something
     *               alert('0');
     *           },false
     *       );
     *
     *       // 删除多个事件
     *       _v._$delEvent(
     *           'abc','mouseover click mouseup',
     *           _doCallback,false
     *       );
     *   });
     * ```
     *
     * @method module:base/event._$delEvent
     * @see    module:base/event._$addEvent
     * @param  {String|Node} arg0 - 节点ID或者对象
     * @param  {String}      arg1 - 事件类型，不带on前缀，不区分大小写，多个事件用空格分隔
     * @param  {Function}    arg2 - 事件处理函数
     * @param  {Boolean}     arg3 - 是否捕获阶段事件
     * @return {Void}
     */
    /**
     * @method CHAINABLE._$delEvent
     * @see module:base/event._$delEvent
     */
    _p._$delEvent = 
    _y._$delEvent = (function(){
        var _unCacheEvent = function(_type,_conf){
            var _id = _e._$id(_conf.element),
                _cch_id = _xcache[_id]||_o,
                _cch_tp = _cch_id[_type],
                _index = _u._$indexOf(
                    _cch_tp,function(_item){
                        // check handler and capture
                        return _item.sfun===_conf.handler&&
                               _item.capt===_conf.capture;
                    }
                );
            // check result
            var _result = null;
            if (_index>=0){
                var _item = _cch_tp.splice(_index,1)[0];
                _result = [[
                    _conf.element,_item.type,
                    _item.func,_conf.capture
                ]];
                if (!!_item.link){
                    // complete element by id
                    _u._$forEach(_item.link,function(v){
                        v[0] = _e._$get(v[0]);
                    });
                    _result.push.apply(_result,_item.link);
                }
                if (!!_item.destroy){
                    _item.destroy();
                }
                // clear cache
                if (!_cch_tp.length){
                    delete _cch_id[_type];
                }
                if (!_u._$hasProperty(_cch_id)){
                    delete _xcache[_id];
                }
            }
            return _result;
        };
        return function(){
            var _args = _doFormatArgs.apply(null,arguments);
            if (!_args) return;
            _u._$forEach(
                _args.type,function(_name){
                    _u._$forEach(
                        _unCacheEvent(_name,_args),
                        function(_item){
                            _h.__delEvent.apply(_h,_item);
                        }
                    );
                }
            );
        };
    })();
    /**
     * 清除节点事件
     *
     * 结构举例
     * ```html
     *   <div id="abc">123</div>
     * ```
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/event'
     *   ],function(_v){
     *       // 添加事件
     *       _v._$addEvent(
     *           'abc','mouseover',function(_event){
     *               // TODO something
     *           }
     *       );
     *       _v._$addEvent(
     *           'abc','mouseover',function(_event){
     *               // TODO something
     *           },true
     *       );
     *       _v._$addEvent(
     *           'abc','custom',function(_event){
     *               // TODO something
     *           }
     *       );
     *
     *       // 清除节点所有事件，包括两个mouseover事件和一个custom事件
     *       _v._$clearEvent('abc');
     *
     *       // 清除节点指定类型事件，只清除两个mouseover事件
     *       _v._$clearEvent('abc','mouseover');
     *
     *       // 清除多个事件，用空格分隔
     *       _v._$clearEvent('abc','mouseover custom');
     *   });
     * ```
     *
     * @method module:base/event._$clearEvent
     * @see    module:base/event._$delEvent
     * @param  {String|Node} arg0 - 节点ID或者对象
     * @param  {String}      arg1 - 事件类型，不带on前缀，不区分大小写，多个事件用空格分隔
     * @return {Void}
     */
    /**
     * @method CHAINABLE._$clearEvent
     * @see module:base/event._$clearEvent
     */
    _p._$clearEvent = 
    _y._$clearEvent = (function(){
        var _doClearEvent = function(_id,_name,_list){
            _u._$reverseEach(
                _list,function(_item){
                    _p._$delEvent(
                        _id,_name,_item.sfun,_item.capt
                    );
                }
            );
        };
        return function(_element,_type){
            var _id = _e._$id(_element);
            if (!_id) return;
            var _cch_id = _xcache[_id];
            if (!!_cch_id){
                _type = _getTypeList(_type);
                if (!!_type){
                    // clear event by type
                    _u._$forEach(
                        _type,function(_name){
                            _doClearEvent(_id,_name,_cch_id[_name]);
                        }
                    );
                }else{
                    // clear all event
                    _u._$loop(
                        _cch_id,function(_value,_name){
                            _p._$clearEvent(_element,_name);
                        }
                    );
                }
            }
        };
    })();
    /**
     * 触发对象的某个事件，注：对于IE浏览器该接口节点事件有以下限制
     *
     * * 捕获阶段支持需要浏览器IE9+
     * * 节点上自定义事件支持需要浏览器IE9+
     *
     *
     * 结构举例
     * ```html
     *   <div id="abc">123</div>
     * ```
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/event'
     *   ],function(_v){
     *       // 注册鼠标事件
     *       _v._$addEvent(
     *           'abc','click',function(_event){
     *               // 获取鼠标事件触发的垂直位置
     *               var _y = _v._$pageY(_event);
     *           }
     *       );
     *       // 触发鼠标事件
     *       _v._$dispatchEvent('abc','click');
     *
     *       // 注册自定义事件
     *       _v._$addEvent(
     *           'abc','ok',function(_event){
     *               // TODO something
     *           }
     *       );
     *       // 触发自定义事件
     *       _v._$dispatchEvent('abc','ok');
     *   });
     * ```
     *
     * @method module:base/event._$dispatchEvent
     * @param  {String|Node} arg0 - 节点ID或者对象
     * @param  {String}      arg1 - 鼠标事件类型，不区分大小写，多个事件用空格分隔
     * @param  {Object}      arg2 - 传递的参数信息
     * @return {Void}
     */
    /**
     * @method CHAINABLE._$dispatchEvent
     * @see module:base/event._$dispatchEvent
     */
    _p._$dispatchEvent = 
    _y._$dispatchEvent = function(_element,_type,_options){
        var _element = _e._$get(_element);
        if (!!_element){
            _u._$forEach(
                _getTypeList(_type),function(_name){
                    var _result = _h.__checkEvent(
                        _element,_name
                    );
                    _h.__dispatchEvent(
                        _element,_result.type,_options
                    );
                }
            );
        }
    };
    /**
     * 获取触发事件的节点，可以传入过滤接口来遍历父节点找到符合条件的节点
     *
     * 结构举例
     * ```html
     *   <div id="a">
     *     <p>
     *       <span id="b">123</span>
     *       <span link="a">123</span>
     *       <span class="a link">123</span>
     *       <span data-link="a">123</span>
     *       <label>aaaaa</label>
     *     </p>
     *   </div>
     * ```
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/event'
     *   ],function(_v){
     *       // 取事件触发节点
     *       _v._$addEvent(
     *           'b','click',function(_event){
     *               // id为b的节点
     *               var _node = _v._$getElement(_event);
     *               // TODO something
     *           }
     *       );
     *
     *       // 事件触发，取id是a的节点
     *       _v._$addEvent(
     *           'b','click',function(_event){
     *               // id为a的节点
     *               var _node = _v._$getElement(
     *                   _event,function(_element){
     *                       return _element.id=='a';
     *                   }
     *               );
     *               // TODO something
     *
     *               // class含link或者属性含link或者data-link的节点
     *               var _node = _v._$getElement(_event,'link');
     *
     *               // 仅匹配class即 class="link xx xxx"
     *               var _node = _v._$getElement(_event,'c:link');
     *
     *               // 仅匹配dataset即 data-link="aaaa"
     *               var _node = _v._$getElement(_event,'d:link');
     *
     *               // 仅匹配attributer即 link="aaa"
     *               var _node = _v._$getElement(_event,'a:link');
     *
     *               // 仅匹配tag即 <label>
     *               var _node = _v._$getElement(_event,'t:label');
     *           }
     *       );
     *   });
     * ```
     *
     * @method module:base/event._$getElement
     * @param  {Event}    arg0 - 事件对象
     * @param  {Function} arg1 - 过滤接口
     * @return {Node}            符合条件的节点
     */
    _p._$getElement = function(_event){
        if (!_event) return null;
        var _element = _event.target||
                _event.srcElement,
            _filter = arguments[1];
        return _e._$getParent(_element,_filter);
    };
    /**
     * 阻止事件，包括默认事件和传递事件
     *
     * 结构举例
     * ```html
     *   <div id="a">
     *     <a href="xxx.html" id="b">123</a>
     *   </div>
     * ```
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/event'
     *   ],function(_v){
     *       // 事件回调中阻止事件冒泡
     *       _v._$addEvent(
     *           'b','click',function(_event){
     *               // 阻止事件继续传播
     *               // 阻止链接打开的默认事件
     *               _v._$stop(_event);
     *           }
     *       );
     *
     *       // a节点上的点击事件不会触发
     *       _v._$addEvent(
     *           'a','click',function(_event){
     *               alert(0);
     *               // TODO something
     *           }
     *       );
     *   });
     * ```
     *
     * @method module:base/event._$stop
     * @see    module:base/event._$stopBubble
     * @see    module:base/event._$stopDefault
     * @param  {Event} arg0 - 要阻止的事件对象
     * @return {Void}
     */
    _p._$stop = function(_event){
        _p._$stopBubble(_event);
        _p._$stopDefault(_event);
    };
    /**
     * 阻止事件的冒泡传递
     *
     * 结构举例
     * ```html
     *   <div id="a">
     *     <a href="xxx.html" id="b">123</a>
     *   </div>
     * ```
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/event'
     *   ],function(_v){
     *       // 事件回调中阻止事件冒泡
     *       _v._$addEvent(
     *           'b','click',function(_event){
     *               // 阻止事件继续传播
     *               // 链接仍然会被打开
     *               _v._$stopBubble(_event);
     *           }
     *       );
     *
     *       // a节点上的点击事件不会触发
     *       _v._$addEvent(
     *           'a','click',function(_event){
     *               alert(0);
     *               // TODO something
     *           }
     *       );
     *   });
     * ```
     *
     * @see    module:base/event._$stop}
     * @method module:base/event._$stopBubble
     * @param  {Event} arg0 - 要阻止的事件对象
     * @return {Void}
     */
    _p._$stopBubble = function(_event){
        if (!!_event){
            !!_event.stopPropagation
            ? _event.stopPropagation()
            : _event.cancelBubble = !0;
        }
    };
    /**
     * 阻止标签的默认事件
     *
     * 结构举例
     * ```html
     *   <div id="a">
     *     <a href="xxx.html" id="b">123</a>
     *   </div>
     * ```
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/event'
     *   ],function(_v){
     *       // 事件回调中阻止链接默认事件
     *       _v._$addEvent(
     *           'b','click',function(_event){
     *               // 阻止链接打开页面的默认行为
     *               _v._$stopDefault(_event);
     *           }
     *       );
     *
     *       // a节点上的点击事件仍然会触发
     *       _v._$addEvent(
     *           'a','click',function(_event){
     *               alert(0);
     *               // TODO something
     *           }
     *       );
     *   });
     * ```
     *
     * @method module:base/event._$stopDefault
     * @see    module:base/event._$stop
     * @param  {Event} arg0 - 要阻止的事件对象
     * @return {Void}
     */
    _p._$stopDefault = function(_event) {
        if (!!_event){
            !!_event.preventDefault
            ? _event.preventDefault()
            : _event.returnValue = !1;
        }
    };
    /**
     * 取事件相对于页面的位置
     *
     * 结构举例
     * ```html
     *   <div id="abc" style="width:100%;height:100%;">123</div>
     * ```
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/event'
     *   ],function(_v){
     *       // 回调中取鼠标位置
     *       _v._$addEvent(
     *           'abc','click',function(_event){
     *               // 获取鼠标事件触发的水平、垂直位置
     *               var _pos = _v._$page(_event);
     *           }
     *       );
     *   });
     * ```
     *
     * @method module:base/event._$page
     * @see    module:base/event._$pageX
     * @see    module:base/event._$pageY
     * @param  {Event}  arg0 - 事件对象
     * @return {Object}        位置信息，{x:10,y:10}
     */
    _p._$page = function(_event){
        return {
            x:_p._$pageX(_event),
            y:_p._$pageY(_event)
        };
    };
    /**
     * 取事件相对于页面左侧的位置，累加所有内部滚动高度
     *
     * 结构举例
     * ```html
     *   <div id="abc" style="width:100%;height:100%;">123</div>
     * ```
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/event'
     *   ],function(_v){
     *       // 回调中取鼠标位置
     *       _p._$addEvent(
     *           'abc','click',function(_event){
     *               // 获取鼠标事件触发的水平位置
     *               var _x = _v._$pageX(_event);
     *           }
     *       );
     *   });
     * ```
     *
     * @method module:base/event._$pageX
     * @see    module:base/event._$clientX
     * @param  {Event}  arg0 - 事件对象
     * @return {Number}        水平位置
     */
    _p._$pageX = function(_event){
        return _getPageOffset(_event,'X','Left');
    };
    /**
     * 取事件相对于页面顶部的位置，累加所有内部滚动高度
     *
     * 结构举例
     * ```html
     *   <div id="abc" style="width:100%;height:100%;">123</div>
     * ```
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/event'
     *   ],function(_v){
     *       // 回调中取鼠标位置
     *       _v._$addEvent(
     *           'abc','click',function(_event){
     *               // 获取鼠标事件触发的垂直位置
     *               var _y = _v._$pageY(_event);
     *           }
     *       );
     *   });
     * ```
     *
     * @method module:base/event._$pageY
     * @see    module:base/event._$clientY
     * @param  {Event}  arg0 - 事件对象
     * @return {Number}        垂直位置
     */
    _p._$pageY = function(_event){
        return _getPageOffset(_event,'Y','Top');
    };
    /**
     * 取事件相对于页面左侧的位置，仅累加页面滚动高度
     *
     * 结构举例
     * ```html
     *   <div id="abc" style="width:100%;height:100%;">123</div>
     * ```
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/event'
     *   ],function(_v){
     *       // 回调中取鼠标位置
     *       _p._$addEvent(
     *           'abc','click',function(_event){
     *               // 获取鼠标事件触发的水平位置
     *               var _x = _v._$clientX(_event);
     *           }
     *       );
     *   });
     * ```
     *
     * @method module:base/event._$clientX
     * @see    module:base/event._$pageX
     * @param  {Event}  arg0 - 事件对象
     * @return {Number}        水平位置
     */
    _p._$clientX = function(_event){
        return _getClientOffset(_event,'X','Left');
    };
    /**
     * 取事件相对于页面顶部的位置，仅累加页面滚动高度
     *
     * 结构举例
     * ```html
     *   <div id="abc" style="width:100%;height:100%;">123</div>
     * ```
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/event'
     *   ],function(_v){
     *       // 回调中取鼠标位置
     *       _v._$addEvent(
     *           'abc','click',function(_event){
     *               // 获取鼠标事件触发的垂直位置
     *               var _y = _v._$pageY(_event);
     *           }
     *       );
     *   });
     * ```
     *
     * @method module:base/event._$clientY
     * @see    module:base/event._$pageY
     * @param  {Event}  arg0 - 事件对象
     * @return {Number}        垂直位置
     */
    _p._$clientY = function(_event){
        return _getClientOffset(_event,'Y','Top');
    };
    
    // for chainable method
    _x._$merge(_y);
    
    if (CMPT){
        NEJ.copy(NEJ.P('nej.v'),_p);
    }

    return _p;
},'19c9fc0aab6a6b9db67f02f7d86454f4','15fb3eeb129e67b9b1cc98ef8ea8e26d','3f115371e3e07e18707a0c434f8a73ce','29e075e23a8f0b7ec637c0da9509d27a','e14dc9d0fd6e97467653b3f422e8b10e');
I$('213d44e8c551a556a0e0da3aeb0c5e49',function (_u,_m,_p,_o,_f,_r){
    /**
     * 从DocumentFragment中取指定ID的节点
     * @param  {Document} 文档对象
     * @param  {String}   节点标识
     * @return {Node}     指定标识的节点
     */
    _p.__getElementById = function(_fragment,_id){
        if (!!_fragment.getElementById){
            return _fragment.getElementById(''+_id);
        }
        try{
            return _fragment.querySelector('#'+_id);
        }catch(e){
            return null;
        }
    };
    /**
     * 取节点的子节点列表
     * @param  {Node}  节点ID或者对象
     * @return {Array} 子节点列表
     */
    _p.__getChildren = function(_element){
        return _u._$object2array(_element.children);
    };
    /**
     * 根据类名取节点列表
     * @param  {Node}   节点ID或者对象
     * @param  {String} 类名
     * @return {Array}  节点列表
     */
    _p.__getElementsByClassName = function(_element,_class){
        return _u._$object2array(_element.getElementsByClassName(_class));
    };
    /**
     * 取下一个兄弟节点
     * @param  {Node}  节点对象
     * @return {Node}  节点
     */
    _p.__nextSibling = function(_element){
        return _element.nextElementSibling;
    };
    /**
     * 取上一个兄弟节点
     * @param  {Node}  节点对象
     * @return {Node}  节点
     */
    _p.__previousSibling = function(_element){
        return _element.previousElementSibling;
    };
    /**
     * 设置、获取数据
     * @param {Node}     节点
     * @param {String}   标识
     * @param {Variable} 值
     */
    _p.__dataset = function(_element,_name,_value){
        _element.dataset = _element.dataset||{};
        if (_value!==undefined){
            _element.dataset[_name] = _value;
        }
        return _element.dataset[_name];
    };
    /**
     * 取节点属性值
     * @param  {Node}   节点
     * @param  {String} 属性名
     * @return {String} 属性值
     */
    _p.__getAttribute = function(_element,_name){
        if ('getAttribute' in _element){
            return _element.getAttribute(_name);
        }
    };
    /**
     * 将dom节点转为xml串
     * @param  {Node}   节点
     * @return {String} XML代码
     */
    _p.__serializeDOM2XML = function(_dom){
        return new XMLSerializer().serializeToString(_dom)||'';
    };
    /**
     * 将xml转为dom节点
     * @param  {String} XML代码
     * @return {Node}   节点
     */
    _p.__parseDOMFromXML = function(_xml){
        var _root = new DOMParser()
                       .parseFromString(_xml,'text/xml')
                       .documentElement;
        return _root.nodeName=='parsererror'?null:_root;
    };
    /**
     * 节点占全屏
     * @param  {Node}   节点
     * @param  {Object} 视窗模型
     * @return {Void}
     */
    _p.__fullScreen = function(){
        // use css fixed position
    };
    /**
     * 为节点增加用于盖select/flash等控件的层
     * @param  {Node} 节点
     * @return {Void}
     */
    _p.__mask = function(){
        // do nothing
    };
    /**
     * 去除用于盖select/flash等控件的层
     * @param  {Node} 节点
     * @return {Void}
     */
    _p.__unmask = function(){
        // do nothing
    };
    // variables
    var _ospt = _m._$SUPPORT,
        _opfx = _m._$KERNEL.prefix;
    /**
     * 指定名称是否在配置表中
     * @param  {String}  名称
     * @param  {Object}  配置表
     * @return {Boolean} 是否命中
     */
    _p.__isMatchedName = (function(){
        var _reg = /^([a-z]+?)[A-Z]/;
        return function(_name,_map){
            return !!(_map[_name]||(_reg.test(_name)&&_map[RegExp.$1]));
        };
    })();
    /**
     * 样式名称做前缀增强
     * @param  {String}  名称
     * @return {Boolean} 是否需要前缀增强
     */
    _p.__isNeedPrefixed = (function(){
        var _pmap = _u._$array2object([
            'animation','transform','transition',
            'appearance','userSelect','box','flex','column'
        ]);
        return function(_name){
            return _p.__isMatchedName(_name,_pmap);
        };
    })();
    /**
     * 格式化样式属性名称
     * border-width -> borderWidth
     * @param  {String} 样式样式名
     * @return {String} 格式化后样式名
     */
    _p.__fmtStyleName = (function(){
        var _reg = /-([a-z])/g;
        return function(_name){
            _name = _name||'';
            return _name.replace(_reg,function($1,$2){
                return $2.toUpperCase();
            });
        };
    })();
    /**
     * 针对样式名称做格式化及前缀增强
     * @param  {String} 样式名
     * @return {String} 增强后的样式名
     */
    _p.__getStyleName = (function(){
        var _reg = /^[a-z]/,
            _prefix = _opfx.css||'';
        return function(_name){
            _name = _p.__fmtStyleName(_name);
            if (!_p.__isNeedPrefixed(_name)){
                return _name;
            }
            // add prefix
            // userSelect -> webkitUserSelect
            return _prefix+_name.replace(_reg,function($1){
                return $1.toUpperCase();
            });
        };
    })();
    /**
     * 取样式值
     * @param  {String|Node} 节点
     * @param  {String}      样式名称
     * @return {Variable}    样式值
     */
    _p.__getStyleValue = function(_element,_name){
        var _current = window.getComputedStyle(_element,null);
        return _current[_p.__getStyleName(_name)]||'';
    };
    /**
     * 设置样式
     * @param  {String|Node} 节点
     * @param  {String}      样式名称
     * @param  {String}      样式值
     * @return {Void}
     */
    _p.__setStyleValue = function(_element,_name,_value){
        _element.style[_p.__getStyleName(_name)] = _value;
    };
    /**
     * 取样式变换矩阵对象
     * @param  {String}    变换信息
     * @return {CSSMatrix} 变换矩阵对象
     */
    _p.__getCSSMatrix = (function(){
        var _reg0 = /\((.*?)\)/,
            _reg1 = /\s*,\s*/,
            _klss = ['CSSMatrix',_opfx.clz+'CSSMatrix'],
            _list = ['m11','m12','m21','m22','m41','m42'];
        // matrix(1,2,3,4,5,6)
        // -> {m11:1,m12:2,m21:3,m22:4,m41:5,m42:6}
        var _doParse = function(_matrix){
            var _obj = {};
            if (_reg0.test(_matrix||'')){
                // 11,12,21,22,41,42
                _u._$forEach(
                    RegExp.$1.split(_reg1),
                    function(_value,_index){
                        _obj[_list[_index]] = _value;
                    }
                );
            }
            return _obj;
        };
        return function(_matrix){
            var _mtrx;
            _u._$forIn(_klss,function(_name){
                if (!!this[_name]){
                    _mtrx = new this[_name](_matrix||'');
                    return !0;
                }
            });
            return !_mtrx?_doParse(_matrix):_mtrx;
        };
    })();
    /**
     * 注入样式
     * @param  {Node}   样式节点
     * @param  {String} 样式内容
     * @return {Void}
     */
    _p.__injectCSSText = function(_style,_css){
        _style.textContent = _css;
    };
    /**
     * 对样式进行预处理
     * @param  {String} 待处理样式内容
     * @return {String} 处理后样式内容
     */
    _p.__processCSSText = (function(){
        var _reg0 = /\$<(.*?)>/gi,
            _reg1 = /\{(.*?)\}/g,
            _pfx = '-'+_opfx.css.toLowerCase()+'-',
            _2dmap = {
                scale:'scale({x|1},{y|1})',
                rotate:'rotate({a})',
                translate:'translate({x},{y})',
                matrix:'matrix({m11},{m12},{m21},{m22},{m41},{m42})'
            },
            _3dmap  = {
                scale:'scale3d({x|1},{y|1},{z|1})',
                rotate:'rotate3d({x},{y},{z},{a})',
                translate:'translate3d({x},{y},{z})',
                matrix:'matrix3d({m11},{m12},{m13},{m14},{m21},{m22},{m23},{m24},{m31},{m32},{m33|1},{m34},{m41},{m42},{m43},{m44|1})'
            };
        // merge template and data
        var _getTransformValue = function(_tpl,_map){
            _map = _map||_o;
            return _tpl.replace(_reg1,function($1,$2){
                var _arr = $2.split('|');
                return _map[_arr[0]]||_arr[1]||'0';
            });
        };
        // process transform value
        _p.__processTransformValue = function(_name,_data){
            var _tpl = (!_ospt.css3d?_2dmap:_3dmap)[_name.trim()];
            if (!!_tpl){
                return _getTransformValue(_tpl,_data);
            }
            return '';
        };
        return function(_css){
            if (!_css.replace){
                return _css;
            }
            return _css.replace(_reg0,function($1,$2){
                // prefix for css3
                if ($2==='vendor'){
                    return _pfx;
                }
                // parse 3D value
                var _arr = ($2||'').split('|');
                return _p.__processTransformValue(
                    _arr[0],_u._$query2object(_arr[1])
                )||$1;
            });
        };
    })();
    /**
     * 追加CSS规则
     * @param  {Node}    样式节点
     * @param  {String}  单条样式规则
     * @return {CSSRule} 样式规则对象
     */
    _p.__appendCSSText = function(_element,_css){
        var _sheet = _element.sheet,
            _length = _sheet.cssRules.length;
        _sheet.insertRule(_css,_length);
        return _sheet.cssRules[_length];
    };
    /**
     * 取待验证的样式列表
     * @param  {String} 样式，多个以空格分隔
     * @return {Array}  样式列表
     */
    _p.__getClassList = (function(){
        var _reg = /\s+/;
        return function(_class){
            _class = (_class||'').trim();
            return !!_class?_class.split(_reg):null;
        };
    })();
    /**
     * 操作样式
     * @param  {Node}   节点
     * @param  {String} 操作
     * @param  {String} 样式
     * @return {Void}
     */
    _p.__processClassName = function(_element,_type,_class){
        if (_type=='replace'){
            _p.__processClassName(
                _element,'remove',_class
            );
            _p.__processClassName(
                _element,'add',arguments[3]
            );
            return;
        }
        _u._$forEach(
            _p.__getClassList(_class),
            function(_clazz){
                _element.classList[_type](_clazz);
            }
        );
    };
    /**
     * 检测节点是否包含指定样式，多个样式用空格分隔，检测时包含其中之一即表示包含
     * @param  {Node}    节点ID或者对象
     * @param  {String}  样式串
     * @return {Boolean} 是否含指定样式
     */
    _p.__hasClassName = function(_element,_class){
        var _list = _element.classList;
        if (!_list||!_list.length){
            return !1;
        }
        return _u._$indexOf(
            _p.__getClassList(_class),
            function(_clazz){
                return _list.contains(_clazz);
            }
        )>=0;
    };
    // for init
    (function(){
        if (!_ospt.css3d){
            var _matrix = _p.__getCSSMatrix();
            _ospt.css3d = !!_matrix&&_matrix.m41!=null;
        }
    })();

    return _p;
},'3f115371e3e07e18707a0c434f8a73ce','836fd3ea8c2cdd6a7842e1315a393abe');
I$('14b5c893dbb887324d0e4cb5659469e1',function(_h,_m,_u,_p,_o,_f,_r){if (_m._$KERNEL.engine==='trident'){I$('6022501a1e6725ef816600065123e62f',function (){
        /**
         * 取节点的子节点列表
         * @param  {Node} _element 节点ID或者对象
         * @return {Array}         子节点列表
         */
        _h.__getChildren = _h.__getChildren._$aop(
            function(_event){
                var _element = _event.args[0];
                if (!!_element.children) return;
                // hack children
                _event.stopped = !0;
                var _result = [];
                _u._$forEach(
                    _element.childNodes,
                    function(_node){
                        if (_node.nodeType==1){
                            _result.push(_node);
                        }
                    }
                );
                _event.value = _result;
            }
        );
    });}
if (_m._$KERNEL.engine==='trident'&&_m._$KERNEL.release<='6.0'){I$('999fa5584b695e20c62e1919bf3e474f',function (){
        /**
         * 设置、获取数据
         * @param {Node}     节点
         * @param {String}   标识
         * @param {Variable} 值
         */
        _h.__dataset = (function(){
            var _dataset = {},
                _tag = 'data-',
                _reg = /\-(.{1})/gi;
            // init element dataset
            var _init = function(_element){
                var _id = _element.id;
                if (!!_dataset[_id]) return;
                var _map = {};
                _u._$forEach(
                    _element.attributes,
                    function(_node){
                        var _key  = _node.nodeName;
                        if (_key.indexOf(_tag)!=0) return;
                        _key = _key.replace(_tag,'')
                                   .replace(_reg,function($1,$2){
                                        return $2.toUpperCase();
                                   });
                        _map[_key] = _node.nodeValue||'';
                    }
                );
                _dataset[_id] = _map;
            };
            return function(_element,_key,_value){
                _init(_element);
                var _set = _dataset[_element.id];
                if (_value!==undefined){
                    _set[_key] = _value;
                }
                return _set[_key];
            };
        })();
    });}
if (_m._$KERNEL.engine==='trident'&&_m._$KERNEL.release<='5.0'){I$('f68f949f01d9801093652ba264c51490',function (){
        // cache background image
        try{document.execCommand('BackgroundImageCache',!1,!0);}catch(e){}
        /**
         * 注入样式
         * @param  {Node}   样式节点
         * @param  {String} 样式内容
         * @return {Void}
         */
        _h.__injectCSSText = (function(){
            var _max = 30;
            return _h.__injectCSSText._$aop(function(_event){
                var _element = _event.args[0];
                if (!_element.styleSheet) return;
                _event.stopped = !0;
                var _css = _event.args[1];
                // ie9- has 31 style/link limitation
                var _list = document.styleSheets;
                if (_list.length>_max){
                    // bad performance
                    _element = _list[_max];
                    _css = _element.cssText + _css;
                }else{
                    _element = _element.styleSheet;
                }
                _element.cssText = _css;
            });
        })();
        /**
         * 取待验证的样式正则表达式
         * @param  {String} 样式，多个以空格分隔
         * @return {RegExp} 正则表达式
         */
        _h.__getClassRegExp = (function(){
            var _reg = /\s+/g;
            return function(_class){
                _class = (_class||'').trim().replace(_reg,'|');
                return !_class?null:new RegExp('(\\s|^)(?:'+_class+')(?=\\s|$)','g');
            };
        })();
        /**
         * 操作样式
         * @param  {Node}   节点
         * @param  {String} 操作
         * @param  {String} 样式
         * @return {Void}
         */
        _h.__processClassName = function(_element,_type,_class){
            _class = _class||'';
            var _name = _element.className||'',
                _xreg = _h.__getClassRegExp(
                    _class+' '+(arguments[3]||'')
                );
            // remove all calss
            var _result = _name;
            if (!!_xreg){
                _result = _result.replace(_xreg,'');
            }
            // parse added class
            switch(_type){
                case 'remove':
                    _class = '';
                break;
                case 'replace':
                    _class = arguments[3]||'';
                break;
            }
            // generate class result
            _result = (_result+' '+_class).trim();
            if (_name!=_result){
                _element.className = _result;
            }
        };
        /**
         * 检测节点是否包含指定样式，多个样式用空格分隔，检测时包含其中之一即表示包含
         * @param  {Node}    节点ID或者对象
         * @param  {String}  样式串
         * @return {Boolean} 是否含指定样式
         */
        _h.__hasClassName = function(_element,_class){
            var _xreg = _h.__getClassRegExp(_class);
            if (!!_xreg){
                return _xreg.test(_element.className||'');
            }
            return !1;
        };
    });}
if (_m._$KERNEL.engine==='trident'&&_m._$KERNEL.release<='4.0'){I$('522355909ce49871b14a325f3473be97',function (){
        /**
         * 根据类名取节点列表
         * @param  {Node}   节点ID或者对象
         * @param  {String} 类名
         * @return {Array}  节点列表
         */
        _h.__getElementsByClassName = function(_element,_class){
            var _result = [],
                _regexp = new RegExp('(\\s|^)(?:'+_class.replace(/\s+/g,'|')+')(?=\\s|$)');
            _u._$forEach(
                _element.getElementsByTagName('*'),
                function(_node){
                    if (_regexp.test(_node.className)){
                        _result.push(_node);
                    }
                }
            );
            return _result;
        };
        /**
         * 取下一个兄弟节点
         * @param  {Node}  节点对象
         * @return {Node}  节点
         */
        _h.__nextSibling = function(_element){
            while(_element=_element.nextSibling){
                if (_element.nodeType==1){
                    return _element;
                }
            }
        };
        /**
         * 取上一个兄弟节点
         * @param  {Node}  节点对象
         * @return {Node}  节点
         */
        _h.__previousSibling = function(_element){
            while(_element=_element.previousSibling){
                if (_element.nodeType==1){
                    return _element;
                }
            }
        };
        /**
         * 将dom节点转为xml串
         * @param  {Node}   节点
         * @return {String} XML代码
         */
        _h.__serializeDOM2XML = function(_dom){
            return ('xml' in _dom)?_dom.xml:_dom.outerHTML;
        };
        /**
         * 将xml转为dom节点
         * @param  {String} XML代码
         * @return {Node}   节点
         */
        _h.__parseDOMFromXML = (function(){
            // http://blogs.msdn.com/b/xmlteam/archive/2006/10/23/using-the-right-version-of-msxml-in-internet-explorer.aspx
            var _msxml = [
                'Msxml2.DOMDocument.6.0',
                'Msxml2.DOMDocument.3.0'
            ];
            var _getParser = function(){
                try{
                    for(var i=0,l=_msxml.length;i<l;i++){
                        return new ActiveXObject(_msxml[i]);
                    }
                }catch(ex){
                    return null;
                }
            };
            return function(_xml){
                var _parser = _getParser();
                if (!!_parser&&
                      _parser.loadXML(_xml)&&
                     !_parser.parseError.errorCode){
                    return _parser.documentElement;
                }
                return null;
            };
        })();
        /**
         * 取样式值
         * @param  {String|Node} 节点
         * @param  {String}      样式名称
         * @return {Variable}    样式值
         */
        _h.__getStyleValue = (function(){
            var _reg0 = /opacity\s*=\s*([\d]+)/i;
            var _fmap = {
                // get opacity from filter:alpha(opacity=50)
                opacity:function(_style){
                    var _result = 0;
                    if (_reg0.test(_style.filter||'')){
                        _result = parseFloat(RegExp.$1)/100;
                    }
                    return _result;
                }
            };
            return function(_element,_name){
                var _current = _element.currentStyle,
                    _func = _fmap[_name];
                if (!!_func){
                    return _func(_current);
                }
                return _current[_h.__getStyleName(_name)]||'';
            };
        })();
        /**
         * 设置样式
         * @param  {String|Node} 节点
         * @param  {String}      样式名称
         * @param  {String}      样式值
         * @return {Void}
         */
        _h.__setStyleValue = (function(){
            var _fmap = {
                // opacity -> filter:alpha(opacity=50)
                opacity:function(_element,_value){
                    _element.style.filter = 'alpha(opacity='+_value*100+')';
                }
            };
            return function(_element,_name,_value){
                var _func = _fmap[_name];
                if (!!_func){
                    _func(_element,_value);
                }else{
                    _element.style[_h.__getStyleName(_name)] = _value;
                }
            };
        })();
        /**
         * 追加CSS规则
         * @param  {Node}    样式节点
         * @param  {String}  单条样式规则
         * @return {CSSRule} 样式规则对象
         */
        _h.__appendCSSText = function(_element,_css){
            var _sheet = _element.styleSheet,
                _length = _sheet.rules.length,
                _arr = _css.split(/[\{\}]/);
            _sheet.addRule(_arr[0],_arr[1],_length);
            return _sheet.rules[_length];
        };
     });}
if (_m._$KERNEL.engine==='trident'&&_m._$KERNEL.release<='3.0'){I$('311487acffbbf7320a195d1661490355',function (){
        /**
         * 取节点属性值
         * @param  {Node}   节点
         * @param  {String} 属性名
         * @return {String} 属性值
         */
        _h.__getAttribute =
        _h.__getAttribute._$aop(null,function(_event){
            // fix ie7 maxlength default value 2147483647
            var _args = _event.args;
            if (_args[1]=='maxlength'&&
                _event.value==2147483647){
                _event.value = null;
            }
        });
    });}
if (_m._$KERNEL.engine==='trident'&&_m._$KERNEL.release<='2.0'){I$('bc3a6303b539b5d4aa93f02a6d95b1da',function (){
        /**
         * 节点占全屏
         * @param  {Node}   节点
         * @param  {Object} 视窗模型
         * @return {Void}
         */
        _h.__fullScreen = function(_element,_viewport){
            var _style = _element.style;
            _style.width = _viewport.scrollWidth+'px';
            _style.height = _viewport.scrollHeight+'px';
        };
        /**
         * 为节点增加用于盖select/flash等控件的层
         * @param  {Node} 节点
         * @return {Void}
         */
        _h.__mask = (function(){
            var _cache = {};
            // remove mask
            _h.__unmask = function(_element){
                var _id = _element.id,
                    _mask = _cache[_id];
                if (!!_mask){
                    delete _cache[_id];
                    _mask.parentNode.removeChild(_mask);
                }
            };
            // append mask
            return function(_element){
                var _id = _element.id,
                    _mask = _cache[_id];
                // create mask
                if (!_mask){
                    _mask = document.createElement('iframe');
                    _mask.style.position = 'absolute';
                    _cache[_id] = _mask;
                }
                // sync mask size
                var _style1 = _mask.style,
                    _style0 = _element.style;
                _style1.top = (parseInt(_style0.top)||0)+'px';
                _style1.left = (parseInt(_style0.left)||0)+'px';
                _style1.width = _element.offsetWidth+'px';
                _style1.height = _element.offsetHeight+'px';
                _element.insertAdjacentElement('beforeBegin',_mask);
                return _mask;
            };
        })();
    });}
if (_m._$KERNEL.engine==='gecko'){I$('09d748deda0a65852b8eec5c673b51c3',function (){
        if (!_m._$SUPPORT.css3d){
            _m._$SUPPORT.css3d = 'MozPerspective' in document.body.style;
        }
        if (!('insertAdjacentElement' in document.body)){
            HTMLElement.prototype.insertAdjacentElement = function(_where,_element){
                if (!_where||!_element) return;
                switch(_where){
                    case 'beforeEnd'  :
                        this.appendChild(_element);
                    return;
                    case 'beforeBegin':
                        this.parentNode.insertBefore(_element,this);
                    return;
                    case 'afterBegin' :
                        !this.firstChild
                        ?this.appendChild(_element)
                        :this.insertBefore(_element,this.firstChild);
                    return;
                    case 'afterEnd'   :
                        !this.nextSibling
                        ?this.parentNode.appendChild(_element)
                        :this.parentNode.insertBefore(_element,this.nextSibling);
                    return;
                }
            };
        }
        if (!('innerText' in document.body)){
            HTMLElement.prototype['__defineGetter__']("innerText",function(){return this.textContent;});
            HTMLElement.prototype['__defineSetter__']("innerText",function(_content){this.textContent = _content;});
        }
    });}return _h;},'213d44e8c551a556a0e0da3aeb0c5e49','836fd3ea8c2cdd6a7842e1315a393abe','3f115371e3e07e18707a0c434f8a73ce');
I$('15fb3eeb129e67b9b1cc98ef8ea8e26d',function (NEJ,_g,_u,_v,_x,_h,_p,_o,_f,_r){
    // variables
    var _y = {},     // chainable methods
        _cspol,      // css text pool
        _empol = {}, // elements without id property, eg. document,window
        _dirty = {}, // temporary element with id
        _fragment = document.createDocumentFragment(); // node in memory
    // init
    if (!document.head){
         document.head = document.getElementsByTagName('head')[0]||document.body;
    }
    // only for test
    _p.dump = function(){
        return {
            pool:_empol,
            dirty:_dirty,
            fragment:_fragment
        };
    };
    /**
     * 为节点设置一个唯一的标识
     *
     * 结构举例
     * ```html
     *    <div id="abc">aaaaa</div>
     * ```
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/element'
     *   ],function(_e){
     *       // 如果有id，返回原来的id,否则返回auto-id-12345678(8位随机字符串)
     *       var _id = _e._$id(_node||"abc");
     *   });
     * ```
     *
     * @method module:base/element._$id
     * @param  {String|Node} arg0 - 节点标识或者对象
     * @return {String}             节点标识
     */
    /**
     * @method CHAINABLE._$id
     * @see module:base/element._$id
     */
    _p._$id =
    _y._$id = function(_element){
        _element = _p._$get(_element);
        if (!_element) return;
        var _id = !!_element.id ? _element.id
                : 'auto-id-'+_u._$uniqueID();
        if (!('id' in _element)){
            _empol[_id] = _element;
        }
        _element.id = _id;
        // check if element can be getted
        if (!_p._$get(_id)){
            _dirty[_id] = _element;
        }
        return _id;
    };
    /**
     * 根据标识取节点对象，包括在内存中的节点
     *
     * 结构举例
     * ```html
     *   <div id="abc">123</div>
     * ```
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/element'
     *   ],function(_e){
     *       // 先根据id从内存中取，再从页面取
     *       var _node = _e._$get("abc");
     *   });
     * ```
     *
     * @method module:base/element._$get
     * @param  {String|Node} arg0 - 节点标识或者对象
     * @return {Node}               节点对象
     */
    _p._$get = function(_element){
        // for document/window
        // fix dirty window object in mac safari
        try{
            var _node = _empol[''+_element];
        }catch(ex){
            // ignore
        }
        if (!!_node){
            return _node;
        }
        // element is node
        if (!_u._$isString(_element)&&
            !_u._$isNumber(_element)){
            return _element;
        }
        // element is id
        // check node in page first
        var _node = document.getElementById(_element);
        if (!_node){
            _node = _h.__getElementById(_fragment,_element);
        }
        // remove dirty element
        if (!!_node){
            delete _dirty[_element];
        }
        return _node||_dirty[_element];
    };
    /**
     * 取节点的子节点列表
     *
     * 结构举例
     * ```html
     *   <div id="abc">
     *       <p>1</p>
     *       <p><span>2</span></p>
     *       <p>3</p>
     *   </div>
     * ```
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/element'
     *   ],function(_e){
     *       // 取直接的3个子节点(p标签)
     *       var _childs = _e._$getChildren('abc');
     *
     *       // 使用类名过滤，去带a或者b样式类的子节点
     *       var _childs = _e._$getChildren('abc','a b');
     *   });
     * ```
     *
     * @method module:base/element._$getChildren
     * @param  {String|Node} arg0 - 节点标识或者对象
     * @param  {String}      arg1 - 样式标识
     * @return {Array}              子节点列表
     */
    /**
     * @method CHAINABLE._$getChildren
     * @see module:base/element._$getChildren
     */
    _p._$getChildren =
    _y._$getChildren = function(_element,_clazz){
        _element = _p._$get(_element);
        if (!_element) return null;
        var _list = _h.__getChildren(_element);
        if (!!_clazz){
            _u._$reverseEach(
                _list,function(_node,_index,_list){
                    if (!_p._$hasClassName(_node,_clazz)){
                        _list.splice(_index,1);
                    }
                }
            );
        }
        return _list;
    };
    /**
     * 根据过滤条件取第一个满足条件的父节点
     *
     * 结构举例
     * ```html
     *   <div data-a="aaa">
     *       <p>1</p>
     *       <div a="aaaaaa">
     *           <p class="a">
     *               <span id="abc">2</span>
     *           </p>
     *       </div>
     *       <p>3</p>
     *   </div>
     * ```
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/element'
     *   ],function(_e){
     *       // 返回包含样式a的节点 <p class="a">
     *       var node = _e._$getParent('abc','c:a');
     *
     *       // 返回包含属性a的节点 <div a="aaaaaa">
     *       var node = _e._$getParent('abc','a:a')
     *
     *       // 返回包含data属性a的节点 <div data-a="aaa">
     *       var node = _e._$getParent('abc','d:a');
     *
     *       // 返回标签为p的节点 <p class="a">
     *       var node = _e._$getParent('abc','t:p');
     *
     *       // 返回符合过滤条件的父节点
     *       var node = _e._$getParent('abc',function(_element){
     *           return _element.scrollHeight>_element.clientHeight;
     *       });
     *   });
     * ```
     *
     * @method module:base/element._$getChildren
     * @param  {String|Node}      arg0 - 节点标识或者对象
     * @param  {String|Function}  arg1 - 过滤规则
     * @return {Node}             父节点
     */
    _p._$getParent = (function(){
        var _exmap;
        var _doFilter = function(_name,_element){
            var _arr = _name.split(':');
            if (_arr.length>1){
                if (!_exmap){
                    _exmap = {
                        a:_p._$attr,
                        d:_p._$dataset,
                        c:_p._$hasClassName,
                        t:function(n,v){return (n.tagName||'').toLowerCase()===v;}
                    };
                }
                var _check = _exmap[_arr[0]];
                if (!!_check){
                    return !!_check(_element,_arr[1]);
                }
                _name = _arr[1];
            }
            return !!_p._$attr(_element,_name)||
                   !!_p._$dataset(_element,_name)||
                     _p._$hasClassName(_element,_name);
        };
        return function(_element,_filter){
            _element = _p._$get(_element);
            if (!_element){
                return;
            }
            if (!_filter){
                return _element;
            }
            if (_u._$isString(_filter)){
                _filter = _doFilter._$bind(null,_filter);
            }
            if (_u._$isFunction(_filter)){
                while(_element){
                    if (!!_filter(_element)){
                        return _element;
                    }
                    _element = _element.parentNode;
                }
                return null;
            }
            return _element;
        };
    })();
    /**
     * 根据类名取节点列表
     *
     * 结构举例
     * ```html
     *   <div id="abc">
     *     <p class="item">1</p>
     *     <div><p class="item">2</p></div>
     *     <p class="item">3</p>
     *   </div>
     * ```
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/element'
     *   ],function(_e){
     *       // 获取abc节点下样式带有"item"的节点列表,如果没有父节点，返回null
     *       var _list = _e._$getByClassName('abc','item');
     *   });
     * ```
     *
     * @method module:base/element._$getByClassName
     * @param  {String|Node} arg0 - 节点标识或者对象
     * @param  {String}      arg1 - 类名
     * @return {Array}              节点列表
     */
    /**
     * @method CHAINABLE._$getByClassName
     * @see module:base/element._$getByClassName
     */
    _p._$getByClassName =
    _y._$getByClassName = function(_element,_class){
        _element = _p._$get(_element);
        return !_element ? null :
                _h.__getElementsByClassName(
                    _element,_class.trim()
                );
    };
    /**
     * 根据从兄弟节点中搜索符合条件的节点
     *
     * 结构举例
     * ```html
     *   <div>
     *     <p class="item" id="a1">1</p>
     *     <p class="item" id="a2">2</p>
     *     <p class="item" id="a3">3</p>
     *   </div>
     * ```
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/element'
     *   ],function(_e){
     *       // 取a2的后一个兄弟节点a3
     *       var _node = _e._$getSibling('a2');
     *
     *       // 取a2的前一个兄弟节点a1
     *       var _node = _e._$getSibling('a2',{backward:true});
     *
     *       // 过滤搜索，从a2向后搜索找id为a4的节点
     *       var _node = _e._$getSibling('a2',function(_element){
     *           return _element.id=='a4'
     *       });
     *
     *       // 过滤搜索，从a2向前搜索找id为a0的节点
     *       var _node = _e._$getSibling('a2',{
     *           backward:true,
     *           filter:function(_element){
     *               return _element.id=='a0'
     *           }
     *       });
     *   });
     * ```
     *
     * @method   module:base/element._$getSibling
     * @param    {String|Node}     arg0     - 节点标识或者对象
     * @param    {Function|Object} arg1     - 如果是函数则表示过滤器，否则为配置信息
     * @property {Boolean}         backward - 是否后向搜索，默认前向搜索
     * @property {Function}        filter   - 节点过滤器，返回true表示需要返回的节点，找到第一个即返回
     * @return   {Node}                       符合条件的节点
     */
    /**
     * @method CHAINABLE._$getSibling
     * @see module:base/element._$getSibling
     */
    _p._$getSibling =
    _y._$getSibling = (function(){
        var _doFilter = function(){
            return !0;
        };
        return function(_element,_filter){
            _element = _p._$get(_element);
            if (!_element){
                return null;
            }
            var _conf = {
                backward:!1,
                filter:_doFilter
            };
            if (_u._$isFunction(_filter)){
                _conf.filter = _filter;
            }else{
                _conf = _u._$fetch(_conf,_filter);
            }
            var _next = _conf.backward
                      ? _h.__previousSibling
                      : _h.__nextSibling;
            while(_element=_next(_element)){
                if (_conf.filter(_element)){
                    break;
                }
            }
            return _element;
        };
    })();
    /**
     * 取节点所在的滚动容器，
     * 从当前节点开始往上遍历，直到出现滚动条的节点
     *
     * 结构举例
     * ```html
     *   <div id="efg">
     *     <div id="abc">123</div>
     *   </div>
     * ```
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/element'
     *   ],function(_e){
     *       // 加入efg节点出现滚动条，则这里找到的是efg节点
     *       var _sbody = _e._$getScrollViewPort('abc');
     *
     *       // 不带任何参数取页面滚动条所在节点
     *       var _sbody = _e._$getScrollViewPort();
     *   });
     * ```
     *
     * @method module:base/element._$getScrollViewPort
     * @param  {String|Node} arg0 - 节点标识或者对象
     * @return {Node}               视窗节点
     */
    _p._$getScrollViewPort = function(_element){
        _element = _p._$get(_element);
        if (!!_element){
            _element = _element.parentNode;
            while(!!_element){
                if (_element.scrollHeight>
                    _element.clientHeight){
                    break;
                }
                _element = _element.parentNode;
            }
            if (!!_element){
                return _element;
            }
        }
        var _tmp1 = document.body.scrollHeight,
            _tmp2 = document.documentElement.scrollHeight;
        return _tmp2>=_tmp1?document.documentElement:document.body;
    };
    /**
     * 盒模型结构
     *
     * @typedef  {Object} module:base/element~BoxModel
     * @property {Number} scrollTop    - 滚动垂直偏移
     * @property {Number} scrollLeft   - 滚动水平偏移
     * @property {Number} clientWidth  - 页面可视宽度
     * @property {Number} clientHeight - 页面可视高度
     * @property {Number} scrollWidth  - 页面滚动宽度
     * @property {Number} scrollHeight - 页面滚动高度
     */
    /**
     * 取页面盒信息，返回盒信息内容：
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/element'
     *   ],function(_e){
     *       // 返回信息见说明
     *       var _box = _e._$getPageBox();
     *   });
     * ```
     *
     * @method module:base/element._$getPageBox
     * @param  {Document} arg0 - 文档对象
     * @return {module:base/element~BoxModel} 盒信息
     */
    _p._$getPageBox = (function(){
        // get min value but not zero
        var _getClientBox = function(_list){
            var _result = 0;
            _u._$forEach(
                _list,function(_size){
                    if (!_size) return;
                    if (!_result){
                        _result = _size;
                    }else{
                        _result = Math.min(_result,_size);
                    }
                }
            );
            return _result;
        };
        var _farr = [
            {
                main:'scroll',
                sub:['Top','Left'],
                func:function(_key,_body0,_body1){
                    return Math.max(
                        _body0['scroll'+_key],
                        _body1['scroll'+_key]
                    );
                }
            },
            {
                main:'client',
                sub:['Width','Height'],
                func:function(_key,_body0,_body1){
                    return _getClientBox([
                        _body0['client'+_key],
                        _body0['offset'+_key],
                        _body1['client'+_key],
                        _body1['offset'+_key]
                    ]);
                }
            },
            {
                main:'scroll',
                sub:['Width','Height'],
                func:function(_key,_body0,_body1,_result){
                    return Math.max(
                        _result['client'+_key],
                        _body0['scroll'+_key],
                        _body1['scroll'+_key]
                    );
                }
            }
        ];
        return function(_document){
            var _result = {},
                _doc   = _document||document,
                _body0 = _doc.body,
                _body1 = _doc.documentElement;
            _u._$forEach(
                _farr,function(_item){
                    var _main = _item.main;
                    _u._$forEach(
                        _item.sub,function(_key){
                            _result[_main+_key] = _item.func(
                                _key,_body0,_body1,_result
                            );
                        }
                    );
                }
            );
            return _result;
        };
    })();
    /**
     * 按比例将给定大小缩放至限制区域内
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/element'
     *   ],function(_e){
     *       // 限制区域大小 100*10
     *       var _limit = {width:100,height:10};
     *
     *       // 给定200*10的大小，由于宽度超出，缩放后为{width:100,height:5}
     *       var _box = _e._$getMaxBox({width:200,height:10},_limit);
     *
     *       // 给定100*20的大小，由于高度超出，缩放后为{width:50,height:10}
     *       var _box = _e._$getMaxBox({width:100,height:20},_limit);
     *
     *       // 给定 50*5，没有超出限制，返回{width:50,height:5}
     *       var _box = _e._$getMaxBox({width:50,height:5},_limit);
     *   });
     * ```
     *
     * @method   module:base/element._$getMaxBox
     * @param    {module:base/element~SizeModel} arg0 - 原始大小
     * @param    {module:base/element~SizeModel} arg1 - 最大限制大小
     * @return   {module:base/element~SizeModel}        按比例计算出的最大值信息
     */
    _p._$getMaxBox = function(_org,_max){
        var _result = _u._$merge({},_org),
            _mrto = _max.width/_max.height,
            _orto = _org.width/_org.height;
        // height overflow
        if (_mrto>_orto&&
            _org.height>_max.height){
            _result.height = _max.height;
            _result.width = _result.height*_orto;
        }
        // width overflow
        if (_mrto<_orto&&
            _org.width>_max.width){
            _result.width = _max.width;
            _result.height = _result.width/_orto;
        }
        return _result;
    };
    /**
     * 滚动到指定节点
     *
     * 结构举例
     * ```html
     *   <div id="a" style="padding:5px 0 0 10px;"></div>
     * ```
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/element'
     *   ],function(_e){
     *       // 滚动到页面上a这节点的位置
     *       _e._$scrollTo('a');
     *   });
     * ```
     *
     * @method module:base/element._$scrollTo
     * @param  {Node|String} arg0 - 节点
     * @return {Void}
     */
    /**
     * @method CHAINABLE._$scrollTo
     * @see module:base/element._$scrollTo
     */
    _p._$scrollTo =
    _y._$scrollTo = function(_element){
        var _offset = _p._$offset(_element);
        window.scrollTo(_offset.x,_offset.y);
    };
    /**
     * 大小信息对象
     * @typedef  {Object} module:base/element~SizeModel
     * @property {Number} width  - 宽度
     * @property {Number} height - 高度
     */
    /**
     * 位置信息对象
     * @typedef  {Object} module:base/element~PositionModel
     * @property {Number} top  - 垂直位置
     * @property {Number} left - 水平位置
     */
    /**
     * 计算在容器中对齐时的位置信息
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/element'
     *   ],function(_e){
     *       // 容器大小
     *       var _box = {width:100,height:40};
     *
     *       // 默认居中对齐返回 {top:15,left:40}
     *       var _pos = _e._$align(_box,{width:20,height:10});
     *
     *       // 左下对齐返回 {top:30,left:0}
     *       var _pos = _e._$align(_box,{width:20,height:10},'left bottom');
     *   });
     * ```
     *
     * @method module:base/element._$align
     * @param  {module:base/element~SizeModel} arg0 - 容器大小
     * @param  {module:base/element~SizeModel} arg1 - 原始大小
     * @param  {String} arg2 - 对齐方式，水平+空格+垂直，如left top，默认为 center middle，
     *                         水平：left/center/right，
     *                         垂直：top/middle/bottom
     * @return {module:base/element~PositionModel} 位置信息
     */
    _p._$align = (function(){
        var _reg = /\s+/;
        var _fmap = {
            left:function(){
                return 0;
            },
            center:function(_box,_org){
                return (_box.width-_org.width)/2;
            },
            right:function(_box,_org){
                return _box.width-_org.width;
            },
            top:function(){
                return 0;
            },
            middle:function(_box,_org){
                return (_box.height-_org.height)/2;
            },
            bottom:function(_box,_org){
                return _box.height-_org.height;
            }
        };
        return function(_box,_org,_align){
            var _result = {},
                _arr  = (_align||'').split(_reg),
                _top  = _fmap[_arr[1]]||_fmap.middle,
                _left = _fmap[_arr[0]]||_fmap.center;
            _result.top = _top(_box,_org);
            _result.left = _left(_box,_org);
            return _result;
        };
    })();
    /**
     * 计算两个节点之间的偏移量
     *
     * 结构举例
     * ```html
     *   <div id="a" style="position:relative;padding:5px 0 0 10px;">
     *     <span id="b">123</span>
     *   </div>
     * ```
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/element'
     *   ],function(_e){
     *       // 计算节点b到节点a(外层需要定位属性)的距离，如果没有指定节点，默认计算的根节点
     *       // _result : {x:10,y:5}
     *       var _result = _e._$offset('b','a');
     *   });
     * ```
     *
     * @method module:base/element._$offset
     * @param  {String|Node} arg0 - 起始节点
     * @param  {String|Node} arg1 - 结束节点，没有该参数则计算到根节点
     * @return {Object}             偏移量，如{x:234,y:987}
     */
    /**
     * @method CHAINABLE._$offset
     * @see module:base/element._$offset
     */
    _p._$offset =
    _y._$offset = (function(){
        var _isRoot = function(_element){
            return _element==document.body||
                   _element==document.documentElement;
        };
        return function(_from,_to){
            _from = _p._$get(_from);
            if (!_from){
                return null;
            }
            _to = _p._$get(_to)||null;
            var _node = _from,
                _result = {x:0,y:0},
                _isroot,_delta,_border;
            while(!!_node&&_node!=_to){
                _isroot = _isRoot(_node)||_node==_from;
                _delta = _isroot?0:_node.scrollLeft;
                _border = parseInt(_p._$getStyle(_node,'borderLeftWidth'))||0;
                _result.x += _node.offsetLeft+_border-_delta;
                _delta = _isroot?0:_node.scrollTop;
                _border = parseInt(_p._$getStyle(_node,'borderTopWidth'))||0;
                _result.y += _node.offsetTop+_border-_delta;
                _node = _node.offsetParent;
            }
            return _result;
        };
    })();
    /**
     * 节点占全屏
     *
     * @method module:base/element._$fullScreen
     * @param  {Node} arg0 - 节点
     * @return {Void}
     */
    /**
     * @method CHAINABLE._$fullScreen
     * @see module:base/element._$fullScreen
     */
    _p._$fullScreen =
    _y._$fullScreen = function(_element){
        _element = _p._$get(_element);
        if (!!_element){
            _h.__fullScreen(
                _element,
                _p._$getPageBox()
            );
        }
    };
    /**
     * 为节点增加用于盖select/flash等控件的层
     *
     * @method module:base/element._$mask
     * @see    module:base/element._$unmask
     * @param  {Node} arg0 - 节点
     * @return {Node}        盖层节点
     */
    /**
     * @method CHAINABLE._$mask
     * @see module:base/element._$mask
     */
    _p._$mask =
    _y._$mask = function(_element){
        _element = _p._$get(_element);
        if (!!_element){
            _p._$id(_element);
            return _h.__mask(_element);
        }
        return null;
    };
    /**
     * 为节点移除用于盖select/flash等控件的层
     *
     * @method module:base/element._$unmask
     * @see    module:base/element._$mask
     * @param  {Node} arg0 - 节点
     * @return {Node}        盖层节点
     */
    /**
     * @method CHAINABLE._$unmask
     * @see module:base/element._$unmask
     */
    _p._$unmask =
    _y._$unmask = function(_element){
        _element = _p._$get(_element);
        if (!!_element){
            _p._$id(_element);
            return _h.__unmask(_element);
        }
        return null;
    };
    /**
     * 创建节点，使用该接口创建的结构后续可通过_$get接口根据ID取到节点
     *
     * 结构举例
     * ```javascript
     *   <div id="abc">1</div>
     * ```
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/element'
     *   ],function(_e){
     *       // 创建一个节点，挂到body上
     *       _e._$create("div","m-body",document.body);
     *
     *       // 创建一个节点挂到id是abc的节点上
     *       // 结果：<div id="abc">1<p class="m-list"></p></div>
     *       _e._$create("p","m-list","abc");
     * 
     *       // 创建一个节点放在内存中
     *       var _node = _e._$create('div');
     *       _node.innerHTML = '<p id="a">aaaaaa</p><p id="b">bbbbbb</p>';
     *       // 后续可以通过id取id为a的节点
     *       var _pa = _e._$get('a');
     *   });
     * ```
     *
     * @method module:base/element._$create
     * @param  {String}      arg0 - 标签
     * @param  {String}      arg1 - 样式
     * @param  {String|Node} arg2 - 父节点标识或者对象
     * @return {Node}               节点
     */
    _p._$create = (function(){
        var _map = {
            a:{href:'#',hideFocus:!0},
            style:{type:'text/css'},
            link:{type:'text/css',rel:'stylesheet'},
            iframe:{frameBorder:0},
            script:{defer:!0,type:'text/javascript'}
        };
        return function(_tag,_class,_parent){
            var _element = document.createElement(_tag),
                _config = _map[_tag.toLowerCase()];
            _u._$merge(_element,_config);
            if (!!_class) _element.className = _class;
            _parent = _p._$get(_parent);
            if (!!_parent){
                _parent.appendChild(_element);
            }else{
                // append to documentfragment for get by id
                if (!_config){
                    _fragment.appendChild(_element);
                }
            }
            return _element;
        };
    })();
    /**
     * 创建可交互框架
     *
     * 结构举例
     * ```html
     *   <div id="frameCnt"></div>
     * ```
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/element'
     *   ],function(_e){
     *      var _xFrame = _e._$createXFrame({
     *          src:'http://www.baidu.com',
     *          name:'百度',
     *          parent:'frameCnt',
     *          visible:false,
     *          onload:function(){
     *              // 加载frame成功后，name设置成功，为百度
     *              // 加载frame成功后，显示效果正确，display:none
     *          }
     *      });
     *   });
     * ```
     *
     * @method   module:base/element._$createXFrame
     * @param    {Object}               arg0    - 可选配置参数
     * @property {String}               src     - 框架地址
     * @property {String}               name    - 框架名称
     * @property {String|Node|Function} parent  - 父节点或者框架加入父容器的执行函数
     * @property {Boolean}              visible - 是否可见
     * @property {Function}             onload  - 框架载入回调
     * @return {Node}                             框架节点
     */
    _p._$createXFrame = (function(){
        var _getFrameSrc = function(){
            if (location.hostname==document.domain){
                return 'about:blank';
            }
            return 'javascript:(function(){document.open();document.domain="'+document.domain+'";document.close();})();';
        };
        var _getFrameWithName = function(_name){
            _name = _name.trim();
            if (!_name){
                return _p._$create('iframe');
            }
            // pass name to frame
            var _iframe;
            try{
                _iframe = document.createElement(
                          '<iframe name="'+_name+'"></iframe>');
                _iframe.frameBorder = 0;
            }catch(e){
                _iframe = _p._$create('iframe');
                _iframe.name = _name;
            }
            return _iframe;
        };
        return function(_options){
            _options = _options||_o;
            var _iframe = _getFrameWithName(_options.name||'');
            if (!_options.visible){
                _iframe.style.display = 'none';
            }
            if (_u._$isFunction(_options.onload)){
                _v._$addEvent(_iframe,'load',function(_event){
                    if (!_iframe.src) return;
                    _v._$clearEvent(_iframe,'load');
                    _options.onload(_event);
                });
            }
            // will trigger onload
            var _parent = _options.parent;
            if (_u._$isFunction(_parent)){
                try{_parent(_iframe);}catch(e){}
            }else{
                (_p._$get(_parent)||document.body).appendChild(_iframe);
            }
            // ensure trigger onload async
            var _src = _options.src||_getFrameSrc();
            window.setTimeout(function(){
                _iframe.src = _src;
            },0);
            return _iframe;
        };
    })();
    /**
     * 删除节点
     *
     * 结构举例
     * ```html
     *   <div id="abc">123</div>
     * ```
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/element'
     *   ],function(_e){
     *       // 移除节点前先清理节点上的事件
     *       _e._$remove('abc',false);
     *       // 移除节点前不清理节点上的事件
     *       _e._$remove('abc',true);
     *   });
     * ```
     *
     * @method module:base/element._$remove
     * @see    module:base/element._$removeByEC
     * @param  {String|Node} arg0 - 节点标识或者对象
     * @param  {Boolean}     arg1 - 是否禁止事件清理
     * @return {Void}
     */
    /**
     * @method CHAINABLE._$remove
     * @see module:base/element._$remove
     */
    _p._$remove =
    _y._$remove = (function(){
        var _fmap = {
            img:function(_node){
                _node.src = _g._$BLANK_IMAGE;
            },
            iframe:function(_node){
                _node.src = 'about:blank';
            }
        };
        var _doClear = function(_node,_tag){
            if (!_tag){
                var _xtag = (_node.tagName||'').toLowerCase(),
                    _func = _fmap[_xtag];
                if (!!_func){
                    _func(_node);
                }
                return;
            }
            if (!!_node.getElementsByTagName){
                _u._$forEach(
                    _node.getElementsByTagName(_tag),
                    _doClear
                );
            }
        };
        return function(_element){
            _element = _p._$get(_element);
            if (!!_element){
                // clear events
                if (!arguments[1]){
                    _v._$clearEvent(_element);
                }
                // clear elements
                _doClear(_element);
                _doClear(_element,'img');
                _doClear(_element,'iframe');
                // remove node
                if (!!_element.parentNode){
                    _element.parentNode.removeChild(_element);
                }
            }
        };
    })();
    /**
     * 节点移至内存
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/element'
     *   ],function(_e){
     *       // 先生成一个节点加到body下
     *       var _node = _e._$create('div','js-div',document.body);
     *       // 把节点移动到内存中
     *       _e._$removeByEC(_node);
     *       // 从body上没有取到节点,结果为[]
     *       _e._$getByClassName(document.body,'js-div');
     *   });
     * ```
     *
     * @method module:base/element._$removeByEC
     * @see    module:base/element._$remove
     * @param  {String|Node} arg0 - 节点标识或者对象
     * @return {Void}
     */
    /**
     * @method CHAINABLE._$removeByEC
     * @see module:base/element._$removeByEC
     */
    _p._$removeByEC =
    _y._$removeByEC = function(_element){
        _element = _p._$get(_element);
        if (!!_element){
            try{
                _fragment.appendChild(_element);
            }catch(ex){
                // ignore
                console.error(ex);
            }
        }
    };
    /**
     * 清除所有子节点
     *
     * 结构举例
     * ```html
     *   <ul id="abc">
     *     <li>aaaaaaaaaaaaa</li>
     *     <li>bbbbbbbbbbbbb</li>
     *     <li>ccccccccccccc</li>
     *   </ul>
     *
     *   <table id="efg">
     *     <tr><td>1111</td><td>1111</td></tr>
     *     <tr><td>2222</td><td>2222</td></tr>
     *     <tr><td>3333</td><td>3333</td></tr>
     *   </table>
     * ```
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/element'
     *   ],function(_e){
     *       // 清除ul下的子节点
     *       _e._$clearChildren('abc');
     *
     *       // 清除table下的子节点
     *       _e._$clearChildren('efg');
     *   });
     * ```
     *
     * @method module:base/element._$clearChildren
     * @see    module:base/element._$remove
     * @param  {String|Node} arg0 - 容器节点
     * @return {Void}
     */
    /**
     * @method CHAINABLE._$clearChildren
     * @see module:base/element._$clearChildren
     */
    _p._$clearChildren =
    _y._$clearChildren = function(_element){
        _element = _p._$get(_element);
        if (!!_element){
            _u._$reverseEach(
                _element.childNodes,
                function(_node){
                    _p._$remove(_node);
                }
            );
        }
    };
    /**
     * 内联元素增加定位封装
     *
     * 结构举例
     * ```html
     *   <input type="text" id="abc"/>
     * ```
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/element'
     *   ],function(_e){
     *       // 包装定位的span
     *       _e._$wrapInline('abc');
     *   });
     * ```
     *
     * 生成结构如下
     * ```html
     *   <span style="position:relative;zoom:1">
     *     <input type="text" id="abc"/>
     *     <!-- 此api返回以下这个节点 -->
     *     <span style="position:absolute;top:0;left:0;"></span>
     *   </span>
     * ```
     *
     * 应用举例
     * ```javascript
     *   NEJ.define([
     *       'base/element'
     *   ],function(_e){
     *       // 返回容器的样式名称
     *       // 通过这个样式名称可以取到一个绝对定位的样式名 class+'-show'
     *       var _node = _e._$wrapInline('abc',{
     *           tag:'label',
     *           clazz:'js-xxx'
     *       });
     *       // 可以在返回的节点里添加想要显示的结构
     *       _node.innerHTML = '<span>aaa</span><span>aaa</span>';
     *   });
     * ```
     *
     * @method   module:base/element._$wrapInline
     * @param    {String|Node}  arg0  - 内联节点
     * @param    {Object}       arg1  - 绝对定位节点配置信息
     * @property {String}       tag   - 标记名称，默认span
     * @property {String}       nid   - 节点识别样式名，这个会被添加到样式中作为标识
     * @property {String}       clazz - 样式名称
     * @return   {Node}                 绝对定位的节点
     */
    /**
     * @method CHAINABLE._$wrapInline
     * @see module:base/element._$wrapInline
     */
    _p._$wrapInline =
    _y._$wrapInline = (function(){
        var _clazz,
            _reg0 = /\s+/;
        var _doInitStyle = function(){
            if (!!_clazz) return;
            _clazz = _p._$pushCSSText('.#<uispace>{position:relative;zoom:1;}.#<uispace>-show{position:absolute;top:0;left:100%;cursor:text;white-space:nowrap;overflow:hidden;}');
            _p._$dumpCSSText();
        };
        return function(_element,_options){
            _element = _p._$get(_element);
            if (!_element){
                return null;
            }
            // init style
            _doInitStyle();
            _options = _options||_o;
            // check relative parent
            var _parent = _element.parentNode;
            if (!_p._$hasClassName(_parent,_clazz)){
                // build wrapper box
                _parent = _p._$create('span',_clazz);
                _element.insertAdjacentElement('beforeBegin',_parent);
                _parent.appendChild(_element);
            }
            // check absolute node
            var _nid = _options.nid||'',
                _node = _p._$getByClassName(
                    _parent,_nid||
                   (_clazz+'-show')
                )[0];
            if (!_node){
                var _klass = ((_options.clazz||'')+' '+_nid).trim();
                _klass = _clazz+'-show'+(!_klass?'':' ')+_klass;
                _node = _p._$create(_options.tag||'span',_klass);
                _parent.appendChild(_node);
            }
            // append class to parent node
            var _klass = _options.clazz;
            if (!!_klass){
                _klass = (_klass||'').trim().split(_reg0)[0]+'-parent';
                _p._$addClassName(_parent,_klass);
            }
            return _node;
        };
    })();
    /**
     * 设置或者获取指定标识的数据
     *
     * 结构举例
     * ```html
     *   <div id="abc">123</div>
     * ```
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/element'
     *   ],function(_e){
     *       // 设置值操作
     *       // <div id="abc" data-img="http://a.b.com/a.png">123</div>
     *       // 返回value值: http://a.b.com/a.png
     *       var _src = _e._$dataset('abc','img','http://a.b.com/a.png');
     *       // 取值操作
     *       var _src = _e._$dataset('abc','img');
     * 
     *       // 批量设置
     *       var _map = _e._$dataset('abc',{
     *           a:'aaaaa',
     *           b:'bbbbbbbb',
     *           c:'ccccccccc'
     *       });
     * 
     *       // 批量取值
     *       // 返回：{a:'aaaaa',b:'bbbbbbbb',c:'ccccccccc'}
     *       var _map = _e._$dataset('abc',['a','b','c']);
     *   });
     * ```
     *
     * @method module:base/element._$dataset
     * @see    module:base/element._$attr
     * @param  {String}              arg0 - 数据标识
     * @param  {String|Object|Array} arg1 - 属性名
     * @return {String|Object}              数据值
     */
    /**
     * @method CHAINABLE._$dataset
     * @see module:base/element._$dataset
     */
    _p._$dataset =
    _y._$dataset = function(_element,_key,_value){
        // check element
        var _id = _p._$id(_element);
        if (!_id){
            return null;
        }
        // check single key-value
        if (_u._$isString(_key)){
            return _h.__dataset(
                _p._$get(_element),
                _key,_value
            );
        }
        // check map set
        // ignore argument _value
        if (_u._$isObject(_key)){
            var _ret = {};
            _u._$forIn(_key,function(_v,_k){
                _ret[_k] = _p._$dataset(_id,_k,_v);
            });
            return _ret;
        }
        // check array get
        // ignore argument _value
        if (_u._$isArray(_key)){
            var _ret = {};
            _u._$forEach(_key,function(_k){
                _ret[_k] = _p._$dataset(_id,_k);
            });
            return _ret;
        }
        return null;
    };
    /**
     * 取某个节点的属性值
     *
     * 结构举例
     * ```html
     *   <div id="abc">123</div>
     * ```
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/element'
     *   ],function(_e){
     *       // 设置成 <div id="abc" data-img="http://a.b.com/a.png">123</div>
     *       // 返回value值: http://a.b.com/a.png
     *       var _src = _e._$attr('abc','data-img','http://a.b.com/a.png');
     *
     *       // 如果设置了img的值返回data-img，否则放回空字符串
     *       var _src = _e._$attr('abc','data-img');
     *   });
     * ```
     *
     * @method module:base/element._$attr
     * @see    module:base/element._$dataset
     * @param  {String|Node} arg0 - 节点标识或者对象
     * @param  {String}      arg1 - 属性名称
     * @param  {String}      arg2 - 属性值，如果没有设置此参数则表示取值
     * @return {String}             属性值
     */
    /**
     * @method CHAINABLE._$attr
     * @see module:base/element._$attr
     */
    _p._$attr =
    _y._$attr = function(_element,_name,_value){
        _element = _p._$get(_element);
        if (!_element){
            return '';
        }
        if (_value!==undefined&&!!_element.setAttribute){
            _element.setAttribute(_name,_value);
        }
        return _h.__getAttribute(_element,_name);
    };
    /**
     * html代码转节点对象，
     * 如果转换出来的节点数量超过[包含]2个，
     * 则最外面增加一个容器节点，即返回的始终是一个节点
     *
     * 结构举例
     * ```html
     *   <div id="abc">
     *     <span>123</span>
     *   </div>
     * ```
     *
     * 代码举例
     * ```javascript
     *   NEJ.define([
     *       'base/element'
     *   ],function(_e){
     *       var _node = _e._$html2node('<div>1</div><div><span>2</span></div>');
     *   });
     * ```
     *
     * 返回结果
     * ```html
     *   <div> <!-- 返回此节点 -->
     *     <div>1</div>
     *     <div><span>2</span></div>
     *   </div>
     * ```
     *
     * @method module:base/element._$html2node
     * @param  {String} arg0 - 代码
     * @return {Node}          节点
     */
    _p._$html2node = (function(){
        var _reg = /<(.*?)(?=\s|>)/i, // first tag name
            _tmap = {li:'ul',tr:'tbody',td:'tr',th:'tr',option:'select'};
        return function(_html){
            var _tag;
            if (_reg.test(_html)){
                _tag = _tmap[(RegExp.$1||'').toLowerCase()]||'';
            }
            var _div = _p._$create(_tag||'div');
            _div.innerHTML = _html;
            var _list = _p._$getChildren(_div);
            return _list.length>1?_div:_list[0];
        };
    })();
    /**
     * 将dom节点转为xml串
     *
     * 结构举例
     * ```html
     *   <div id="abc">123</div>
     * ```
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/element'
     *   ],function(_p){
     *       // 生成<div id="abc">123</div>字符串
     *       var _xml = _p._$dom2xml('abc'));
     *   });
     * ```
     *
     * @see    module:base/element._$xml2dom
     * @method module:base/element._$dom2xml
     * @param  {String|Node} arg0 - 节点
     * @return {String}             XML代码
     */
    /**
     * @method CHAINABLE._$dom2xml
     * @see module:base/element._$dom2xml
     */
    _p._$dom2xml =
    _y._$dom2xml = function(_element){
        _element = _p._$get(_element);
        return !_element?'':_h.__serializeDOM2XML(_element);
    };
    /**
     * 将xml转为dom节点
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/element'
     *   ],function(_e){
     *       // 生成<div id="abc">123</div>节点
     *       var _node = _e._$xml2dom('<div id="abc">123</div>');
     *   });
     * ```
     *
     * @method module:base/element._$xml2dom
     * @see    module:base/element._$dom2xml
     * @param  {String} arg0 - xml文本
     * @return {Node}          DOM节点
     */
    _p._$xml2dom = function(_xml){
        _xml = (_xml||'').trim();
        return !_xml?null:_h.__parseDOMFromXML(_xml);
    };
    /**
     * dom节点转对象，多用于XML DOM转数据对象
     *
     * 结构举例
     * ```html
     *   <div id="abc">123</div>
     *
     *   <div id="efg">
     *     <p>aaaa</p>
     *     <span>bbbb</span>
     *   </div>
     * ```
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/element'
     *   ],function(_p){
     *       // 返回对象{div:'123'}
     *       var _obj = _p._$dom2object('abc');
     *
     *       // 返回对象{div:{p:'aaaa',span:'bbbb'}}
     *       var _obj = _p._$dom2object('efg');
     *   });
     * ```
     *
     * @method module:base/element._$dom2object
     * @see    module:base/element._$xml2object
     * @param  {String|Node} arg0 - 节点
     * @return {Object}             转换完成的对象
     */
    /**
     * @method CHAINABLE._$dom2object
     * @see module:base/element._$dom2object
     */
    _p._$dom2object =
    _y._$dom2object = function(_dom,_obj){
         _obj = _obj||{};
         _dom = _p._$get(_dom);
         if (!_dom) return _obj;
        var _name = _dom.tagName.toLowerCase(),
            _list = _p._$getChildren(_dom);
        if (!_list||!_list.length){
            _obj[_name] = _dom.textContent||_dom.text||'';
            return _obj;
        }
        var _tmp = {};
        _obj[_name] = _tmp;
        _u._$forEach(
            _list,function(_node){
                _p._$dom2object(_node,_tmp);
            }
        );
        return _obj;
    };
    /**
     * XML转对象
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/element'
     *   ],function(_e){
     *       // 返回 {user:{id:'1',username:'aaa',password:'123456'}}
     *       var _obj = _e._$xml2object('\
     *           <?xml version="1.0" encoding="utf-8" ?>\
     *           <user>\
     *             <id>1</id>\
     *             <username>aaa</username>\
     *             <password>123456</password>\
     *           </user>\
     *       ');
     *   });
     * ```
     *
     * @method module:base/element._$xml2object
     * @see    module:base/element._$dom2object
     * @param  {String} arg0 - xml代码
     * @return {Object}        对象
     */
    _p._$xml2object = function(_xml){
        try{
            return _p._$dom2object(_p._$xml2dom(_xml));
        }catch(ex){
            return null;
        }
    };
    /**
     * 文本转指定类型的数据
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/element'
     *   ],function(_e){
     *       // 转成dom节点
     *       var _dom = _e._$text2type('<div id="abc">123</div>',"xml");
     *       // 转成json字符串
     *       var _json = _e._$text2type('{"a":"aaaaaaaaaaaaa"}',"json");
     *       // 原样返回
     *       var _text = _e._$text2type('<div id="abc">123</div>');
     *   });
     * ```
     *
     * @method module:base/element._$text2type
     * @param  {String} arg0 - 文本内容
     * @param  {String} arg1 - 类型，如xml/json/text
     * @return {Variable}      指定类型的数据
     */
    _p._$text2type = (function(){
        var _fmap = {
            xml:function(_text){
                return _p._$xml2dom(_text);
            },
            json:function(_text){
                try{
                    return JSON.parse(_text);
                }catch(ex){
                    return null;
                }
            },
            dft:function(_text){
                return _text;
            }
        };
        return function(_text,_type){
            _type = (_type||'').toLowerCase();
            return (_fmap[_type]||_fmap.dft)(_text||'');
        };
    })();
    /**
     * 批量设置节点样式
     *
     * 结构举例
     * ```html
     *   <div id="abc">123</div>
     * ```
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/element'
     *   ],function(_e){
     *       _e._$style('abc',{color:'red',width:'100px'});
     *   });
     * ```
     *
     * 输出结果
     * ```html
     *   <div id="abc" style="color:red;width:100px;">123</div>
     * ```
     *
     * @method module:base/element._$style
     * @see    module:base/element._$setStyle
     * @param  {String|Node} arg0 - 节点
     * @param  {Object}      arg1 - 样式信息{color:'red',width:'100px'}
     * @return {Void}
     */
    /**
     * @method CHAINABLE._$style
     * @see module:base/element._$style
     */
    _p._$style =
    _y._$style = function(_element,_map){
        _element = _p._$get(_element);
        if (!!_element){
            _u._$loop(_map,function(_value,_name){
                _p._$setStyle(_element,_name,_value);
            });
        }
    };
    /**
     * 设置单个样式
     *
     * 结构举例
     * ```html
     *   <div id="abc">123</div>
     * ```
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/element'
     *   ],function(_e){
     *       _e._$setStyle('abc','color','red');
     *   });
     * ```
     *
     * 输出结果
     * ```html
     *   <div id="abc" style="color:red;">123</div>
     * ```
     *
     * @method module:base/element._$setStyle
     * @see    module:base/element._$getStyle
     * @param  {String|Node} arg0 - 节点
     * @param  {String}      arg1 - 样式名称
     * @param  {String}      arg2 - 样式值
     * @return {Void}
     */
    /**
     * @method CHAINABLE._$setStyle
     * @see module:base/element._$setStyle
     */
    _p._$setStyle =
    _y._$setStyle = function(_element,_name,_value){
        _element = _p._$get(_element);
        if (!!_element){
            _h.__setStyleValue(
                _element,_name,
                _h.__processCSSText(_value)
            );
        }
    };
    /**
     * 取样式值
     *
     * 结构举例
     * ```html
     *   <div id="abc" style="color:red;">123</div>
     * ```
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/element'
     *   ],function(_e){
     *       // 返回节点的颜色值red（高版本浏览器返回rgb值），如果没有返回空字符串
     *       var _value = _e._$getStyle('abc','color');
     *   });
     * ```
     *
     * @method module:base/element._$getStyle
     * @see    module:base/element._$setStyle
     * @param  {String|Node} arg0 - 节点
     * @param  {String}      arg1 - 样式名称
     * @return {String}             样式值
     */
    /**
     * @method CHAINABLE._$getStyle
     * @see module:base/element._$getStyle
     */
    _p._$getStyle =
    _y._$getStyle = function(_element,_name){
        _element = _p._$get(_element);
        return !_element ? '' :
                _h.__getStyleValue(
                    _element,_name
                );
    };
    /**
     * 页面注入脚本
     *
     * 结构举例
     * ```html
     *   <div id="abc">123</div>
     * ```
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/element'
     *   ],function(_e){
     *       // 注入脚本，全局执行环境
     *       _e._$addScript('\
     *           document.getElementById("abc").style.color = "green"\
     *       ');
     *   });
     * ```
     *
     * 输出结果
     * ```html
     *   <div id="abc" style="color:green;">123</div>
     * ```
     *
     * @method module:base/element._$addScript
     * @param  {String} arg0 - 脚本内容
     * @return {Void}
     */
    _p._$addScript = function(_script){
        try{
            _script = _script.trim();
            if (!!_script){
                return (new Function(_script))();
            }
        }catch(ex){
            // ignore
            console.error(ex.message);
            console.error(ex.stack);
        }
    };
    /**
     * 注入页面内联样式，
     * 样式支持前缀标记$&lt;vendor&gt; ，
     * 如下样式值支持3D/2D切换，优先选用3D，格式：$&lt;NAME|VALUE&gt;
     *
     * * NAME支持：scale/rotate/translate/matrix
     * * VALUE格式：x=1&y=2&z=3&a=30
     *
     *
     * 范例如$&lt;scale|a=30&gt;，各名称支持的参数列表
     *
     * | 名称              | 参数 |
     * | :--        | :-- |
     * | scale      | x,y,z |
     * | rotate     | x,y,z,a |
     * | translate  | x,y,z |
     * | matrix     | m11,m12,m13,m14,m21,m22,m23,m24,m31,m32,m33,m34,m41,m42,m43,m44 |
     *
     *
     * 结构举例
     * ```html
     *   <html>
     *    <head>
     *        <title>test</title>
     *    </head>
     *   </html>
     * ```
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/element'
     *   ],function(_e){
     *       // 注入样式
     *       _e._$addStyle('body{font-size:20px}');
     *
     *       // 注入样式支持变量
     *       _e._$addStyle('\
     *           .a{$<vendor>transform-origin:0 0;}\
     *           .b{$<vendor>transform:$<translate|x=0&y=1&z=1>}\
     *       ');
     *   });
     * ```
     *
     * 输出结果
     * ```html
     *   <html>
     *    <head>
     *        <title>test</title>
     *        <style>body{font-size:20px;}</style>
     *        <style>
     *           .a{-webkit-transform-origin:0 0;}\
     *           .b{-webkit-transform:translate3d(0,1,1);}\
     *        </style>
     *    </head>
     *   </html>
     * ```
     *
     * @method module:base/element._$addStyle
     * @param  {String} arg0 - 样式内容
     * @return {Node}          样式节点
     */
    _p._$addStyle = (function(){
        var _reg = /[\s\r\n]+/gi;
        return function(_css){
            _css = (_css||'').replace(_reg,' ').trim();
            var _node = null;
            if (!!_css){
                _node = _p._$create('style');
                document.head.appendChild(_node);
                _h.__injectCSSText(
                    _node,_h.__processCSSText(_css)
                );
            }
            return _node;
        };
    })();
    /**
     * 缓存待激活样式
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/element'
     *   ],function(_e){
     *       // 设置样式到缓存中，自动生成样式名，返回自动生成的类名#<class>
     *       var _class = _e._$pushCSSText('.#<uispace>{width:300px;}');
     *
     *       // 把缓存中的样式内联到页面
     *       _e._$dumpCSSText();
     *   });
     * ```
     *
     * @method module:base/element._$pushCSSText
     * @see    module:base/element._$dumpCSSText
     * @param  {String} arg0 - 样式
     * @return {String}        样式标识
     */
    _p._$pushCSSText = (function(){
        var _reg = /#<(.*?)>/g,
            _seed = +new Date;
        return function(_css,_data){
            if (!_cspol){
                _cspol = [];
            }
            var _class = 'auto-'+_u._$uniqueID(),
                _dmap = _u._$merge({uispace:_class},_data);
            _cspol.push(
                _css.replace(_reg,function($1,$2){
                    return _dmap[$2]||$1;
                })
            );
            return _class;
        };
    })();
    /**
     * 激活缓存中的样式
     *
     * 结构举例
     * ```html
     *   <div id="abc" class="item">123</div>
     * ```
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/element'
     *   ],function(_e){
     *       // 设置样式.item{width:300px;}到缓存中
     *       _e._$pushCSSText('.item{width:300px;}');
     *
     *       // 把缓存中的样式内联到页面
     *       _e._$dumpCSSText();
     *   });
     * ```
     *
     * @method module:base/element._$dumpCSSText
     * @see    module:base/element._$pushCSSText
     * @return {Void}
     */
    _p._$dumpCSSText = function(){
        if (!!_cspol){
            _p._$addStyle(_cspol.join(' '));
            _cspol = null;
        }
    };
    /**
     * 追加CSS规则
     *
     * 结构举例
     * ```html
     *   <style id="abc"></style>
     * ```
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/element'
     *   ],function(_e){
     *       // 设置样式.item{width:300px;}到缓存中
     *       _e._$appendCSSText('node-id','.item{width:300px;}');
     *   });
     * ```
     *
     * @method module:base/element._$appendCSSText
     * @see    module:base/element._$addStyle
     * @param  {Node}   arg0 - 样式节点
     * @param  {String} arg1 - 单条样式规则
     * @return {CSSRule}       样式规则对象
     */
    /**
     * @method CHAINABLE._$appendCSSText
     * @see module:base/element._$appendCSSText
     */
    _p._$appendCSSText =
    _y._$appendCSSText = function(_element,_css){
        _element = _p._$get(_element);
        return !_element ? null :
                _h.__appendCSSText(
                    _element,
                    _h.__processCSSText(_css)
                );
    };
    /**
     * 新增样式类，多个样式用空格分开
     *
     * 结构举例
     * ```html
     *   <div id="abc">123</div>
     * ```
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/element'
     *   ],function(_e){
     *       // 添加样式 fc01 fc03
     *       _e._$addClassName('abc','fc01 fc03');
     *   });
     * ```
     *
     * 输出结果
     * ```html
     *   <div id="abc" class="fc01 fc03">123</div>
     * ```
     *
     * @method module:base/element._$addClassName
     * @see    module:base/element._$delClassName
     * @see    module:base/element._$replaceClassName
     * @param  {String|Node} arg0 - 要操作的节点标识或者节点对象
     * @param  {String}      arg1 - 要新增的样式类名称
     * @return {Void}
     */
    /**
     * @method CHAINABLE._$addClassName
     * @see module:base/element._$addClassName
     */
    _p._$addClassName =
    _y._$addClassName = function(_element,_class){
        if (!_class){
            return;
        }
        _element = _p._$get(_element);
        if (!!_element){
            _h.__processClassName(
                _element,'add',_class
            );
        }
    };
    /**
     * 删除样式类，多个样式用空格分开
     *
     * 结构举例
     * ```html
     *   <div id="abc" class="fc01 fc03">123</div>
     * ```
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/element'
     *   ],function(_e){
     *       // 删除fc02 fc03样式名
     *       _e._$delClassName('abc','fc02 fc03');
     *   });
     * ```
     *
     * 输出结果
     * ```html
     *   <div id="abc" class="fc01">123</div>
     * ```
     *
     * @method module:base/element._$delClassName
     * @see    module:base/element._$addClassName
     * @see    module:base/element._$replaceClassName
     * @param  {String|Node} arg0 - 要操作的节点标识或者节点对象
     * @param  {String}      arg1 - 要删除的样式类名称
     * @return {Void}
     */
    /**
     * @method CHAINABLE._$delClassName
     * @see module:base/element._$delClassName
     */
    _p._$delClassName =
    _y._$delClassName = function(_element,_class){
        _element = _p._$get(_element);
        if (!!_element){
            _h.__processClassName(
                _element,'remove',_class
            );
        }
    };
    /**
     * 替换节点的样式类名称，多个样式用空格分隔，
     * 操作过程为先删除待删样式，再添加待添样式，因此不需要删除样式存在才添加样式
     *
     * 结构举例
     * ```html
     *   <div id="abc" class="fc01 fc03">123</div>
     * ```
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/element'
     *   ],function(_e){
     *       // 替换fc02为fc05
     *       // 这里不需要fc02存在
     *       _e._$replaceClassName('abc','fc02','fc05');
     *   });
     * ```
     *
     * 输出结果
     * ```html
     *   <div id="abc" class="fc01 fc03 fc05">123</div>
     * ```
     *
     * @method module:base/element._$replaceClassName
     * @see    module:base/element._$addClassName
     * @see    module:base/element._$delClassName
     * @param  {String|Node} arg0 - 要操作的节点标识或者节点对象
     * @param  {String}      arg1 - 要删除的样式类名称
     * @param  {String}      arg2 - 要新增的样式类名称
     * @return {Void}
     */
    /**
     * @method CHAINABLE._$replaceClassName
     * @see module:base/element._$replaceClassName
     */
    _p._$replaceClassName =
    _y._$replaceClassName = function(_element,_del,_add){
        _element = _p._$get(_element);
        if (!!_element){
            _h.__processClassName(
                _element,'replace',
                _del,_add
            );
        }
    };
    /**
     * 检测节点是否包含指定样式，多个样式用空格分隔，检测时包含其中之一即表示包含
     *
     * 结构举例
     * ```html
     *   <div id="abc" class="fc01 fc03">123</div>
     * ```
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/element'
     *   ],function(_e){
     *       // 如果有fc01样式返回true，否则返回false
     *       _e._$hasClassName('abc',"fc01");
     *   });
     * ```
     *
     * @method module:base/element._$hasClassName
     * @param  {String|Node} arg0 - 节点标识或者对象
     * @param  {String}      arg1 - 样式串
     * @return {Boolean}            是否含指定样式
     */
    /**
     * @method CHAINABLE._$hasClassName
     * @see module:base/element._$hasClassName
     */
    _p._$hasClassName =
    _y._$hasClassName = function(_element,_class){
        _element = _p._$get(_element);
        if (!!_element){
            return _h.__hasClassName(_element,_class);
        }
        return !1;
    };
    /**
     * 取样式变换矩阵对象
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/element'
     *   ],function(_e){
     *       // 生成下面矩阵的对象
     *       // |a:1,b:0,c:0,d:1,e:0:f:0|
     *       // |m11:1,m12:0,m13:0,m14:0|
     *       // |m21:0,m22:1,m23:0,m24:0|
     *       // |m31:0,m32:0,m33:1,m34:0|
     *       // |m41:0,m42:0,m43:0,m44:1|
     *       var _matrix = _e._$matrix("matrix(1,0,0,1,0,0)");
     *   });
     * ```
     *
     * @method module:base/element._$matrix
     * @param  {String} arg0 - 变化信息
     * @return {CSSMatrix}     变换矩阵对象
     */
    _p._$matrix = function(_matrix){
        _matrix = (_matrix||'').trim();
        return _h.__getCSSMatrix(_matrix);
    };
    /**
     * 设置3D变换，对于不支持3D的系统自动切换为2D变换
     *
     * 结构举例
     * ```html
     *   <div id="abc"></div>
     * ```
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'base/element'
     *   ],function(_e){
     *       // 进行css3d变换，对应css样式为-webkit-transform:rotate3d( 2, 1, 1, -75deg);
     *       _e._$css3d('abc','rotate',{x:2,y:1,z:1,a:'-75deg'});
     *   });
     * ```
     *
     * @method module:base/element._$css3d
     * @see    module:base/element._$addStyle
     * @param  {String|Node} arg0 - 节点标识或者对象
     * @param  {String}      arg1 - 变换类型，matrix/translate/scale/rotate
     * @param  {Object}      arg2 - 变换值，{x:1,y:2,z:3,a:'30deg'}
     * @return {Void}
     */
    /**
     * @method CHAINABLE._$css3d
     * @see module:base/element._$css3d
     */
    _p._$css3d =
    _y._$css3d = function(_element,_name,_map){
        _element = _p._$get(_element);
        if (!!_element){
            var _value = _h.__processTransformValue(_name,_map);
            if (!!_value){
                _p._$setStyle(_element,'transform',_value);
            }
        }
    };
    // for chainable
    _x._$merge(_y);

    if (CMPT){
        NEJ.copy(NEJ.P('nej.e'),_p);
    }

    return _p;
},'19c9fc0aab6a6b9db67f02f7d86454f4','ca81292dba9c26802fbbda1e893ea19b','3f115371e3e07e18707a0c434f8a73ce','72b60541618971d03c8b74f45c039218','29e075e23a8f0b7ec637c0da9509d27a','14b5c893dbb887324d0e4cb5659469e1');
I$('07295d3d10c258de51c70bf22b7ff622',function (_e, _u, _platform) {
  /**
   * [_$isSafari 判断是否Safari浏览器]
   * @return {Boolean} []
   */
  _u._$isSafari = function () {
    var browser = _platform._$KERNEL.browser
    if (browser) {
      browser = browser.toLowerCase()
      return browser === 'safari'
    }

    console.log('cant get browser!!')
    return false
  }

  _u._$getRootDomain = function (origin) {
    var list = origin.replace('https://', '').replace('http://', '').split(':')[0].split('.')
    var length = list.length
    return length >= 2 ? list[length - 2] + '.' + list[length - 1] : origin
  }

  /**
   * [_$SafariChangeUrl safari需要替换url]
   * @param  {[type]} url [old url]
   * @return {[String]}
   */
  _u._$SafariChangeUrl = function (url) {
    if (!_u._$isSafari()) {
      return url
    }
    var origin = _u._$url2origin(location.href)
    var urlOrigin = _u._$url2origin(url)
    if (_u._$getRootDomain(origin) === _u._$getRootDomain(urlOrigin)) {
      // 同域不做再次跳转
      return url
    }
    if (url.indexOf('/iframe/cookie?redirect=') !== -1) {
      return url
    }

    return window.passportUrl + '/iframe/cookie?redirect=' + encodeURIComponent(url)
  }

  /**
   * [_$getPassportUrl 根据域名获取url]
   * @return {[type]} [description]
   */
  _u._$getPassportUrl = function (str) {
    console.log(str)
    try {
      var map = JSON.parse(str.replace(/'/g, '"'))
      var origin = _u._$url2origin(window.topLocation || location.href)
      var domain = _u._$getRootDomain(origin)
      return map[domain] || ''
    } catch (e) {
      console.log(e)
      return ''
    }
  }

  _u.showError = function (msg) {
    var nContainer = _e._$html2node('<div class="u-toast">' + msg + '</div>')
    document.body.appendChild(nContainer)
    var timeout = timeout || 3000
    setTimeout(function () {
      nContainer.parentNode.removeChild(nContainer)
    }, timeout)
  }

  /**
   * [_$getBody 获取不同浏览器的body]
   * @return {[element]} [body]
   */
  _u._$getBody = function () {
    /**
     * Chrome 的滚动事件是在 document.body 上
     * Firefox 和 IE 的滚动事件是在 document.documentElement 上
     */
    var body = document.body
    var browser = _platform._$KERNEL.browser
    var isFirefox = browser === 'firefox'
    var isIE = browser === 'ie'
    if (isFirefox || isIE) {
      body = document.documentElement
    }

    return body
  }

  /**
   * [_$showLoading 显示覆盖全局的loading]
   * @param  {Boolean} isShow [是否显示，同时只能显示一个]
   * @return {[type]}         [null]
   */
  _u._$showLoading = function (isShow) {
    if (isShow) {
      if (!_u.lContainer) {
        _u.lContainer = _e._$html2node('<div class="modal">loading...</div>')
        document.body.appendChild(_u.lContainer)
      }
    } else {
      _u.lContainer.parentNode.removeChild(_u.lContainer)
      _u.lContainer = null
    }
  }

  return _u
},'15fb3eeb129e67b9b1cc98ef8ea8e26d','3f115371e3e07e18707a0c434f8a73ce','836fd3ea8c2cdd6a7842e1315a393abe');
I$('6676313c7af5106a9823fa04ad6746bd',function (_p,_o,_f,_r){
    /**
     * 格式化源信息
     * @param  {String} 源
     * @return {String} 格式化后源
     */
    _p.__formatOrigin = (function(){
        var _reg = /^([\w]+?:\/\/.*?(?=\/|$))/i;
        return function(_origin){
            _origin = _origin||'';
            if (_reg.test(_origin)){
                return RegExp.$1;
            }
            return '*';
        };
    })();
    /**
     * 解析消息传递数据
     * @param  {Variable} 数据
     * @return {Variable} 数据
     */
    _p.__formatPassData = function(_data){
        return _data;
    };
    /**
     * 跨文档发送数据
     * @param  {Window} 窗体对象
     * @param  {Object} 发送配置
     * @return {Void}
     */
    _p.__postMessage = function(_window,_options){
        if (!_window.postMessage){
            return;
        }
        _options = _options||_o;
        _window.postMessage(
            _p.__formatPassData(_options.data),
            _p.__formatOrigin(_options.origin)
        );
    };
    
    return _p;
});
I$('23d2eff4217184839549ed8931fc594e',function (NEJ,_u,_p,_o,_f,_r){
    /**
     * 定义类，通过此api定义的类具有以下特性：
     *
     * * {@link external:Function#_$extend|_$extend}作为类的静态扩展方法
     * * __init作为类的初始化函数
     * * __super作为子类调用父类的同名函数
     *
     * ```javascript
     * NEJ.define([
     *     'base/klass'
     * ],function(k,p){
     *     // 定义类A
     *     p.A = k._$klass();
     *     var pro = A.prototype;
     *     // 初始化
     *     pro.__init = function(){
     *          // do init
     *     };
     *     // 类接口
     *     pro.__doSomething = function(a){
     *         // TODO something
     *     };
     * 
     *     return p;
     * });
     * ```
     * 
     * ```javascript
     * NEJ.define([
     *     'base/klass',
     *     '/path/to/class/a.js'
     * ],function(k,a,p){
     *     // 定义类B，并继承自A
     *     p.B = k._$klass();
     *     var pro = B._$extend(a.A);
     *     // 初始化
     *     pro.__init = function(){
     *         // 调用A的初始化逻辑
     *         this.__super();
     *         // TODO B的初始化逻辑
     *     };
     *     // 类接口
     *     pro.__doSomething = function(a){
     *         // 调用A的__doSomething接口
     *         this.__super(a);
     *         // TODO B的逻辑
     *     };
     * 
     *     return p;
     * });
     * ```
     * 
     * @method module:base/klass._$klass
     * @see    external:Function#_$extend
     * @return {Function} 返回定义的类
     */
    _p._$klass = (function(){
        var _isNotFunction = function(){
            return _o.toString.call(arguments[0])!=='[object Function]';
        };
        var _doFindIn = function(_method,_klass){
            while(!!_klass){
                var _pro = _klass.prototype,
                    _key = _u.__forIn(_pro,function(v){
                        return _method===v;
                    });
                if (_key!=null){
                    return {
                        name:_key,
                        klass:_klass
                    };
                }
                _klass = _klass._$super;
            }
        };
        return function(){
            // class constructor
            var _Klass = function(){
                return this.__init.apply(this,arguments);
            };
            _Klass.prototype.__init = _f;
            /**
             * 子类继承父类
             *
             * ```javascript
             * NEJ.define([
             *     'base/klass'
             * ],function(k,p){
             *     // 定义类A
             *     p.A = k._$klass();
             *     var pro = A.prototype;
             *     // 初始化
             *     pro.__init = function(){
             *          // do init
             *     };
             *     // 类接口
             *     pro.__doSomething = function(a){
             *         // TODO something
             *     };
             * 
             *     return p;
             * });
             * ```
             * 
             * ```javascript
             * NEJ.define([
             *     'base/klass',
             *     '/path/to/class/a.js'
             * ],function(k,a,p){
             *     // 定义类B，并继承自A
             *     p.B = k._$klass();
             *     var pro = B._$extend(a.A);
             *     // 初始化
             *     pro.__init = function(){
             *         // 调用A的初始化逻辑
             *         this.__super();
             *         // TODO B的初始化逻辑
             *     };
             *     // 类接口
             *     pro.__doSomething = function(a){
             *         // 调用A的__doSomething接口
             *         this.__super(a);
             *         // TODO B的逻辑
             *     };
             * 
             *     return p;
             * });
             * ```
             *
             * @method external:Function#_$extend
             * @see    module:base/klass._$klass
             * @param  {Function} arg0 - 父类
             * @param  {Boolean}  arg1 - 是否拷贝父类的静态方法，默认拷贝父类静态方法
             * @return {Object}          扩展类的prototype对象
             */
            _Klass._$extend = function(_super,_static){
                if (_isNotFunction(_super)){
                    return;
                }
                // for static method
                var _this = this;
                if (_static!==!1){
                    _u.__forIn(_super,function(v,k){
                        if (!_isNotFunction(v)){
                            _this[k] = v;
                        }
                    });
                }
                // do inherit
                this._$super = _super;
                var _parent = function(){};
                _parent.prototype = _super.prototype;
                this.prototype = new _parent();
                this.prototype.constructor = this;
                // for super method call
                var _stack = [],
                    _phash = {};
                var _doUpdateCache = function(_method,_klass){
                    var _result = _doFindIn(_method,_klass);
                    if (!_result) return;
                    // save state
                    if (_stack[_stack.length-1]!=_result.name){
                        _stack.push(_result.name);
                    }
                    _phash[_result.name] = _result.klass._$super;
                    return _result.name;
                };
                this.prototype.__super = function(){
                    var _name = _stack[_stack.length-1],
                        _method = arguments.callee.caller;
                    if (!_name){
                        _name = _doUpdateCache(_method,this.constructor);
                    }else{
                        var _parent = _phash[_name].prototype;
                        // switch caller name
                        if (!_parent.hasOwnProperty(_name)||
                            _method!=_parent[_name]){
                            _name = _doUpdateCache(_method,this.constructor);
                        }else{
                            // other method in current parent
                            _phash[_name] = _phash[_name]._$super;
                        }
                    }
                    // call parent method
                    var _ret = _phash[_name].prototype[_name].apply(this,arguments);
                    // exit super
                    if (_name==_stack[_stack.length-1]){
                        _stack.pop();
                        delete _phash[_name];
                    }
                    return _ret;
                };

                if (CMPT){
                    var _pro = this.prototype;
                    _pro.__supInit      = _pro.__super;
                    _pro.__supReset     = _pro.__super;
                    _pro.__supDestroy   = _pro.__super;
                    _pro.__supInitNode  = _pro.__super;
                    _pro.__supDoBuild   = _pro.__super;
                    _pro.__supOnShow    = _pro.__super;
                    _pro.__supOnHide    = _pro.__super;
                    _pro.__supOnRefresh = _pro.__super;
                    this._$supro = _super.prototype;
                }

                return this.prototype;
            };
            return _Klass;
        };
    })();

    if (CMPT){
        NEJ.C = _p._$klass;
        NEJ.copy(this.NEJ,NEJ);
    }

    return _p;
},'19c9fc0aab6a6b9db67f02f7d86454f4','51215da15c0ae87c65064f5ad7c3de94');
I$('f47d31eab9ba6db67cd130d5e345279b',function (NEJ,_k,_v,_u,_p,_o,_f,_r){
    var _pro;
    /**
     * 控件基类，主要实现以下功能：
     * * 对事件驱动编程模型的支持
     * * 对控件通用行为及业务逻辑的抽象
     * 
     * ```javascript
     *   NEJ.define([
     *       'base/klass',
     *       'util/event'
     *   ],function(_k,_t,_p,_o,_f,_r){
     *       // 自定义一个控件及使用、回收的流程
     *       var _pro;
     *   
     *       // 第一步
     *       // 定义控件类，从父类继承
     *       _p._$$Widget = _k._$klass();
     *       _pro = _p._$$Widget._$extend(_t._$$EventTarget);
     *   
     *       // 第二步
     *       // 重写控件初始化业务逻辑
     *       _pro.__init = function(_options){
     *           // _options - 配置参数信息
     *           //            初始化时一般不对该参数做处理
     *           // 调用父类初始化业务逻辑
     *           this.__super(_options);
     *           // TODO something
     *       };
     *   
     *       // 第三步
     *       // 重写控件重置业务逻辑
     *       _pro.__reset = function(_options){
     *           // _options - 配置参数信息
     *           //            此处重置控件配置信息
     *           // 调用父类重置业务逻辑
     *           this.__super(_options);
     *           // TODO something
     *       };
     *   
     *       // 第四步
     *       // 重写控件回收业务逻辑
     *       _pro.__destroy = function __destroy(){
     *           // 调用父类回收业务逻辑
     *           this.__super();
     *           // TODO something
     *       };
     *   
     *       // 第五步
     *       // 使用控件
     *       var _widget = _p._$$Widget._$allocate({
     *           a:'aaaaaaaaaaa',
     *           b:'bbbbbbbbbbbbb',
     *           c:'ccccccccccccccc'
     *       });
     *   
     *       // 第六步
     *       // 回收控件
     *       _widget = _widget._$recycle();
     *       // 也可以使用以下方式回收，建议使用上面的回收方式
     *       _widget = _p._$$Widget._$recycle(_widget);
     *   });
     * ```
     * 
     * @class module:util/event._$$EventTarget
     * @param {Object} config - 配置参数，根据控件实际情况提供配置参数支持
     */
    /** 
     * 控件回收前触发事件，控件在具体实现时如需触发回收前的事件
     * 
     * ```javascript
     *   // 重写控件回收业务逻辑触发onbeforerecycle事件
     *   _pro.__destroy = function(){
     *       this._$dispatchEvent('onbeforerecycle');
     *       // 调用父类回收业务逻辑
     *       this.__super();
     *       // TODO something
     *   };
     * 
     *   // 监测onbeforerecycle事件
     *   var _widget = _p._$$Widget._$allocate({
     *       onbeforerecycle:function(_event){
     *           // TODO something
     *       }
     *   });
     * ```
     * 
     * @event module:util/event._$$EventTarget#onbeforerecycle
     * @param {Object} event - 事件触发信息
     */
    /**
     * 控件回收后触发事件，控件在具体实现时如需触发回收后的事件
     * 
     * ```javascript
     *   // 重写控件回收业务逻辑触发onbeforerecycle事件
     *   _pro.__destroy = function(){
     *       // 调用父类回收业务逻辑
     *       this.__super();
     *       // TODO something
     *       this._$dispatchEvent('onaftercycle');
     *   };
     *   
     *   // 监测onaftercycle事件
     *   var _widget = _p._$$Widget._$allocate({
     *       onaftercycle:function(_event){
     *           // TODO something
     *       }
     *   });
     * ```
     * 
     * @event module:util/event._$$EventTarget#onaftercycle
     * @param {Object} event - 事件触发信息
     */
    _p._$$EventTarget = _k._$klass();
    _pro = _p._$$EventTarget.prototype;
    /**
     * 控件分配，NEJ框架提供的所有控件统一使用分配和回收机制，
     * 分配空间时会优先考虑使用前面回收的同种控件，只有在没有可用控件的情况下才会实例化新的控件
     * 
     * ```javascript
     *   // 分配一个控件
     *   var _widget = _p._$$Widget._$allocate({
     *       conf0:'aaaaaaa',
     *       conf1:'bbbbbbbbbbbbb',
     *       onxxx:function(){
     *           // TODO something
     *       }
     *   });
     * ```
     * 
     * @method module:util/event._$$EventTarget._$allocate
     * @see    module:util/event._$$EventTarget._$getInstance
     * @see    module:util/event._$$EventTarget._$getInstanceWithReset
     * @param  {Object}  arg0 - 配置参数，根据控件实际情况提供配置参数支持
     * @return {module:util/event._$$EventTarget} 控件实例
     */
    _p._$$EventTarget._$allocate = function(_options){
        _options = _options||{};
        var _instance = !!this.__pool
                        &&this.__pool.shift();
        if (!_instance){
            _instance = new this(_options);
            this.__inst__ = (this.__inst__||0)+1;
        }
        // reset instance, flag first
        _instance.__reset(_options);
        return _instance;
    };
    /**
     * 控件回收，NEJ框架提供的所有控件统一使用分配和回收机制，
     * 如果提供的实例非当前类的实例则自动调整为输入实例的类来回收此实例
     * 
     * ```javascript
     *   // 回收前面分配的实例有两种方式
     *   // 如果不能确定实例的构造类，则可以直接使用实例的回收接口
     *   _widget._$recycle();
     *   // 如果可以确定实例的构造类，则可以使用构造类的静态回收接口
     *   _p._$$Widget._$recycle(_widget);
     *   // 如果回收多个实例则使用构造类的静态回收接口
     *   _p._$$Widget._$recycle([_widget0,_widget1]);
     * ```
     * 
     * @method module:util/event._$$EventTarget._$recycle
     * @param  {module:util/event._$$EventTarget|module:util/event._$$EventTarget[]} arg0 - 待回收实例或者实例列表
     * @return {Void}
     */
    _p._$$EventTarget._$recycle = (function(){
        var _doRecycle = function(_item,_index,_list){
            _item._$recycle();
            _list.splice(_index,1);
        };
        return function(_instance){
            if (!_instance) return null;
            if (!_u._$isArray(_instance)){
                // instance is not instanceof class
                if (!(_instance instanceof this)){
                    // use constructor recycle instance
                    var _class = _instance.constructor;
                    if (!!_class._$recycle){
                        _class._$recycle(_instance);
                    }
                    return null;
                }
                // delete singleton instance
                if (_instance==this.__instance){
                    delete this.__instance;
                }
                if (_instance==this.__inctanse){
                    delete this.__inctanse;
                }
                // do recycle
                _instance.__destroy();
                // recycle instance
                if (!this.__pool){
                    this.__pool = [];
                } 
                if (_u._$indexOf(this.__pool,_instance)<0){
                    this.__pool.push(_instance);
                }
                return null;
            }
            // recycle instance array
            _u._$reverseEach(_instance,_doRecycle,this);
        };
    })();
    /**
     * 取控件实例（单例），如果控件指明了为单例模式，
     * 则项目中使用该控件时统一使用此接口获取控件实例，使用方式同_$allocate
     * 
     * ```javascript
     *   // 取控件单例，确保在第一次取单例时输入所有配置参数
     *   var _widget = _p._$$Widget._$getInstance({
     *       conf0:'aaaaaaa',
     *       conf1:'bbbbbbbbbbbbb',
     *       onxxx:function(){
     *           // TODO something
     *       }
     *   });
     *   
     *   // 后续取单例忽略配置参数
     *   var _widget1 = _p._$$Widget._$getInstance({
     *       conf0:'bbbbb'  // <-- 如果单例已生成，则这里的配置信息不会生效
     *   });
     * 
     *   // 等价于如下调用
     *   var _widget2 = _p._$$Widget._$getInstance();
     * ```
     * 
     * @method module:util/event._$$EventTarget._$getInstance
     * @see    module:util/event._$$EventTarget._$getInstanceWithReset
     * @see    module:util/event._$$EventTarget._$allocate
     * @param  {Object}  arg0 - 配置参数，根据控件实际情况提供配置参数支持
     * @return {module:util/event._$$EventTarget} 控件实例
     */
    _p._$$EventTarget._$getInstance = function(_options){
        if (!this.__instance){
            this.__instance = this._$allocate(_options);
        }
        return this.__instance;
    };
    /**
     * 取控件实例（单例），如果控件指明了为单例模式，
     * 则项目中使用该控件时统一使用此接口获取控件实例，使用方式同_$getInstance，
     * 该接口同_$getInstance接口的主要区别在于输入的配置参数是否在每次调用接口时都重置
     * 
     * ```javascript
     *   // 取控件单例，确保在第一次取单例时输入所有配置参数
     *   var _widget = _p._$$Widget._$getInstanceWithReset({
     *       conf0:'aaaaaaa',
     *       conf1:'bbbbbbbbbbbbb',
     *       onxxx:function(){
     *           // TODO something
     *       }
     *   });
     *   
     *   // 后续取单例使用新的配置参数
     *   var _widget1 = _p._$$Widget._$getInstanceWithReset({
     *       conf0:'bbbbb'  // <-- 如果单例已生成，则重置这里的配置信息
     *   });
     * ```
     * 
     * @method module:util/event._$$EventTarget._$getInstanceWithReset
     * @see    module:util/event._$$EventTarget._$getInstance
     * @see    module:util/event._$$EventTarget._$allocate
     * @param  {Object}  arg0 - 配置参数，根据控件实际情况提供配置参数支持
     * @param  {Boolean} arg1 - 是否需要先清理已有实例
     * @return {module:util/event._$$EventTarget} 控件实例
     */
    _p._$$EventTarget._$getInstanceWithReset = function(_options,_clear){
        // clear instance
        if (!!_clear&&!!this.__inctanse){
            this.__inctanse._$recycle();
            delete this.__inctanse;
        }
        // allocate instance
        if (!this.__inctanse){
            this.__inctanse = this._$allocate(_options);
        }else{
            this.__inctanse.__reset(_options);
        }
        return this.__inctanse;
    };
    /**
     * 控件初始化，
     * 子类可重写此接口业务逻辑，
     * 子类可通过调用__super接口调用父类的初始化业务逻辑
     * 
     * ```javascript
     *   // 子类控件初始化业务逻辑
     *   _pro.__init = function(){
     *       // 调用父类控件初始化
     *       this.__super();
     *       // TODO something
     *   };
     * ```
     * 
     * @protected
     * @method module:util/event._$$EventTarget#__init
     * @return {Void}
     */
    _pro.__init = function(){
        this.__events = {};
        this.__events_dom = {};
        this.id = _u._$uniqueID();
    };
    /**
     * 控件重置，此接口用来接收控件配置参数的处理，
     * 控件基类已处理以下业务逻辑：
     * 
     * * 缓存通过配置参数输入的回调事件
     * 
     * 子类重写此接口业务逻辑来处理具体控件对配置参数的处理，
     * 子类通过调用__super接口调用父类的重置业务逻辑
     * 
     * ```javascript
     *   // 子类控件重置业务逻辑
     *   _pro.__reset = function(_options){
     *       // 调用父类控件重置逻辑
     *       this.__super(_options);
     *       // TODO something
     *   };
     * ```
     * 
     * @protected
     * @method module:util/event._$$EventTarget#__reset
     * @param  {Object} arg0 - 配置参数，根据控件实际情况提供配置参数支持
     * @return {Void}
     */
    _pro.__reset = function(_options){
        this._$batEvent(_options);
    };
    /**
     * 控件销毁，当控件在回收时会调用此接口，基类已处理以下业务逻辑：
     * 
     * * 通过配置参数输入的事件回调的清理
     * * 通过__doInitDomEvent接口添加的DOM事件的清理
     * 
     * 一般情况下控件还需回收通过重置接口__reset产生的数据，
     * 子类可重写此接口业务逻辑来触发onbeforerecycle和onafterrecycle事件，
     * 子类可通过调用__super接口调用父类的销毁业务逻辑
     * 
     * ```javascript
     *   // 子类重写控件销毁逻辑
     *   _pro.__destroy = function(){
     *       // 触发回收之前事件
     *       this._$dispatchEvent('onbeforerecycle');
     *       // 调用父类清理逻辑，如果有触发回收之后事件则以下业务逻辑需在触发回收之后事件后面调用
     *       //this.__super();
     *       // 清理本控件的数据
     *       delete this.__conf0;
     *       this.__widget2 = this.__widget2._$recycle();
     *       // 触发回收之后事件，确保在onafterrecycle事件被清理前触发
     *       this._$dispatchEvent('onafterrecycle');
     *       this.__super();
     *   };
     * ```
     * 
     * @protected
     * @method module:util/event._$$EventTarget#__destroy
     * @return {Void}
     */
    _pro.__destroy = function(){
        this._$clearEvent();
        this.__doClearDomEvent();
    };
    /**
     * 初始化事件，
     * 重置接口__reset中需要通过_$addEvent接口添加的事件，
     * 使用此接口添加可以在回收时自动被清理
     * 
     * ```javascript
     *   // 子类重置接口添加节点事件
     *   _pro.__reset = function(_options){
     *       this.__super(_options);
     *       // 添加DOM事件或者自定义事件
     *       this.__doInitDomEvent([
     *           [document,'click',this.__onDocClick._$bind(this)],
     *           [window,'ok',this.__onWindowOK._$bind(this)]
     *       ]);
     *   };
     * ```
     * 
     * @protected
     * @method module:util/event._$$EventTarget#__doInitDomEvent
     * @see    module:util/event._$$EventTarget#__doClearDomEvent
     * @param  {Array} arg0 - 待添加的事件配置列表 
     * @return {Void}
     */
    _pro.__doInitDomEvent = (function(){
        var _doAttach = function(_args){
            if (!_args||_args.length<3) return;
            this.__events_dom['de-'+_u._$uniqueID()] = _args;
            _v._$addEvent.apply(_v,_args);
        };
        return function(_list){
            _u._$forEach(_list,_doAttach,this);
        };
    })();
    /**
     * 清除DOM事件，_$recycle接口会自动调用来清理这种DOM事件
     * 
     * ```javascript
     *   // 子类重置接口清理节点事件
     *   _pro.__destroy = function(_options){
     *       this.__doClearDomEvent();
     *       this.__super(_options);
     *   };
     * ```
     * 
     * @protected
     * @method module:util/event._$$EventTarget#__doClearDomEvent
     * @see    module:util/event._$$EventTarget#__doInitDomEvent
     * @return {Void}
     */
    _pro.__doClearDomEvent = (function(){
        var _doRemoveEvent = function(_args,_key,_map){
            delete _map[_key];
            _v._$delEvent.apply(_v,_args);
        };
        return function(){
            _u._$loop(this.__events_dom,_doRemoveEvent);
        };
    })();
    /**
     * 清理所有组合的控件
     * 
     * ```javascript
     *   // 子类重置接口清理组件
     *   _pro.__destroy = function(_options){
     *       this.__doClearComponent(function(_inst){
     *           // 不回收_p._$$Widget2控件实例
     *           return _inst instanceof _p._$$Widget2;
     *       });
     *       this.__super(_options);
     *   };
     * ```
     * 
     * @protected
     * @method module:util/event._$$EventTarget#__doClearComponent
     * @param  {Function} arg0 - 过滤接口，返回true表示不清理该控件
     * @return {Void}
     */
    _pro.__doClearComponent = function(_filter){
        _filter = _filter||_f;
        _u._$loop(this,function(_inst,_key,_map){
            if (!!_inst&&!!_inst._$recycle&&!_filter(_inst)){
                delete _map[_key];
                _inst._$recycle();
            }
        });
    };
    /**
     * 回收控件，通过实例的构造类来回收当前实例
     * 
     * ```javascript
     *   // 通过实例的接口回收当前实例
     *   _widget._$recycle();
     * ```
     * 
     * @method module:util/event._$$EventTarget#_$recycle
     * @see    module:util/event._$$EventTarget#_$allocate
     * @return {Void}
     */
    _pro._$recycle = function(){
        this.constructor._$recycle(this);
    };
    /**
     * 判断是否有注册事件回调
     * 
     * ```javascript
     *   // 分配实例
     *   var _widget = _p._$$Widget._$allocate({
     *       onok:function(){
     *           // TODO
     *       }
     *   });
     *   // 判断控件实例是否注册有onok事件回调
     *   _widget._$hasEvent('onok');
     * ```
     * 
     * @method module:util/event._$$EventTarget#_$hasEvent
     * @param  {String} arg0 - 事件类型
     * @return {Boolean}       是否注册了事件回调
     */
    _pro._$hasEvent = function(_type){
        var _type = (_type||'').toLowerCase(),
            _event = this.__events[_type];
        return !!_event&&_event!==_f;
    };
    /**
     * 删除单个事件回调
     * 
     * ```javascript
     *   var _handler = function(){
     *       // TODO
     *   };
     *   // 分配实例
     *   var _widget = _p._$$Widget._$allocate({
     *       onok:_handler
     *   });
     *   // 删除onok事件回调
     *   _widget._$delEvent('onok',_handler);
     * ```
     * 
     * @method module:util/event._$$EventTarget#_$delEvent
     * @param  {String}   arg0 - 事件类型
     * @param  {Function} arg1 - 事件处理函数
     * @return {Void}
     */
    _pro._$delEvent = function(_type,_event){
        var _type = (_type||'').toLowerCase(),
            _events = this.__events[_type];
        if (!_u._$isArray(_events)){
            if (_events==_event){
                delete this.__events[_type];
            }
            return;
        }
        // batch remove
        _u._$reverseEach(
            _events,function(_func,_index,_list){
                if (_func==_event){
                    _list.splice(_index,1);
                }
            }
        );
        if (!_events.length){
            delete this.__events[_type];
        }
    };
    /**
     * 重置事件，覆盖原有事件
     * 
     * ```javascript
     *   // 分配实例
     *   var _widget = _p._$$Widget._$allocate();
     *   // 设置控件事件回调
     *   _widget._$setEvent('onok',function(){
     *       // TODO something
     *   });
     *   _widget._$setEvent('oncancel',function(){
     *       // TODO something
     *   });
     * ```
     * 
     * @method module:util/event._$$EventTarget#_$setEvent
     * @param  {String}   arg0 - 事件类型，大小写不敏感
     * @param  {Function} arg1 - 事件处理函数
     * @return {Void}
     */
    _pro._$setEvent = function(_type,_event){
        if (!!_type&&_u._$isFunction(_event)){
            this.__events[_type.toLowerCase()] = _event;
        }
    };
    /**
     * 批量添加事件
     * 
     * ```javascript
     *   // 分配实例
     *   var _widget = _p._$$Widget._$allocate();
     *   // 批量设置控件事件回调
     *   _widget._$batEvent({
     *       onok:function(){
     *           // TODO something
     *       },
     *       oncancel:function(){
     *           // TODO something
     *       }
     *   });
     * ```
     * 
     * @method module:util/event._$$EventTarget#_$batEvent
     * @see    module:util/event._$$EventTarget#_$setEvent
     * @param  {Object} arg0 - 事件集合,{type:function}
     * @return {Void}
     */
    _pro._$batEvent = (function(){
        var _doSetEvent = function(_event,_type){
            this._$setEvent(_type,_event);
        };
        return function(_events){
            _u._$loop(_events,_doSetEvent,this);
        };
    })();
    /**
     * 清除事件，没有指定类型则清除所有事件
     * 
     * ```javascript
     *   // 分配实例
     *   var _widget = _p._$$Widget._$allocate({
     *       onok:function(){
     *           // TODO something
     *       }
     *   });
     *   // 清除onok事件回调
     *   _widget._$clearEvent('onok');
     *   // 清除所有时间回调
     *   _widget._$clearEvent();
     * ```
     * 
     * @method module:util/event._$$EventTarget#_$clearEvent
     * @param  {String} arg0 - 事件类型
     * @return {Void}
     */
    _pro._$clearEvent = (function(){
        var _doClearEvent = function(_event,_type){
            this._$clearEvent(_type);
        };
        return function(_type){
            var _type = (_type||'').toLowerCase();
            if (!!_type){
                delete this.__events[_type];
            }else{
                _u._$loop(this.__events,_doClearEvent,this);
            }
        };
    })();
    /**
     * 追加事件，通过此接口可以对同一个事件添加多个回调函数
     * 
     * ```javascript
     *   // 分配实例
     *   var _widget = _p._$$Widget._$allocate({
     *       onok:function(){
     *           // TODO something
     *       }
     *   });
     *   // 追加事件回调
     *   _widget._$addEvent({
     *       onok:function(){
     *           // TODO something
     *       }
     *   });
     * ```
     * 
     * @method module:util/event._$$EventTarget#_$addEvent
     * @param  {String}   arg0 - 事件类型
     * @param  {Function} arg1 - 事件处理函数
     * @return {Void}
     */
    _pro._$addEvent = function(_type,_event){
        // check type and event
        if (!_type||!_u._$isFunction(_event)){
            return;
        }
        // cache event
        _type = _type.toLowerCase();
        var _events = this.__events[_type];
        if (!_events){
            this.__events[_type] = _event;
            return;
        }
        if (!_u._$isArray(_events)){
            this.__events[_type] = [_events];
        }
        this.__events[_type].push(_event);
    };
    /**
     * 调用事件，一般在控件实现的具体业务逻辑中使用
     * 
     * ```javascript
     *   // 分配实例
     *   var _widget = _p._$$Widget._$allocate({
     *       onok:function(){
     *           // TODO something
     *       }
     *   });
     *   // 触发控件onok事件
     *   _widget._$dispatchEvent('onok');
     *   
     *   // 在控件实现的业务逻辑中使用
     *   _pro.__doSomething = function(){
     *       // TODO something
     *       // 触发onok事件
     *       this._$dispatchEvent('onok');
     *   };
     * ```
     * 
     * @method module:util/event._$$EventTarget#_$dispatchEvent
     * @param  {String}   arg0 - 事件类型，不区分大小写
     * @param  {Variable} arg1 - 事件可接受参数，具体看调用时的业务逻辑
     * @return {Void}
     */
    _pro._$dispatchEvent = function(_type){
        var _type = (_type||'').toLowerCase(),
            _event = this.__events[_type];
        if (!_event) return;
        var _args = _r.slice.call(arguments,1);
        // single event
        if (!_u._$isArray(_event)){
            _event.apply(this,_args);
            return;
        }
        // event list
        _u._$forEach(
            _event,function(_handler){
                if (DEBUG){
                    _handler.apply(this,_args);
                }else{
                    try{
                        _handler.apply(this,_args);
                    }catch(ex){
                        // ignore
                        console.error(ex.message);
                        console.error(ex.stack);
                    }
                }
            },this
        );
    };
    
    if (CMPT){
        _p._$$Event = _p._$$EventTarget;
        NEJ.copy(NEJ.P('nej.ut'),_p);
    }
    
    return _p;
},'19c9fc0aab6a6b9db67f02f7d86454f4','23d2eff4217184839549ed8931fc594e','72b60541618971d03c8b74f45c039218','3f115371e3e07e18707a0c434f8a73ce');
I$('7bb0311ae4a29a38dce028b2ac370ee2',function (NEJ,_k,_e,_v,_u,_t,_p,_o,_f,_r){
    var _pro;
    /**
     * 自定义事件封装对象，封装的事件支持通过事件相关接口进行添加、删除等操作
     * 
     * 脚本举例
     * ```javascript
     * NEJ.define([
     *     'base/event'
     *     'util/event'
     * ],function(_v,_t){
     *     // 支持自定义事件
     *     _t._$$CustomEvent._$allocate({
     *         element:window,
     *         event:'ok'
     *     });
     * 
     *     // 添加自定义事件 
     *     _v._$addEvent(window,'ok',function(){alert(0);});
     *     _v._$addEvent(window,'ok',function(){alert(1);});
     *     
     *     // 删除自定义事件
     *     _v._$delEvent(window,'ok',function(){alert(0);});
     *     _v._$clearEvent(window,'ok');
     *     
     *     // 触发自定义事件
     *     window.onok({a:'aaaaa'});
     *     _v._$dispatchEvent(window,'ok',{a:'aaaaa'});
     * });
     * ```
     * 
     * @class    module:util/event/event._$$CustomEvent
     * @extends  module:util/event._$$EventTarget
     * 
     * @param    {Object}       config  - 可选配置参数
     * @property {String|Node}  element - 事件关联节点ID或者对象，默认为window对象
     * @property {String|Array} event   - 事件名称或者名称列表
     */
    /** 
     * 初始化时触发事件
     * 
     * @event module:util/event/event._$$CustomEvent#oninit
     * @param {Object} event - 事件信息
     */
    /** 
     * 事件调度前触发事件
     * 
     * @event    module:util/event/event._$$CustomEvent#ondispatch
     * @param    {Object} event - 事件信息
     * @property {String} type  - 事件类型
     */
    /**
     * 添加事件时触发事件
     * 
     * @event    module:util/event/event._$$CustomEvent#oneventadd
     * @param    {Object}   event    - 事件信息
     * @property {String}   type     - 事件类型
     * @property {Function} listener - 事件执行函数
     */
    _p._$$CustomEvent = _k._$klass();
    _pro = _p._$$CustomEvent._$extend(_t._$$EventTarget);
    /**
     * 控件初始化
     * 
     * @protected
     * @method module:util/event/event._$$CustomEvent#__init
     * @return {Void}
     */
    _pro.__init = function(){
        // onxxx - event entry handler
        //   xxx - event callback handler list
        this.__cache = {};
        this.__super();
    };
    /**
     * 控件重置
     * 
     * @protected
     * @method module:util/event/event._$$CustomEvent#__reset
     * @param  {Object} arg0 - 可选配置参数
     * @return {Void}
     */
    _pro.__reset = function(_options){
        this.__super(_options);
        this.__element = _e._$get(_options.element)||window;
        // init event
        this.__doEventInit(_options.event);
        this.__doEventAPIEnhance();
        this._$dispatchEvent('oninit');
    };
    /**
     * 销毁控件
     * 
     * @protected
     * @method module:util/event/event._$$CustomEvent#__destroy
     * @return {Void}
     */
    _pro.__destroy = (function(){
        var _doClear = function(_value,_key,_map){
            if (!_u._$isArray(_value)){
                _u._$safeDelete(this.__element,_key);
            }
            delete _map[_key];
        };
        return function(){
            this.__super();
            // clear cache
            _u._$loop(
                this.__cache,_doClear,this
            );
            delete this.__element;
        };
    })();
    /**
     * 判断是否需要代理事件
     * 
     * @protected
     * @method module:util/event/event._$$CustomEvent#__isDelegate
     * @param  {String|Node} arg0 - 节点
     * @param  {String}      arg1 - 事件
     * @return {Boolean}            是否需要代理事件
     */
    _pro.__isDelegate = function(_element,_type){
        _element = _e._$get(_element);
        return _element===this.__element&&
               (!_type||!!this.__cache['on'+_type]);
    };
    /**
     * 初始化事件
     * 
     * @protected
     * @method module:util/event/event._$$CustomEvent#__doEventInit
     * @param  {String} arg0 - 事件名称
     * @return {Void}
     */
    _pro.__doEventInit = function(_event){
        if (_u._$isString(_event)){
            var _name = 'on'+_event;
            if (!this.__cache[_name]){
                this.__cache[_name] = 
                    this.__doEventDispatch.
                        _$bind(this,_event);
            }
            this.__doEventBind(_event); 
            return;
        }
        if (_u._$isArray(_event)){
            _u._$forEach(
                _event,this.__doEventInit,this
            );
        }
    };
    /**
     * 绑定事件
     * 
     * @protected
     * @method module:util/event/event._$$CustomEvent#__doEventBind
     * @param  {String} arg0 - 事件名称
     * @return {Void}
     */
    _pro.__doEventBind = function(_type){
        var _event = 'on'+_type,
            _handler = this.__element[_event],
            _handler1 = this.__cache[_event];
        if (_handler!=_handler1){
            this.__doEventDelete(_type);
            if (!!_handler&&_handler!=_f){
                this.__doEventAdd(_type,_handler);
            }
            this.__element[_event] = _handler1;
        }
    };
    /**
     * 添加事件
     * 
     * protected
     * @method module:util/event/event._$$CustomEvent#__doEventAdd
     * @param  {String}   arg0 - 事件名称
     * @param  {Function} arg1 - 事件回调
     * @return {Void}
     */
    _pro.__doEventAdd = function(_type,_handler,_front){
        var _list = this.__cache[_type];
        if (!_list){
            _list = [];
            this.__cache[_type] = _list;
        }
        if (_u._$isFunction(_handler)){
            !_front ? _list.push(_handler)
                    : _list.unshift(_handler);
        } 
    };
    /**
     * 删除事件
     * 
     * protected
     * @method module:util/event/event._$$CustomEvent#__doEventDelete
     * @param  {String}   arg0 - 事件名称
     * @param  {Function} arg1 - 事件回调
     * @return {Void}
     */
    _pro.__doEventDelete = function(_type,_handler){
        var _list = this.__cache[_type];
        if (!_list||!_list.length) return;
        // clear all event handler
        if (!_handler){
            delete this.__cache[_type];
            return;
        }
        // delete one event handler
        _u._$reverseEach(
            _list,function(_value,_index,_xlist){
                if (_handler===_value){
                    _xlist.splice(_index,1);
                    return !0;
                }
            }
        );
    };
    /**
     * 事件调度
     * 
     * protected
     * @method module:util/event/event._$$CustomEvent#__doEventDispatch
     * @param  {String} arg0 - 事件名称
     * @param  {Object} arg1 - 事件对象
     * @return {Void}
     */
    _pro.__doEventDispatch = function(_type,_event){
        _event = _event||{noargs:!0};
        if (_event==_o){
            _event = {};
        }
        _event.type = _type;
        this._$dispatchEvent('ondispatch',_event);
        if (!!_event.stopped) return;
        _u._$forEach(
            this.__cache[_type],function(_handler){
                if (DEBUG){
                    _handler(_event);
                }else{
                    try{
                        _handler(_event);
                    }catch(ex){
                        // ignore
                        console.error(ex.message);
                        console.error(ex.stack);
                    }
                }
            }
        );
    };
    /**
     * 增强事件操作API
     * 
     * protected
     * @method module:util/event/event._$$CustomEvent#__doEventAPIEnhance
     * @return {Void}
     */
    _pro.__doEventAPIEnhance = (function(){
        var _doAddEvent = function(_event){
            var _args = _event.args,
                _type = _args[1].toLowerCase();
            if (this.__isDelegate(_args[0],_type)){
                _event.stopped = !0;
                this.__doEventBind(_type);
                this.__doEventAdd(_type,_args[2],_args[3]);
                this._$dispatchEvent('oneventadd',{
                    type:_type,
                    listener:_args[2]
                });
            }
        };
        var _doDelEvent = function(_event){
            var _args = _event.args,
                _type = _args[1].toLowerCase();
            if (this.__isDelegate(_args[0],_type)){
                _event.stopped = !0;
                this.__doEventDelete(_type,_args[2]);
            }
        };
        var _doClearEvent = function(_event){
            var _args = _event.args,
                _type = (_args[1]||'').toLowerCase();
            if (this.__isDelegate(_args[0])){
                if (!!_type){
                    this.__doEventDelete(_type);
                    return;
                }
                _u._$loop(
                    this.__cache,function(_value,_key){
                        if (_u._$isArray(_value)){
                            this.__doEventDelete(_key);
                        }
                    },this
                );
            }
        };
        var _doDispatchEvent = function(_event){
            var _args = _event.args,
                _type = _args[1].toLowerCase();
            if (this.__isDelegate(_args[0],_type)){
                _event.stopped = !0;
                _args[0]['on'+_type].apply(_args[0],_args.slice(2));
            }
        };
        return function(){
            // void multi-enhance
            if (!!this.__enhanced){
                return;
            }
            // enhance event api
            this.__enhanced = true;
            _v._$addEvent = _v._$addEvent._$aop(_doAddEvent._$bind(this));
            _v._$delEvent = _v._$delEvent._$aop(_doDelEvent._$bind(this));
            _v._$clearEvent = _v._$clearEvent._$aop(_doClearEvent._$bind(this));
            _v._$dispatchEvent = _v._$dispatchEvent._$aop(_doDispatchEvent._$bind(this));
            
            if (CMPT){
                NEJ.copy(NEJ.P('nej.v'),_v);
            }
        };
    })();
    
    if (CMPT){
        NEJ.copy(NEJ.P('nej.ut'),_p);
    }
    
    return _p;
},'19c9fc0aab6a6b9db67f02f7d86454f4','23d2eff4217184839549ed8931fc594e','15fb3eeb129e67b9b1cc98ef8ea8e26d','72b60541618971d03c8b74f45c039218','3f115371e3e07e18707a0c434f8a73ce','f47d31eab9ba6db67cd130d5e345279b');
/*! JSON v3.2.5 | http://bestiejs.github.io/json3 | Copyright 2012-2013, Kit Cambridge | http://kit.mit-license.org */
;(function(){var o=!0,w=null;
(function(B){function v(a){if("bug-string-char-index"==a)return"a"!="a"[0];var f,c="json"==a;if(c||"json-stringify"==a||"json-parse"==a){if("json-stringify"==a||c){var d=k.stringify,b="function"==typeof d&&l;if(b){(f=function(){return 1}).toJSON=f;try{b="0"===d(0)&&"0"===d(new Number)&&'""'==d(new String)&&d(m)===r&&d(r)===r&&d()===r&&"1"===d(f)&&"[1]"==d([f])&&"[null]"==d([r])&&"null"==d(w)&&"[null,null,null]"==d([r,m,w])&&'{"a":[1,true,false,null,"\\u0000\\b\\n\\f\\r\\t"]}'==d({a:[f,o,!1,w,"\x00\u0008\n\u000c\r\t"]})&&
"1"===d(w,f)&&"[\n 1,\n 2\n]"==d([1,2],w,1)&&'"-271821-04-20T00:00:00.000Z"'==d(new Date(-864E13))&&'"+275760-09-13T00:00:00.000Z"'==d(new Date(864E13))&&'"-000001-01-01T00:00:00.000Z"'==d(new Date(-621987552E5))&&'"1969-12-31T23:59:59.999Z"'==d(new Date(-1))}catch(n){b=!1}}if(!c)return b}if("json-parse"==a||c){a=k.parse;if("function"==typeof a)try{if(0===a("0")&&!a(!1)){f=a('{"a":[1,true,false,null,"\\u0000\\b\\n\\f\\r\\t"]}');var e=5==f.a.length&&1===f.a[0];if(e){try{e=!a('"\t"')}catch(g){}if(e)try{e=
1!==a("01")}catch(i){}}}}catch(O){e=!1}if(!c)return e}return b&&e}}var m={}.toString,p,C,r,D=typeof define==="function"&&define.amd,k="object"==typeof exports&&exports;k||D?"object"==typeof JSON&&JSON?k?(k.stringify=JSON.stringify,k.parse=JSON.parse):k=JSON:D&&(k=B.JSON={}):k=B.JSON||(B.JSON={});var l=new Date(-3509827334573292);try{l=-109252==l.getUTCFullYear()&&0===l.getUTCMonth()&&1===l.getUTCDate()&&10==l.getUTCHours()&&37==l.getUTCMinutes()&&6==l.getUTCSeconds()&&708==l.getUTCMilliseconds()}catch(P){}if(!v("json")){var s=
v("bug-string-char-index");if(!l)var t=Math.floor,J=[0,31,59,90,120,151,181,212,243,273,304,334],z=function(a,f){return J[f]+365*(a-1970)+t((a-1969+(f=+(f>1)))/4)-t((a-1901+f)/100)+t((a-1601+f)/400)};if(!(p={}.hasOwnProperty))p=function(a){var f={},c;if((f.__proto__=w,f.__proto__={toString:1},f).toString!=m)p=function(a){var f=this.__proto__,a=a in(this.__proto__=w,this);this.__proto__=f;return a};else{c=f.constructor;p=function(a){var f=(this.constructor||c).prototype;return a in this&&!(a in f&&
this[a]===f[a])}}f=w;return p.call(this,a)};var K={"boolean":1,number:1,string:1,undefined:1};C=function(a,f){var c=0,b,h,n;(b=function(){this.valueOf=0}).prototype.valueOf=0;h=new b;for(n in h)p.call(h,n)&&c++;b=h=w;if(c)c=c==2?function(a,f){var c={},b=m.call(a)=="[object Function]",d;for(d in a)!(b&&d=="prototype")&&!p.call(c,d)&&(c[d]=1)&&p.call(a,d)&&f(d)}:function(a,f){var c=m.call(a)=="[object Function]",b,d;for(b in a)!(c&&b=="prototype")&&p.call(a,b)&&!(d=b==="constructor")&&f(b);(d||p.call(a,
b="constructor"))&&f(b)};else{h=["valueOf","toString","toLocaleString","propertyIsEnumerable","isPrototypeOf","hasOwnProperty","constructor"];c=function(a,f){var c=m.call(a)=="[object Function]",b,d;if(d=!c)if(d=typeof a.constructor!="function"){d=typeof a.hasOwnProperty;d=d=="object"?!!a.hasOwnProperty:!K[d]}d=d?a.hasOwnProperty:p;for(b in a)!(c&&b=="prototype")&&d.call(a,b)&&f(b);for(c=h.length;b=h[--c];d.call(a,b)&&f(b));}}c(a,f)};if(!v("json-stringify")){var L={92:"\\\\",34:'\\"',8:"\\b",12:"\\f",
10:"\\n",13:"\\r",9:"\\t"},u=function(a,f){return("000000"+(f||0)).slice(-a)},G=function(a){var f='"',b=0,d=a.length,h=d>10&&s,n;for(h&&(n=a.split(""));b<d;b++){var e=a.charCodeAt(b);switch(e){case 8:case 9:case 10:case 12:case 13:case 34:case 92:f=f+L[e];break;default:if(e<32){f=f+("\\u00"+u(2,e.toString(16)));break}f=f+(h?n[b]:s?a.charAt(b):a[b])}}return f+'"'},E=function(a,b,c,d,h,n,e){var g=b[a],i,j,k,l,q,s,v,x,y;try{g=b[a]}catch(A){}if(typeof g=="object"&&g){i=m.call(g);if(i=="[object Date]"&&
!p.call(g,"toJSON"))if(g>-1/0&&g<1/0){if(z){k=t(g/864E5);for(i=t(k/365.2425)+1970-1;z(i+1,0)<=k;i++);for(j=t((k-z(i,0))/30.42);z(i,j+1)<=k;j++);k=1+k-z(i,j);l=(g%864E5+864E5)%864E5;q=t(l/36E5)%24;s=t(l/6E4)%60;v=t(l/1E3)%60;l=l%1E3}else{i=g.getUTCFullYear();j=g.getUTCMonth();k=g.getUTCDate();q=g.getUTCHours();s=g.getUTCMinutes();v=g.getUTCSeconds();l=g.getUTCMilliseconds()}g=(i<=0||i>=1E4?(i<0?"-":"+")+u(6,i<0?-i:i):u(4,i))+"-"+u(2,j+1)+"-"+u(2,k)+"T"+u(2,q)+":"+u(2,s)+":"+u(2,v)+"."+u(3,l)+"Z"}else g=
w;else if(typeof g.toJSON=="function"&&(i!="[object Number]"&&i!="[object String]"&&i!="[object Array]"||p.call(g,"toJSON")))g=g.toJSON(a)}c&&(g=c.call(b,a,g));if(g===w)return"null";i=m.call(g);if(i=="[object Boolean]")return""+g;if(i=="[object Number]")return g>-1/0&&g<1/0?""+g:"null";if(i=="[object String]")return G(""+g);if(typeof g=="object"){for(a=e.length;a--;)if(e[a]===g)throw TypeError();e.push(g);x=[];b=n;n=n+h;if(i=="[object Array]"){j=0;for(a=g.length;j<a;y||(y=o),j++){i=E(j,g,c,d,h,n,
e);x.push(i===r?"null":i)}a=y?h?"[\n"+n+x.join(",\n"+n)+"\n"+b+"]":"["+x.join(",")+"]":"[]"}else{C(d||g,function(a){var b=E(a,g,c,d,h,n,e);b!==r&&x.push(G(a)+":"+(h?" ":"")+b);y||(y=o)});a=y?h?"{\n"+n+x.join(",\n"+n)+"\n"+b+"}":"{"+x.join(",")+"}":"{}"}e.pop();return a}};k.stringify=function(a,b,c){var d,h,j;if(typeof b=="function"||typeof b=="object"&&b)if(m.call(b)=="[object Function]")h=b;else if(m.call(b)=="[object Array]"){j={};for(var e=0,g=b.length,i;e<g;i=b[e++],(m.call(i)=="[object String]"||
m.call(i)=="[object Number]")&&(j[i]=1));}if(c)if(m.call(c)=="[object Number]"){if((c=c-c%1)>0){d="";for(c>10&&(c=10);d.length<c;d=d+" ");}}else m.call(c)=="[object String]"&&(d=c.length<=10?c:c.slice(0,10));return E("",(i={},i[""]=a,i),h,j,d,"",[])}}if(!v("json-parse")){var M=String.fromCharCode,N={92:"\\",34:'"',47:"/",98:"\u0008",116:"\t",110:"\n",102:"\u000c",114:"\r"},b,A,j=function(){b=A=w;throw SyntaxError();},q=function(){for(var a=A,f=a.length,c,d,h,k,e;b<f;){e=a.charCodeAt(b);switch(e){case 9:case 10:case 13:case 32:b++;
break;case 123:case 125:case 91:case 93:case 58:case 44:c=s?a.charAt(b):a[b];b++;return c;case 34:c="@";for(b++;b<f;){e=a.charCodeAt(b);if(e<32)j();else if(e==92){e=a.charCodeAt(++b);switch(e){case 92:case 34:case 47:case 98:case 116:case 110:case 102:case 114:c=c+N[e];b++;break;case 117:d=++b;for(h=b+4;b<h;b++){e=a.charCodeAt(b);e>=48&&e<=57||e>=97&&e<=102||e>=65&&e<=70||j()}c=c+M("0x"+a.slice(d,b));break;default:j()}}else{if(e==34)break;e=a.charCodeAt(b);for(d=b;e>=32&&e!=92&&e!=34;)e=a.charCodeAt(++b);
c=c+a.slice(d,b)}}if(a.charCodeAt(b)==34){b++;return c}j();default:d=b;if(e==45){k=o;e=a.charCodeAt(++b)}if(e>=48&&e<=57){for(e==48&&(e=a.charCodeAt(b+1),e>=48&&e<=57)&&j();b<f&&(e=a.charCodeAt(b),e>=48&&e<=57);b++);if(a.charCodeAt(b)==46){for(h=++b;h<f&&(e=a.charCodeAt(h),e>=48&&e<=57);h++);h==b&&j();b=h}e=a.charCodeAt(b);if(e==101||e==69){e=a.charCodeAt(++b);(e==43||e==45)&&b++;for(h=b;h<f&&(e=a.charCodeAt(h),e>=48&&e<=57);h++);h==b&&j();b=h}return+a.slice(d,b)}k&&j();if(a.slice(b,b+4)=="true"){b=
b+4;return o}if(a.slice(b,b+5)=="false"){b=b+5;return false}if(a.slice(b,b+4)=="null"){b=b+4;return w}j()}}return"$"},F=function(a){var b,c;a=="$"&&j();if(typeof a=="string"){if((s?a.charAt(0):a[0])=="@")return a.slice(1);if(a=="["){for(b=[];;c||(c=o)){a=q();if(a=="]")break;if(c)if(a==","){a=q();a=="]"&&j()}else j();a==","&&j();b.push(F(a))}return b}if(a=="{"){for(b={};;c||(c=o)){a=q();if(a=="}")break;if(c)if(a==","){a=q();a=="}"&&j()}else j();(a==","||typeof a!="string"||(s?a.charAt(0):a[0])!="@"||
q()!=":")&&j();b[a.slice(1)]=F(q())}return b}j()}return a},I=function(a,b,c){c=H(a,b,c);c===r?delete a[b]:a[b]=c},H=function(a,b,c){var d=a[b],h;if(typeof d=="object"&&d)if(m.call(d)=="[object Array]")for(h=d.length;h--;)I(d,h,c);else C(d,function(a){I(d,a,c)});return c.call(a,b,d)};k.parse=function(a,f){var c,d;b=0;A=""+a;c=F(q());q()!="$"&&j();b=A=w;return f&&m.call(f)=="[object Function]"?H((d={},d[""]=c,d),"",f):c}}}D&&define(function(){return k})})(this);return JSON;
}());
I$('89cdea88e368593644edd7acd2ff4418',function(_m,_p,_o,_f,_r){
if (_m._$KERNEL.engine==='trident'&&_m._$KERNEL.release=='2.0'){I$('38997a33234d258882b636bfce51ecf2',function (){
	    // eval for big string
	    JSON.parse = (function(){
	        // check save json string
	        // http://www.ietf.org/rfc/rfc4627.txt
	        var _isSafeJSON = function(_content){
	            return !(/[^,:{}\[\]0-9.\-+Eaeflnr-u \n\r\t]/.test(
	                        _content.replace(/"(\\.|[^"\\])*"/g,'')
	                    ));
	        };
	        return JSON.parse._$aop(function(_event){
	            var _str = _event.args[0]||'';
	            if (_str.length>=500000){  // &&_isSafeJSON(_str)
	                _event.stopped = !0;
	                _event.value = eval('('+_str+')');
	            }
	        });
	    })();
	});}return JSON;},'836fd3ea8c2cdd6a7842e1315a393abe');
I$('5b218a1b215c72ebda2676400ac1d838',function (){return JSON;},'89cdea88e368593644edd7acd2ff4418');
I$('c4a85b6e1f2052df7f9670001a73aea9',function(b1725258635351,_h,_u,_v,_p,_o,_f,_r){if (b1725258635351._$KERNEL.engine==='trident'&&b1725258635351._$KERNEL.release>='4.0'&&b1725258635351._$KERNEL.release<='5.0'){I$('b7ff6d6b2a164fee7874fa7d7445febc',function (){
        /**
         * 解析消息传递数据
         * @param  {Variable} 数据
         * @return {Variable} 数据
         */
        _h.__formatPassData = function(_data){
            // ie8-9 only support string data
            return JSON.stringify(_data);
        };
    });}
if (b1725258635351._$KERNEL.engine==='trident'&&b1725258635351._$KERNEL.release<='3.0'){I$('2323481810b18b47e3b778b17ada3158',function (_t){
        var _key = 'MSG|',
            _queue = [];
        /*
         * 检测window.name变化情况
         * @return {Void}
         */
        var _doCheckWindowName = function(){
            // check name
            var _name = unescape(window.name||'').trim();
            if (!_name||_name.indexOf(_key)!=0) return;
            window.name = '';
            // check result
            var _result = _u._$string2object(_name.replace(_key,''),'|'),
                _origin = (_result.origin||'').toLowerCase();
            // check origin
            if (!!_origin&&_origin!='*'&&
                location.href.toLowerCase().indexOf(_origin)!=0){
                return;
            }
            // dispatch onmessage event
            _v._$dispatchEvent(window,'message',{
                data:JSON.parse(_result.data||'null'),
                source:window.frames[_result.self]||_result.self,
                origin:_h.__formatOrigin(_result.ref||document.referrer)
            });
        };
        /*
         * 检测window.name设置队列
         * @return {Void}
         */
        var _doCheckNameQueue = (function(){
            var _checklist;
            // set window.name
            var _doSetWindowName = function(_map,_index,_list){
                if (_u._$indexOf(_checklist,_map.w)<0){
                    _checklist.push(_map.w);
                    _list.splice(_index,1);
                    _map.w.name = _map.d;
                }
            };
            return function(){
                _checklist = [];
                _u._$reverseEach(_queue,_doSetWindowName);
                _checklist = null;
            };
        })();
        /**
         * 跨文档发送数据
         * @param  {Window} 窗体对象
         * @param  {Object} 发送配置
         * @return {Void}
         */
        _h.__postMessage = (function(){
            // serialize send data
            var _doSerialize = function(_data){
                var _result = {};
                _data = _data||_o;
                _result.origin = _data.origin||'';
                _result.ref  = location.href;
                _result.self = _data.source;
                _result.data = JSON.stringify(_data.data);
                return _key+_u._$object2string(_result,'|',!0);
            };
            // function body
            return function(_window,_options){
                _queue.unshift({
                    w:_window,
                    d:escape(_doSerialize(_options))
                });
            };
        })();

        // init window onmessage event
        _t._$$CustomEvent._$allocate({
            element:window,
            event:'message'
        });
        setInterval(_doCheckNameQueue,100);
        setInterval(_doCheckWindowName,20);
    },'7bb0311ae4a29a38dce028b2ac370ee2','5b218a1b215c72ebda2676400ac1d838');}return _h;},'836fd3ea8c2cdd6a7842e1315a393abe','6676313c7af5106a9823fa04ad6746bd','3f115371e3e07e18707a0c434f8a73ce','72b60541618971d03c8b74f45c039218');
I$('482a3ce38efeffb22aaa475741ec4cbc',function (NEJ,_u,_e,_h,_p,_o,_f,_r){
    /**
     * 发送跨文档的消息
     *
     * 结构举例
     * ```html
     * <!-- 注意需要通过source进行双向交互的frame节点必须设置id属性作为标识 -->
     * <iframe id="targetFrame" src="http://a.b.com/a.html"></iframe>
     * ```
     *
     * 脚本举例
     * ```javascript
     * NEJ.define([
     *     'base/event'
     *     'util/ajax/message'
     * ],function(_v,_j){
     *     // top页面代码
     *     // 发送消息至 http://c.d.com 的页面
     *     _j._$postMessage('targetFrame',{
     *         data:'hello c.d.com',
     *         origin:'http://c.d.com'
     *     });
     *
     *     // http://a.b.com/a.html页面代码
     *     // 添加消息监测事件
     *     _v._$addEvent(
     *         window,'message',function(_event){
     *             // 因为top页面发送消息到 http://c.d.com
     *             // 所以在http://a.b.com页面不会收到任何消息
     *         }
     *     );
     *
     *     // top页面代码
     *     // 发送消息至 http://a.b.com 的页面
     *     _j._$postMessage('targetFrame',{
     *         data:'hello a.b.com'
     *     });
     *
     *     // http://a.b.com/a.html页面代码
     *     // 添加消息监测事件
     *     _v._$addEvent(
     *         window,'message',function(_event){
     *             // 必须先验证消息来源_event.origin是否你允许的域
     *              if (!_isAllow(_event.origin))
     *                 return;
     *
     *             // 处理_event.data中的消息内容
     *             // TODO something
     *
     *             // 回复消息，使用_event.source
     *             _j._$postMessage(_event.source,{
     *                 data:'hello!',
     *                 origin:_event.origin
     *             });
     *         }
     *     );
     * });
     * ```
     *
     * @method module:util/ajax/message._$postMessage
     * @param  {String|Window} arg0   - window对象或者Frame的name，或者字符串如_top、_parent、_self
     * @param  {Object}        arg1   - 消息配置
     * @property {Variable}      data   - 消息内容
     * @property {String}        origin - 目标Origin，只有指定的页面可以收到消息，如http://a.b.com
     * @property {String}        source - 当前窗体标识，除非你非常确定当前窗体的标识是什么，否则请采用自动识别
     * @return {Void}
     */
    _p._$postMessage = (function(){
        var _self = window.name||'_parent',
            _wmap = {
                '_top'   : window.top,
                '_self'  : window,
                '_parent': window.parent
            };
        return function(_target,_options){
            if (_u._$isString(_target)){
                _target = _wmap[_target]||
                          window.frames[_target]||
                         (_e._$get(_target)||_o).contentWindow;
                if (!_target) return;
            }
            // check data
            var _data = _u._$fetch({
                data:null,
                origin:'*',
                source:_self
            },_options);
            // send message
            _h.__postMessage(_target,_data);
        };
    })();

    if (CMPT){
        NEJ.copy(NEJ.P('nej.j'),_p);
    }

    return _p;
},'19c9fc0aab6a6b9db67f02f7d86454f4','3f115371e3e07e18707a0c434f8a73ce','15fb3eeb129e67b9b1cc98ef8ea8e26d','c4a85b6e1f2052df7f9670001a73aea9');
/*
 * TrimPath Template. Release 1.1.2.
 * Copyright (C) 2004 - 2007 TrimPath.
 * 
 * TrimPath Template is licensed under the GNU General Public License
 * and the Apache License, Version 2.0, as follows:
 *
 * This program is free software; you can redistribute it and/or 
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; either version 2
 * of the License, or (at your option) any later version.
 * 
 * This program is distributed WITHOUT ANY WARRANTY; without even the 
 * implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  
 * See the GNU General Public License for more details.
 * 
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 59 Temple Place - Suite 330, Boston, MA 02111-1307, USA.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * 
 * http://www.apache.org/licenses/LICENSE-2.0
 * 
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/*
 * ------------------------------------------
 * JST模板引擎实现文件
 * 实现原理参考trimpath项目 (GPL & APL)
 * http://code.google.com/p/trimpath/
 * @version  1.0
 * @author   genify(caijf@corp.netease.com)
 * ------------------------------------------
 */
(function(){
    /**
     * TrimPath模版引擎名字空间
     * @namespace TrimPath
     */
    // init TrimPath
    if (typeof TrimPath==='undefined'){
        TrimPath = {};
        if (typeof exports!=='undefined')
            TrimPath = exports;
    }
    // variable declaration
    var _tcache = {}, // jst string cache
        _stack  = [], // loop statement stack
        _rspc   = /\s+/g,
        _seed   = +new Date,
        _trim,_config,_vars;
    /*
     * 解析表达式中变量信息，如
     * a.b(c,d) || d('aaaa',f,g) && !!test() || 'eeee'
     * @param  {String} 内容
     * @return {Void}
     */
    var _doParseVars = (function(){
        var _reg0 = /^\s*[\[\{'"].*?[\]\}'"]\s*$/,
            _reg1 = /[\&\|\<\>\+\-\*\/\%\,\(\)\[\]\?\:\!\=\;]/,
            // keyword extend later
            _reg2 = /^(?:defined|null|undefined|true|false|instanceof|new|this|typeof|\$v|[\d]+)$/i,
            // statement extend later
            // new XX
            _reg3 = /^new\s+/,
            _reg4 = /['"]/;
        var _doParseSimple = function(_value){
            if (_reg0.test(_value)) return;
            _value = _value.split('.')[0].trim();
            if (!_value||_reg4.test(_value)) return;
            _value = _value.replace(_reg3,'');
            //console.log('-->'+_value+'<--');
            try{
                if (_reg2.test(_value))
                    return;
                _vars[_value] = 1;
                //console.log('=====>'+_value+'<====');
            }catch(e){
                // ignore
            }
        };
        return function(_content){
            _content = _content||'';
            // for string/array
            if (!_content||_reg0.test(_content)) 
                return;
            var _arr = _content.split(_reg1);
            for(var i=0,l=_arr.length;i<l;i++)
                _doParseSimple(_arr[i]);
        };
    })();
    /*
     * 解析{for x in b}字符串的前缀
     * @param  {Array}  按空格拆分的值,['for','x','in','b']
     * @return {String} 解析后的前缀值
     */
    var _doParsePrefixFor = function(_part){
        if (_part[2]!='in')
            throw 'bad for loop statement: '+_part.join(' ');
        _stack.push(_part[1]);
        // b is array or has [1,2,4],{a:'aaa',b:'bbb'}
        _doParseVars(_part[3]);
        return 'var __HASH__'+_part[1]+' = '+_part[3]+','+
                    _part[1]+','+_part[1]+'_count=0;'+
               'if (!!__HASH__'+_part[1]+')'+
                   'for(var '+_part[1]+'_key in __HASH__'+_part[1]+'){'+
                        _part[1]+' = __HASH__'+_part[1]+'['+_part[1]+'_key];'+
                        'if (typeof('+_part[1]+')=="function") continue;'+
                        _part[1]+'_count++;';
    };
    /*
     * 解析{forelse}字符串的前缀
     * @return {String} 解析后的前缀值
     */
    var _doParsePrefixForElse = function(){
        var _part = _stack[_stack.length-1];
        return '}; if(!__HASH__'+_part+'||!'+_part+'_count){';
    };
    /*
     * 解析{/for}字符串的前缀
     * @return {String} 解析后的前缀值
     */
    var _doParsePrefixForEnd = function(){
        _stack.pop();
        return '};';
    };
    /*
     * 解析{list seq as x}或者{list 1..100 as x}字符串的前缀
     * @param  {Array}  按空格拆分的值,['list','seq','as','x']
     * @return {String} 解析后的前缀值
     */
    var _doParsePrefixList = function(_part){
        if (_part[2]!='as')
            throw 'bad for list loop statement: '+_part.join(' ');
        var _seq = _part[1].split('..');
        if (_seq.length>1){
            // {list 1..100 as x}
            _doParseVars(_seq[0]);
            _doParseVars(_seq[1]);
            return 'for(var '+_part[3]+','+_part[3]+'_index=0,'+
                        _part[3]+'_beg='+_seq[0]+','+_part[3]+'_end='+_seq[1]+','+
                        _part[3]+'_length=parseInt('+_part[3]+'_end-'+_part[3]+'_beg+1);'+
                        _part[3]+'_index<'+_part[3]+'_length;'+_part[3]+'_index++){'+
                        _part[3]+' = '+_part[3]+'_beg+'+_part[3]+'_index;';
        }else{
            // {list seq as x}
            // seq is array [1,2,4]
            _doParseVars(_part[1]);
            return 'for(var __LIST__'+_part[3]+' = '+_part[1]+','+
                        _part[3]+','+_part[3]+'_index=0,'+
                        _part[3]+'_length=__LIST__'+_part[3]+'.length;'+
                        _part[3]+'_index<'+_part[3]+'_length;'+_part[3]+'_index++){'+
                        _part[3]+' = __LIST__'+_part[3]+'['+_part[3]+'_index];';
        }
    };
    /*
     * 解析{macro macroName(arg1,arg2,...argN)}字符串的前缀
     * @param  {Array}  按空格拆分的值,['macro','macroName(arg1,arg2,...argN)']
     * @return {String} 解析后的前缀值
     */
    var _doParsePrefixMacro = function(_part){
        if (!_part||!_part.length) return;
        _part.shift(); // remove macro key word
        var _name = _part[0].split('(')[0];
        return 'var '+_name+' = function'+_part.join('').replace(_name,'')+'{var __OUT=[];';
    };
    /*
     * 解析{include "text-template-id"}字符串前缀
     * @param  {Array}  按空格拆分的值,['include','"text-template-id"']
     * @return {String} 解析后的前缀值
     */
    var _doParsePrefixInline = function(_part){
        if (!_part[1]) 
            throw 'bad include statement: '+_part.join(' ');
        return 'if (typeof inline == "function"){__OUT.push(inline(';
    };
    /**
     * 解析IF语句前缀，{if customer != null && customer.balance > 1000 || test(customer)}
     * @param  {String}  返回值
     * @param  {Array}   按空格拆分的值
     * @return {String}  解析后的前缀值
     */
    var _doParsePrefixCondition = function(_prefix,_part){
        _doParseVars(_part.slice(1).join(' '));
        return _prefix;
    };
    // parse prefix condition
    var _doParsePrefixConditionIF = function(_part){
        return _doParsePrefixCondition('if(',_part);
    };
    var _doParsePrefixConditionELSEIF = function(_part){
        return _doParsePrefixCondition('}else if(',_part);
    };
    var _doParsePrefixConditionVAR = function(_part){
        return _doParsePrefixCondition('var ',_part);
    };
    // jst configuration
    _config = {
        blk : /^\{(cdata|minify|eval)/i,
        tag : 'forelse|for|list|if|elseif|else|var|macro|break|notrim|trim|include',
        // {pmin : min param number,
        //  pdft : param default value,
        //  pfix : statement prefix,
        //  sfix : statement suffix}
        def : {
            'if'     : {pfix:_doParsePrefixConditionIF,sfix:'){',pmin:1},
            'else'   : {pfix:'}else{'},
            'elseif' : {pfix:_doParsePrefixConditionELSEIF,sfix:'){',pdft:'true'},
            '/if'    : {pfix:'}'},
            'for'    : {pfix:_doParsePrefixFor,pmin:3},
            'forelse': {pfix:_doParsePrefixForElse},
            '/for'   : {pfix:_doParsePrefixForEnd},
            'list'   : {pfix:_doParsePrefixList,pmin:3},
            '/list'  : {pfix:'};'},
            'break'  : {pfix:'break;'},
            'var'    : {pfix:_doParsePrefixConditionVAR,sfix:';'},
            'macro'  : {pfix:_doParsePrefixMacro},
            '/macro' : {pfix:'return __OUT.join("");};'},
            'trim'   : {pfix:function(){_trim = !0;}},
            '/trim'  : {pfix:function(){_trim = null;}},
            'inline' : {pfix:_doParsePrefixInline,pmin:1,sfix:'));}'}
        },
        ext : {
            'seed'   : function(_prefix){return (_prefix||'')+''+_seed;},
            'default': function(_value,_default){return _value||_default;}
        }
    };
    /*
     * 解析语句，如{if customer != null && customer.balance > 1000}
     * @param  {String} 待解析语句
     * @param  {Array}  内容输出
     * @return {Void}
     */
    var _doParseStatement = (function(){
        var _rbrc = /\\([\{\}])/g;
        return function(_content,_out){
            _content = _content.replace(_rbrc,'$1');
            //console.log('++++>'+_content);
            var _part = _content.slice(1, -1).split(_rspc),
                _conf = _config.def[_part[0]];
            if (!_conf){_doParseSectionText(_content,_out);return;}
            if (!!_conf.pmin&&_conf.pmin>=_part.length)
                throw 'Statement needs more parameters:'+_content;
            // parse prefix
            _out.push((!!_conf.pfix&&
                       typeof(_conf.pfix)!='string')
                       ?_conf.pfix(_part):(_conf.pfix||''));
            // parse params and suffix
            if (!!_conf.sfix){
                if (_part.length<=1) {
                    if (!!_conf.pdft) _out.push(_conf.pdft);
                }else{
                    for(var i=1,l=_part.length;i<l;i++){
                        if (i>1) _out.push(' ');
                        _out.push(_part[i]);
                    }
                }
                _out.push(_conf.sfix);
            }
        };
    })();
    /*
     * 解析表达式，如['firstName','default:"John Doe"','capitalize']
     * @param  {Array}  表达式内容
     * @param  {Number} 表达式索引
     * @param  {Array}  内容输出
     * @return {Void}
     */
    var _doParseExpression = function(_exps,_out){
        // foo|a:x|b:y1,y2|c:z1,z2 -> c(b(a(foo,x),y1,y2),z1,z2)
        if (!_exps||!_exps.length) return;
        if (_exps.length==1){
            var _var = _exps.pop();
            _doParseVars(_var);
            // fix error for ${}
            _out.push(_var==''?'""':_var);
            return;
        }
        var _exp = _exps.pop().split(':');
        _out.push('__MDF[\''+_exp.shift()+'\'](');
        _doParseExpression(_exps,_out);
        if (_exp.length>0){
            var _args = _exp.join(':');
            _doParseVars(_args);
            _out.push(','+_args);
        }
        _out.push(')');
    };
    /*
     * 解析内容，内容中可能包含换行
     * @param  {String} 待解析语句
     * @param  {Array}  内容输出
     * @return {Void}
     */
    var _doParseSectionText = function(_content,_out){
        if (!_content) return;
        var _lines = _content.split('\n');
        if (!_lines||!_lines.length) return;
        for(var i=0,l=_lines.length,_line;i<l;i++){
            _line = _lines[i];
            if (!!_trim){
                _line = _line.trim();
                if (!_line) continue;
            } 
            _doParseSectionTextLine(_line,_out);
            if (!!_trim&&i<l-1) _out.push('__OUT.push(\'\\n\');');
        }
    };
    /*
     * 解析内容，内容中可能包含${a}或者${%a%}取值语句
     * @param  {String} 待解析语句
     * @param  {Array}  内容输出
     * @return {Void}
     */
    var _doParseSectionTextLine = (function(){
        var _raor = /\|\|/g,
            _rvor = /#@@#/g;
        return function(_content,_out){
            // defined used variable
            var _prvmrkend = '}',_prvexpend = -1,
                _length = _content.length,
                _begin,_end,_begexp,_endexp,_exparr;
            while((_prvexpend+_prvmrkend.length)<_length){
                _begin = '${'; _end = '}';
                _begexp = _content.indexOf(_begin,_prvexpend+_prvmrkend.length);
                if (_begexp<0) break;
                // parse ${% customer.firstName %} syntax
                if (_content.charAt(_begexp+2)=='%'){
                    _begin = '${%'; _end = '%}';
                }
                _endexp = _content.indexOf(_end,_begexp+_begin.length);
                if (_endexp<0) break;
                _doParseText(_content.substring(_prvexpend+_prvmrkend.length,_begexp),_out);
                // parse expression: 'firstName|default:"John Doe"|capitalize'.split('|')
                _exparr = _content.substring(_begexp+_begin.length,_endexp).replace(_raor,'#@@#').split('|');
                for(var i=0,l=_exparr.length;i<l;_exparr[i]=_exparr[i].replace(_rvor,'||'),i++);
                _out.push('__OUT.push('); _doParseExpression(_exparr,_out); _out.push(');');
                _prvmrkend = _end; _prvexpend = _endexp;
            }
            _doParseText(_content.substring(_prvexpend+_prvmrkend.length),_out);
        };
    })();
    /*
     * 解析纯文本内容，不包含需要解析的内容
     * @param  {String} 待解析内容
     * @param  {Array}  内容输出
     * @return {Void}
     */
    var _doParseText = (function(){
        var _map = {r:/\n|\\|\'/g,'\n':'\\n','\\':'\\\\','\'':'\\\''};
        var _doEncode = function(_content){
            return (_content||'').replace(_map.r,function($1){
                return _map[$1]||$1;
            });
        };
        return function(_content,_out){
            if (!_content) return;
            _out.push('__OUT.push(\''+_doEncode(_content)+'\');');
        };
    })();
    /*
     * 解析模板为执行函数
     * @param  {String}   模板内容
     * @return {Function} 模板执行函数
     */
    var _doParseTemplate = (function(){
        var _rtab = /\t/g,
            _rnln = /\n/g,
            _rlne = /\r\n?/g;
        var _doSearchEnd = function(_content,_begin){
            var _index = _content.indexOf("}",_begin+1);
            // for {for x in \{a:'aaa',b:'bbbb'\}}
            while(_content.charAt(_index-1)=='\\'){
                _index = _content.indexOf("}",_index+1);
            }
            return _index;
        };
        var _doParseVarMap = function(){
            var _arr = [],
                _arg = arguments[0];
            for(var x in _arg){
                x = (x||'').trim();
                if (!x) continue;
                _arr.push(x+'=$v(\''+x+'\')');
            }
            return _arr.length>0?('var '+_arr.join(',')+';'):'';
        };
        return function(_content){
            _vars = {};
            _content = _content.replace(_rlne,'\n').replace(_rtab,'    ');
            var _ftxt = ['if(!__CTX) return \'\';',''];
            _ftxt.push('function $v(__NAME){var v = __CTX[__NAME];return v==null?window[__NAME]:v;};');
            _ftxt.push('var defined=function(__NAME){return __CTX[__NAME]!=null;},');
            _ftxt.push('__OUT=[];');
            // defiend used variables
            var _prvend = -1,_length = _content.length;
            var _stmtbeg,_stmtend,_statement,
                _blockrx,_blktmp,_blkend,_blkmrk,_blktxt;
            // search content
            while((_prvend+1)<_length){
                // search statement begin
                _stmtbeg = _prvend;
                _stmtbeg = _content.indexOf("{",_stmtbeg+1);
                while(_stmtbeg>=0){
                    _stmtend = _doSearchEnd(_content,_stmtbeg);
                    _statement = _content.substring(_stmtbeg,_stmtend);
                    _blockrx = _statement.match(_config.blk);
                    // minify/eval/cdata implementation
                    if (!!_blockrx){
                        _blktmp = _blockrx[1].length+1;
                        _blkend = _content.indexOf('}',_stmtbeg+_blktmp);
                        if (_blkend>=0){
                            // gen block end marker
                            _blkmrk = _blkend-_stmtbeg-_blktmp<=0
                                    ? ('{/'+_blockrx[1]+'}')
                                    : _statement.substr(_blktmp+1);
                            _blktmp = _content.indexOf(_blkmrk,_blkend+1);
                            // parse block content
                            if (_blktmp>=0){
                                _doParseSectionText(_content.substring(_prvend+1,_stmtbeg),_ftxt);
                                // get block text and parse
                                _blktxt = _content.substring(_blkend+1,_blktmp);
                                switch(_blockrx[1]){
                                    case 'cdata' : _doParseText(_blktxt,_ftxt); break;
                                    case 'minify': _doParseText(_blktxt.replace(_rnln,' ').replace(_rspc,' '),_ftxt); break;
                                    case 'eval'  : if (!!_blktxt) _ftxt.push('__OUT.push((function(){'+_blktxt+'})());'); break;
                                }
                                _stmtbeg = _prvend = _blktmp+_blkmrk.length-1;
                            }
                        }
                    }else if(_content.charAt(_stmtbeg-1)!='$'&&
                             _content.charAt(_stmtbeg-1)!='\\'&&
                             _statement.substr(_statement.charAt(1)=='/'?2:1)
                                                         .search(_config.tag)==0){
                        // break when result is a statement
                        break;
                    }
                    _stmtbeg = _content.indexOf("{",_stmtbeg+1);
                }
                if (_stmtbeg<0) break;
                _stmtend = _doSearchEnd(_content,_stmtbeg);
                if (_stmtend<0) break;
                // parse content
                _doParseSectionText(_content.substring(_prvend+1,_stmtbeg),_ftxt);
                _doParseStatement(_content.substring(_stmtbeg,_stmtend+1),_ftxt);
                _prvend = _stmtend;
            }
            _doParseSectionText(_content.substring(_prvend+1),_ftxt);
            _ftxt.push(';return __OUT.join("");'); 
            _ftxt[1] = _doParseVarMap(_vars);
            _vars = null;
            //console.log(_ftxt.join(''));
            return new Function('__CTX','__MDF',_ftxt.join(''));
        };
    })();
    // interface
    /**
     * 取模板随机数种子
     *
     * 代码举例
     * ```javascript
     * NEJ.define([
     *     'util/template/trimpath.nej'
     * ],function(){
     *     // 模版统一随机标识
     *     var _seed = TrimPath.seed();
     * });
     * ```
     * 
     * @method TrimPath.seed
     * @return {String} 随机数种子
     */
    TrimPath.seed = function(){
        return _seed;
    };
    /**
     * 根据模板的序列号合并模板数据
     * 
     * 代码举例
     * ```javascript
     * NEJ.define([
     *     'util/template/trimpath'
     * ],function(){
     *     // 模版合并数据
     *     var _html = TrimPath.merge(
     *         _jst_id,{
     *             a:'aaaaaa',
     *             b:'bbbbbbbbbb',
     *             c:'cccccccccccc'
     *         }
     *     );
     * });
     * ```
     *
     * @method TrimPath.merge
     * @param  {String} arg0 - 模板序列号
     * @param  {Object} arg1 - 模板数据
     * @param  {Object} arg2 - 扩展接口
     * @return {String}        合并数据后的内容
     */
    TrimPath.merge = (function(){
        var _fcache = {};
        // for test
        TrimPath.dump = function(){
            return {
                func:_fcache,
                text:_tcache
            };
        };
        return function(_sn,_data,_extend){
            try{
                _data = _data||{};
                if (!_fcache[_sn]&&!_tcache[_sn])
                    return '';
                if (!_fcache[_sn]){
                    _fcache[_sn] = _doParseTemplate(_tcache[_sn]);
                    delete _tcache[_sn];
                }
                if (!!_extend){
                    for(var x in _config.ext)
                        if (!_extend[x])
                            _extend[x] = _config.ext[x];
                }
                return _fcache[_sn](_data,_extend||_config.ext);
            }catch(ex){
                return ex.message||'';
            }
        };
    })();
    /**
     * 添加JST模板，JST模板可以是节点的值
     *
     * 代码举例
     * ```javascript
     * NEJ.define([
     *     'util/template/trimpath'
     * ],function(){
     *     // 解析缓存模版
     *     var _jst_id = TrimPath.merge(
     *         '<div>\
     *              <p>${a}</p>\
     *              <p>${b}</p>\
     *              <p>${c}</p>\
     *          </div>'
     *     );
     * });
     * ```
     *
     * @method TrimPath.parse
     * @param  {String}  arg0 - JST模板内容
     * @param  {Boolean} arg1 - 是否保留节点
     * @return {String}         JST模板在缓存中的标识
     */
    TrimPath.parse = (function(){
        var _xeed = +new Date;
        return function(_content,_sn){
            if (!_content) return '';
            _sn = _sn||('ck-'+(_xeed++));
            if (_tcache[_sn]!=null){
                console.warn('jst template overwrited with key '+_sn);
                console.debug('old template content: '+_tcache[_sn].replace(/\n/g,' '));
                console.debug('new template content: '+_content.replace(/\n/g,' '));
            }
            _tcache[_sn] = _content;
            return _sn;
        };
    })();
})();
I$('ff746cdffa6022e10ac6474410445437',function (NEJ,_u,_e,_x,_t,_p,_o,_f,_r){
    var _ext = {};
    /**
     * 取模板随机数种子
     *
     * 脚本举例
     * ```javascript
     * NEJ.define([
     *     'util/template/jst'
     * ],function(_p){
     *     // 返回一个标识符
     *     var _seed = _p._$seed();
     * });
     * ```
     *
     * @method module:util/template/jst._$seed
     * @return {String} 随机数种子
     */
    _p._$seed = TrimPath.seed;
    /**
     * 根据模板的序列号合并模板数据
     *
     * 脚本举例
     * ```javascript
     * NEJ.define([
     *     'util/template/jst'
     * ],function(_p){
     *     // 添加模版
     *     var _html_seed =  _p._$add('<div>${name}</div>');
     *     // 生成结构<div>jack</div>
     *     var _html = _p._$get(_html_seed,{name:'jack'});
     * });
     * ```
     *
     * @method module:util/template/jst._$get
     * @see    module:util/template/jst._$add
     * @param  {String} arg0 - 模板序列号
     * @param  {Object} arg1 - 模板数据
     * @param  {Object} arg2 - 扩展接口
     * @return {String}        合并数据后的内容
     */
    _p._$get = (function(){
        var _doInline = function(_id){
            return !_p._$getTextTemplate?'':
                    _p._$getTextTemplate(_id);
        };
        return function(_sn,_data,_extend){
            _data = _data||{};
            _data.inline = _doInline;
            _extend = _u._$merge({},_ext,_extend);
            _extend.rand = _u._$uniqueID;
            _extend.format = _u._$format;
            _extend.escape = _u._$escape;
            _extend.inline = _doInline;
            return TrimPath.merge(_sn,_data,_extend);
        };
    })();
    /**
     * 添加JST模板，JST模板可以是节点的值
     *
     * 脚本举例
     * ```javascript
     * NEJ.define([
     *     'util/template/jst'
     * ],function(_p){
     *     // 添加模版缓存
     *     var _html_seed =  _p._$add('<div>${name}</div>');
     * });
     * ```
     *
     * @method module:util/template/jst._$add
     * @see    module:util/template/jst._$get
     * @param  {String}  arg0 - JST模板内容或者节点ID
     * @param  {Boolean} arg1 - 是否保留节点
     * @return {String}         JST模板在缓存中的序列号
     */
    _p._$add = function(_content,_keep){
        if (!_content) return '';
        var _sn,_element = _e._$get(_content);
        if (!!_element){
            _sn = _element.id;
            _content = _element.value||_element.innerText;
            if (!_keep) _e._$remove(_element);
        }
        return TrimPath.parse(_content,_sn);
    };
    /**
     * 添加JST模板内容
     * 
     * @method module:util/template/jst._$addTemplate
     * @see    module:util/template/jst._$add
     * @param  {String}  arg0 - JST模板内容
     * @param  {String}  arg1 - 模板标识
     * @return {String}         JST模板在缓存中的序列号
     */
    _p._$addTemplate = function(_content,_sn){
        return TrimPath.parse(_content,_sn);
    };
    /**
     * 整合模板后输出至指定容器节点
     *
     * 结构举例
     * ```html
     * <div id="box">aaa</div>
     * ```
     *
     * 脚本举例
     * ```javascript
     * NEJ.define([
     *     'util/template/jst'
     * ],function(_p){
     *     // 添加模版缓存
     *     var _html_seed =  _p._$add('<div>${name}</div>');
     *     // 把结构塞到box中，生成<div id="box"><div>jack</div></div>
     *     _p._$render('box',_html_seed,{name:'jack'});
     * });
     * ```
     *
     * @method module:util/template/jst._$render
     * @param  {String|Node} arg0 - 容器节点
     * @param  {String}      arg1 - 模板序列号
     * @param  {Object}      arg2 - 模板数据
     * @param  {Object}      arg3 - 扩展接口
     * @return {Void}
     */
    /**
     * @method CHAINABLE._$render
     * @see module:util/template/jst._$render
     */
    _p._$render = function(_parent,_sn,_data,_extend){
        _parent = _e._$get(_parent);
        if (!!_parent){
            _parent.innerHTML =
                _p._$get(_sn,_data,_extend);
        }
    };
    /**
     * 注册JST扩展方法
     *
     * 结构举例
     * ```html
     * <textarea name="jst" id="abc">
     *   <div>
     *     <p>${name|a|b}</p>
     *   </div>
     * </textarea>
     * ```
     *
     * 脚本举例
     * ```javascript
     * NEJ.define([
     *     'util/template/jst'
     * ],function(_p){
     *     // 注册扩展方法 a和b
     *     _p._$extend({
     *         a:function(){},
     *         b:function(){}
     *     });
     *     // 模板整合数据
     *     _p._$render(
     *         'box','abc',{name:'jack'}
     *     );
     * });
     * ```
     *
     * @method module:util/template/jst._$extend
     * @param  {Object} arg0 - 扩展方法
     * @return {Void}
     */
    _p._$extend = function(_map){
        _u._$merge(_ext,_map);
    };
    // for chainable method
    _x._$merge({_$render:_p._$render});

    if (CMPT){ 
        var _z = NEJ.P('nej.e');
        _z._$addHtmlTemplate     = _p._$add;
        _z._$getHtmlTemplate     = _p._$get;
        _z._$getHtmlTemplateSeed = _p._$seed;
        _z._$renderHtmlTemplate  = _p._$render;
        _z._$registJSTExt        = _p._$extend;
    }

    return _p;
},'19c9fc0aab6a6b9db67f02f7d86454f4','3f115371e3e07e18707a0c434f8a73ce','15fb3eeb129e67b9b1cc98ef8ea8e26d','29e075e23a8f0b7ec637c0da9509d27a','13726c367e9a751ff0a5539fba2c66e7');
I$('542fab9973f7cdb3d850d2bdf6833803',function (_e, _u, _platform, _j, _jp) {
  /**
   * [_$sendMsg 往iframe发送消息]
   * @param  {[type]}   frameId  [iframeId]
   * @param  {[type]}   data     []
   * @return {[null]}
   */
  _u._$sendMsg = function (frameId, data) {
    console.log('send msg')
    console.log(data)
    if (location) {
      data.href = location.href
    }

    _j._$postMessage(frameId, {
      data: _u._$isString(data) ? data : JSON.stringify(data)
    })
  }

  /**
   * [initModule 加载模块]
   * @param  {[string]} type [目标模块]
   * @param  {[type]} target [目标模块]
   * @param  {[string|node]} node [容器id或容器]
   * @param  {[type]} data   [数据，选填]
   * @return {[type]}        [null]
   */
  _u.initModule = function (type, target, node, data) {
    var module = _jp._$add(target)
    var element = _e._$get(node)
    element ? element.innerHTML = _jp._$get(module, data).trim() : console.log('node of ' + type + ' is undefined!!')
  }

  _u.changeActive = function (nodeList, target) {
    if (!_e._$hasClassName(target, 'active')) {
      if (nodeList) {
        _u._$forEach(nodeList, function (item) {
          _e._$delClassName(item, 'active')
        })
      }

      _e._$addClassName(target, 'active')
    }
  }

  _u._$objWatch = function (obj, prop, callback) {
    if (!obj.$property) {
      obj.$property = function (prop, value) {
        if (this[prop] !== value) {
          this[prop] = value;
          return callback(this);
        }
        return this;
      }
    }
  }

  return _u
},'15fb3eeb129e67b9b1cc98ef8ea8e26d','07295d3d10c258de51c70bf22b7ff622','836fd3ea8c2cdd6a7842e1315a393abe','482a3ce38efeffb22aaa475741ec4cbc','ff746cdffa6022e10ac6474410445437');
I$('f9797207da2091aa22c4e79ebd14ba7b',function (_e, _v, _u, _p) {
  // var isScroll = false
  var closeList = []
  var styleNode

  _p._$init = function (node, scrollTop, customNode) {
    _p.node = _e._$get(node)

    if (customNode) {
      _e._$getByClassName(_p.node, 'j-custom-item')[0].append(customNode)
    }

    _u._$forEach(closeList, function (item) {
      var temp = _e._$getByClassName(_p.node, 'j-index-' + item)[0]
      _e._$delClassName(temp, 'active')
    })
    // 即使是在关闭列表中，但是其中的子菜单被选中时，还是需要打开
    var crtNode = _e._$getByClassName(_p.node, 'z-crt')[0]
    var crtParentNode = crtNode ? crtNode.parentNode ? crtNode.parentNode.parentNode : '' : ''
    if (crtParentNode && _e._$hasClassName(crtParentNode, 'yun-parent')) {
      _e._$addClassName(crtParentNode, 'active')
    }

    var index = this.getScrollTopByIndex(crtNode)
    // if (isScroll && index) {
    //   scrollTop = 53 * index
    // } else {
    //   isScroll = false
    // }
    // 点击事件触发的，不自动定位
    var mh = 53
    var showScrollTopStart = mh * index
    var ch = document.documentElement.clientHeight - 64
    if (showScrollTopStart + mh > scrollTop + ch) {
      // 隐藏在下面
      scrollTop = showScrollTopStart + 2 * mh - ch
    } else if (scrollTop > showScrollTopStart) {
      // 隐藏在上面
      scrollTop = showScrollTopStart - mh
    }
    _e._$getByClassName(_p.node, 'm-yun-left')[0].scrollTop = scrollTop

    this.addEvent()
  }

  _p.addEvent = function () {
    _v._$clearEvent(this.node, 'click')
    _v._$addEvent(this.node, 'click', _p.ops)
  }

  _p.ops = function (event) {
    var target = _v._$getElement(event, 'c:j-yun-menu')
    if (target) {
      // isScroll = false
      // var crtList = _e._$getByClassName(_p.node, 'z-crt')
      // _u._$forEach(crtList, function (item) {
      //   _e._$delClassName(item, 'z-crt')
      // })
      // _e._$addClassName(target, 'z-crt')
      // return
    }

    target = _v._$getElement(event, 'c:yun-less-list')
    if (target) {
      // 子菜单
      return
    }

    // 父元素
    target = _v._$getElement(event, 'c:yun-parent')
    if (!target) {
      return
    }

    var index = _p.getScrollTopByIndex(target)
    if (_e._$hasClassName(target, 'active')) {
      _e._$delClassName(target, 'active')
      if (_u._$indexOf(closeList, index) === -1) {
        closeList.push(index)
      }
    } else {
      _e._$addClassName(target, 'active')
      var listIndex = _u._$indexOf(closeList, index)
      if (listIndex !== -1) {
        closeList.splice(listIndex, 1)
      }
    }
  }

  /**
   * [getScrollTopByIndex 根据index获取当前应该定位的高度，暂时只定位父级目录]
   * @param  {[node]}   target [当前定位的node]
   * @return {[number]}      [scrollTop]
   */
  _p.getScrollTopByIndex = function (target) {
    var targetIndex
    if (target) {
      var list = target.classList ? target.classList : target.className.split(/\s+/)
      _u._$forEach(list, function (item) {
        if (item.indexOf('j-index-') !== -1) {
          var index = item.replace('j-index-', '')
          try {
            targetIndex = parseInt(index)
          } catch (error) {
            console.log(error)
          }
        }
      })
    }
    return targetIndex
  }

  _p.addStyle = function (data) {
    if (styleNode) {
      _e._$remove(styleNode, false)
    }

    var style = ''
    _u._$forEach(data.list, function (item) {
      style = _p.setStyle(style, item)

      if (item.list) {
        _u._$forEach(item.list, function (lessItem) {
          style = _p.setStyle(style, lessItem)
        })
      }
    })

    styleNode = _e._$addStyle(style)
  }

  _p.setStyle = function (style, item) {
    if (item.iconPosition) {
      style = style + '.m-yun-base .' + item.clazz + '{background-position: ' + item.iconPosition.base + ';} .m-yun-base .z-crt *>.' + item.clazz + ', .m-yun-base :hover>.' + item.clazz + '{background-position: ' + item.iconPosition.hover + ';}'
    }

    return style
  }
},'15fb3eeb129e67b9b1cc98ef8ea8e26d','72b60541618971d03c8b74f45c039218','542fab9973f7cdb3d850d2bdf6833803');
I$('46e728ed94253a743910263e624644a1',function (_e, _v, _u, _p) {
  _p._$init = function (parent, data) {
    this.data = data
    this.parent = _e._$getByClassName(parent, 'wrap-service')[0]
    this.isShow = false
    this.addEvent()
    this.open = this.open.bind(this)
    this.clickClose = this.clickClose.bind(this)
    this.close = this.close.bind(this)
    this.overItem = this.overItem.bind(this)
  }

  _p.addEvent = function () {
    _v._$addEvent(this.parent, 'mouseover', this.overItem)// 左右测选中项相关逻辑
    _v._$addEvent(this.parent, 'mouseover', this.open)
    _v._$addEvent(this.parent, 'click', this.clickClose)
  }

  _p.clickClose = function (e) {
    if (e.target.className && e.target.className.indexOf('mainContainer') != -1) {
      _p.close(e)
    }
  }

  _p.open = function (e) {
      _p.isShow = true
      var target = _e._$getByClassName(_p.parent, 'mainContainer')[0]
      _e._$delClassName(target, 'mainContent_disappear')
  }

  _p.close = function (e) {
    if (e.target.className && e.target.className.indexOf('mainContainer') != -1) {
      _p.isShow = false
      _e._$addClassName(e.target, 'mainContent_disappear')
    }
  }

  // _p.tooggleService = function () {
  //   this.isShow = !this.isShow
  //   var target = _e._$getByClassName(this.parent, 'mainContainer')[0]
  //   var fn = this.isShow ? _e._$delClassName : _e._$addClassName
  //   fn(target, 'mainContent_disappear')
  // }

  _p.overItem = function (e) {// 修改左右选中项
    if (e.target.className && e.target.className.indexOf('leftItem') != -1) {
      var leftList = _e._$getByClassName(_p.parent, 'leftItem')
      var rightList = _e._$getByClassName(_p.parent, 'rightTarget')
      var index = e.target.attributes.index.value
      _p.changeActiveName(leftList, e.target, 'activeLeft')
      _p.removeAllName(rightList, rightList[index], 'mainContent_disappear')
    }
  }

  _p.changeActiveName = function (nodeList, target, name) {
    if (!_e._$hasClassName(target, name)) {
      if (nodeList) {
        _u._$forEach(nodeList, function (item) {
          _e._$delClassName(item, name)
        })
      }
      _e._$addClassName(target, name)
    }
  }
  _p.removeAllName = function (nodeList, target, name) {
    if (_e._$hasClassName(target, name)) {
      if (nodeList) {
        _u._$forEach(nodeList, function (item) {
          _e._$addClassName(item, name)
        })
      }
      _e._$delClassName(target, name)
    }
  }
},'15fb3eeb129e67b9b1cc98ef8ea8e26d','72b60541618971d03c8b74f45c039218','542fab9973f7cdb3d850d2bdf6833803');
I$('c26aac78045e1fe32f4f3df2f2593498',"<div class=\"m-yun-base m-yun-head\">\n  <div class=\"j-header\"></div>\n  <iframe id=\"targetFrame\" name=\"targetFrame\" border=\"0\" frameborder=\"0\" width=\"0\" height=\"0\"></iframe>\n  <div class=\"j-improve\"></div>\n</div>\n");
I$('257cd0ef1a97e4f8fd1c1f850779b73b',"<div class=\"m-yun-base m-yun-left-container {if hide}z-hide{/if}\">\n  <div class=\"m-yun-base m-yun-left\">\n    <ul>\n      {if title && title !== \"\"}\n        <li class=\"yun-title j-index-${index} {if locale.locale === 'en_US'}\n          f-en-us\n          {/if}\">\n          {var index = index + 1}\n          {if url}\n          <a {if url.indexOf('target:') === -1}href=\"${url}\"{else}href=\"${url.split('target:')[1]}\" target=\"_blank\"{/if} {if tip}title=\"${tip}\"{/if}>${title}</a>\n          {else}\n          <span class=\"name\">${title}</span>\n          {/if}\n        </li>\n      {/if}\n      {var index = 0}\n      {if customSdItem}\n        <li class=\"j-custom-item j-index-${index}\"></li>\n        {var index = index + 1}\n      {/if}\n      {if list}\n        {list list as model}\n          <li class=\"{if model.list}\n            yun-parent\n            {if model.hide == 1}\n              active yun-parent-hide\n            {else}\n              j-index-${index}\n              {var index = index + 1}\n              {if sdOpen}\n                active\n              {else}\n                {list model.list as lessModel}\n                  {if path.indexOf(lessModel.url) === 0 || (origin + path).indexOf(lessModel.url) === 0}\n                    active\n                  {/if}\n                {/list}\n              {/if}\n            {/if}\n          {else}\n            j-index-${index}\n            {var index = index + 1}\n            j-yun-menu\n            {if path.indexOf(model.url) === 0 || (origin + path).indexOf(model.url) === 0}\n              z-crt\n            {/if}\n          {/if}\">\n            {if model.hide !== 1}\n              <a {if model.url}{if model.url.indexOf('target:') === -1}href=\"${model.url}\"{else}href=\"${model.url.split('target:')[1]} target=\"_blank\"{/if}{/if}>\n                <i class=\"u-icon ${model.clazz}\"></i><span class=\"name\">${model.text}</span>\n              </a>\n            {/if}\n            {if model.list}\n              <ul class=\"yun-less-list\">\n                {list model.list as lessModel}\n                  <li class=\"j-yun-menu j-index-${index}\n              {var index = index + 1}{if path.indexOf(lessModel.url) === 0 || (origin + path).indexOf(lessModel.url) === 0}z-crt{/if}\">\n                    <a {if lessModel.url.indexOf('target:') === -1}href=\"${lessModel.url}\"{else}href=\"${lessModel.url.split('target:')[1]}\" target=\"_blank\"{/if}>\n                      <i class=\"u-icon ${lessModel.clazz}\"></i><span>${lessModel.text}</span>\n                    </a>\n                  </li>\n                {/list}\n              </ul>\n            {/if}\n          </li>\n        {/list}\n      {/if}\n    </ul>\n  </div>\n</div>\n");
I$('de00d00d362cfba5215ef005fa813b53',"<div class=\"mainContainer toggleTarget mainContent_disappear\">\n  <div class=\"leftContainer\">\n    {list menuList as menu}\n    <div index=${menu_index} class=\"leftItem {if menu_index == 0} activeLeft {/if}\">${menu.title}</div>\n    {/list}\n  </div>\n  <div class=\"rightContainer\">\n    {list menuList as menu}\n    {if menu.type === 'simple'}\n    <div index=${menu_index} class=\"simpleBlock rightTarget {if menu_index != 0} mainContent_disappear {/if}\">\n      {list menu.data as item}\n      <a href=\"${item.url}\" target=\"_blank\">\n        ${item.content}\n        {if item.isRecommend}\n        <div class=\"hotIcon\">HOT</div>\n        {/if}\n      </a>\n      {/list}\n    </div>\n    {else}\n    <div index=${menu_index} class=\"complexBlock rightTarget {if menu_index != 0} mainContent_disappear {/if}\">\n      {list menu.data as item}\n      <div class=\"complexItem\">\n        <div class=\"complexItem_title\">${item.title}</div>\n        <div class=\"complexItem_mainBox\">\n          {list item.list as detail}\n          <a href=\"${detail.url}\" target=\"_blank\">${detail.content}\n            {if detail.isRecommend}\n            <div class=\"hotIcon\">HOT</div>\n            {/if}\n          </a>\n          {/list}\n        </div>\n      </div>\n      {/list}\n    </div>\n    {/if}\n    {/list}\n  </div>\n</div>");
I$('5fae61394280575515a74043cd9268a0',"<div class=\"user-account\">\n  <img class=\"account-avator\" src=\"${baseUrl}/res/images/avatar/nAvatar.png\"/>\n  <!-- <img class=\"account-avator\" src=\"http://test.163.com:8090/res/images/avatar/nAvatar.png\"/> -->\n  <!-- nAvatar -->\n  <span>${userName || ssn}</span>\n</div>\n<div class=\"user-list\">\n  <ul>\n    {if locale.locale === 'zh_CN' || isSubUser === 'true'}\n      <a href=\"${infoUrl}\">\n        <li><img class=\"icon\" src='${baseUrl}/res/images/sdk/baseInfo.png'/>个人中心</li>\n      </a>\n    {/if}\n    {if isSubUser !== 'true' && isCommon !== 'true'}\n      {if locale.locale === 'zh_CN'}\n        <a href=\"${balanceUrl}\">\n          <li><img class=\"icon\" src='${baseUrl}/res/images/sdk/acconutInfo.png'/>账户信息</li>\n        </a>\n        <a href=\"${certifyUrl}\">\n          <li><img class=\"icon\" src='${baseUrl}/res/images/sdk/credentials.png'/>认证信息</li>\n        </a>\n        <a href=\"${securityUrl}\">\n          <li><img class=\"icon\" src='${baseUrl}/res/images/sdk/accountSafe.png'/>账户安全</li>\n        </a>\n      {/if}\n      {if accessUrl}\n        <a href=\"${accessUrl}\">\n          <li><img class=\"icon\" src='${baseUrl}/res/images/sdk/userPower.png'/>用户与权限</li>\n        </a>\n      {else}\n        <a class=\"j-showModal\">\n          <li><img class=\"icon\" src='${baseUrl}/res/images/sdk/userPower.png'/>用户与权限</li>\n        </a>\n      {/if}\n    {/if}\n    {if (isSubUser === 'true' || locale.locale === 'zh_CN') && isCommon !== 'true'}\n      <a href=\"${accesskeyUrl}\">\n        <li><img class=\"icon\" src='${baseUrl}/res/images/sdk/accessKey.png'/>Access Key</li>\n      </a>\n    {/if}\n    {if locale.locale === 'zh_CN'}\n      {if isDistributor === 'true'}\n        <a href=\"${channelPanelUrl}\">\n          <li><i class=\"u-icon u-icon-less u-icon-channel\"></i>渠道管理</li>\n        </a>\n      {/if}\n      {if isBaseOperator === 'true'}\n        <a href=\"${channelBaseOperatorUrl}\">\n          <li><i class=\"u-icon u-icon-less u-icon-operator\"></i>基地运营商面板</li>\n        </a>\n      {/if}\n      {if iotType === 'OPERATOR'}\n        <a href=\"${iotOperatorUrl}\">\n          <li><i class=\"u-icon u-icon-less u-icon-iot\"></i>IoT 账单</li>\n        </a>\n      {/if}\n      {if iotType === 'CUSTOMER'}\n        <a href=\"${iotCustomUrl}\">\n          <li><i class=\"u-icon u-icon-less u-icon-iot\"></i>IoT 账单</li>\n        </a>\n      {/if}\n    {/if}\n    <li class=\"j-exit lastOne\"><img class=\"icon\" src='${baseUrl}/res/images/sdk/exit.png'/>退出账号</li>\n  </ul>\n</div>\n");
I$('9bcad601fe1a6cd5dc002cc58d7b6095',"<div class=\"m-yun-base m-yun-mask\">\n  <div class=\"m-yun-improve m-yun-dialog\">\n    <div class=\"dialog-title\">${locale.content.title}</div>\n    <div class=\"dialog-content\">\n      <img src=\"$((baseUrl))/res/images/improve.png\" srcset=\"$((baseUrl))/res/images/improve.png 1x, $((baseUrl))/res/images/improve@2x.png 2x\">\n      <p>${locale.content.desc}</p>\n    </div>\n    <div class=\"dialog-btns u-btn-line\">\n      <a href=\"${passportUrl}/improve-info?referrer=$((baseUrl))\" class=\"u-btn u-btn-primary u-btn-lg\">${locale.content.btnStr}</a>\n    </div>\n    <div class=\"dialog-timeout\">\n      ${locale.content.countdownBefore}<span class=\"j-time\">5</span>${locale.content.countdownAfter}\n    </div>\n  </div>\n</div>\n");
I$('4a8051dab0be3a135be79caf2c562fee',"<div class=\"m-yun-base m-yun-mask\">\n  <div class=\"m-yun-improve m-yun-exclusive m-yun-dialog\">\n    <div class=\"dialog-content\">\n      <img src=\"$((baseUrl))/res/images/exclusive.png\" srcset=\"$((baseUrl))/res/images/exclusive.png 1x, $((baseUrl))/res/images/exclusive@2x.png 2x\">\n      <p>该账号不能在此登录，请联系您的云管理员</p>\n    </div>\n    <div class=\"dialog-btns u-btn-line\">\n      <a href=\"${homesiteUrl}\" class=\"u-btn u-btn-primary u-btn-lg\">确定</a>\n    </div>\n    <div class=\"dialog-timeout\">\n      <span class=\"j-time\">5</span>S后自动跳转\n    </div>\n  </div>\n</div>\n");
I$('76768f2557c694f62a86363764ade37b',"<div class=\"head-wrap\">\n  <div class=\"wrap-logo\">\n    {if source === 'dun'}\n    {if locale.locale === 'en_US'}\n    <a href=\"$((dunHomesiteUrl))/locale/en\" title=\"Go to YIDUN website homepage\" target=\"_blank\">\n      <img src=\"$((baseUrl))/res/images/logo_dun_en_US.png\"\n        srcset=\"$((baseUrl))/res/images/logo_dun_en_US.png 1x, $((baseUrl))/res/images/logo_dun_en_US@2x.png 2x\"\n        alert=\"NETEASE YIDUN\">\n      {else}\n      <a href=\"$((dunHomesiteUrl))\" title=\"到易盾首页\" target=\"_blank\">\n        <img src=\"$((baseUrl))/res/images/logo_dun.png\"\n          srcset=\"$((baseUrl))/res/images/logo_dun.png 1x, $((baseUrl))/res/images/logo_dun@2x.png 2x\" alert=\"网易易盾\">\n        {/if}\n        {else}\n        <a class=\"{if locale.locale === 'en_US'}f-en-us{/if}\" href=\"${homesiteUrl}\" title=\"${locale.content.logoTitle}\"\n          target=\"_blank\">\n          {if locale.locale === 'en_US'}\n          <img src=\"$((baseUrl))/res/images/logo_en_US.png?t=20200713\"\n            srcset=\"$((baseUrl))/res/images/logo_en_US.png?t=20200713 1x, $((baseUrl))/res/images/logo_en_US@2x.png?t=20200713 2x\"\n            alert=\"NetEase DigitalSail\">\n          {else}\n          <img src=\"$((baseUrl))/res/images/logo.png?t=20200709\"\n            srcset=\"$((baseUrl))/res/images/logo.png?t=20200709 1x, $((baseUrl))/res/images/logo@2x.png?t=20200709 2x\"\n            alert=\"网易数帆\">\n          {/if}\n          {/if}\n        </a>\n  </div>\n  {if locale.locale === 'zh_CN'}\n  <a href=\"${baseUrl}\">\n    <!-- <div class=\"wrap-name {if zl_selected}z-selected{/if}\"> -->\n    <div class=\"wrap-name\">\n      <span>首页</span>\n    </div>\n  </a>\n  {/if}\n  <div class=\"wrap-name wrap-service f-dn toggleTarget\">\n    <span class=\"toggleTarget\">产品与服务</span>\n    <div class=\"toggleTarget head-services j-service {if locale.locale === 'en_US'}f-en-us{/if}\">\n    </div>\n  </div>\n</div>\n<div class=\"head-op\">\n  {if locale.locale === 'zh_CN' && source === 'dun'}\n  <a class=\"op-menu\" href=\"$((dunUrl))/dashboard#/m/export-record/\">导出记录</a>\n  {/if}\n  {if show_order}\n  <!-- <a class=\"op-menu op-order {if order_selected}z-selected{/if}\" href=\"${orderUrl}\"> -->\n  <a class=\"op-menu op-order\" href=\"${orderUrl}\">\n    工单\n    <!-- <i class=\"u-icon u-icon-order\"></i> -->\n  </a>\n  {/if}\n  {if show_im_order}\n  <div class=\"op-menu op-im\">\n    <span>工单</span>\n    <div class=\"op-list\">\n      <ul>\n        <li><a href=\"https://hubble.netease.com/sl/aaaefB\">提交工单</a></li>\n        <li><a href=\"https://hubble.netease.com/sl/aaaefC\">我的工单</a></li>\n      </ul>\n    </div>\n  </div>\n  <div class=\"op-menu op-im op-im-dev\">\n    <span>开发者中心</span>\n    <div class=\"op-list\">\n      <ul>\n        <li><a href=\"https://hubble.netease.com/sl/aaaed1\" target=\"_blank\">开发文档</a></li>\n        <li><a href=\"https://hubble.netease.com/sl/aaaed2\" target=\"_blank\">知识库</a></li>\n        <li><a href=\"https://hubble.netease.com/sl/aaaed3\" target=\"_blank\">Demo&SDK下载</a></li>\n        <li><a href=\"https://hubble.netease.com/sl/aaaed4\" target=\"_blank\">视频教程</a></li>\n        <li><a href=\"https://hubble.netease.com/sl/aaaed5\" target=\"_blank\">易云社区</a></li>\n      </ul>\n    </div>\n  </div>\n  {/if}\n  {if locale.locale === 'zh_CN'}\n  {if show_dun_order}\n  <div class=\"op-menu op-dun-order\">\n    <span>工单</span>\n    <div class=\"op-list\">\n      <ul>\n        <li><a href=\"$((dunUrl))/dashboard#/m/work/create/\">提交工单</a></li>\n        <li><a href=\"$((dunUrl))/dashboard#/m/work/index/\">我的工单</a></li>\n      </ul>\n    </div>\n  </div>\n  {/if}\n  {if docUrl}\n  <a class=\"op-menu\" href=\"${docUrl}\" target=\"_blank\">\n    文档\n    <!-- <i class=\"u-icon u-icon-help\"></i> -->\n  </a>\n  {/if}\n  <a class=\"op-menu op-message j-message-link\" href=\"${msgHref}\">\n    <span class=\"msgIconContainer\">\n      <span class=\"dotContainer\">\n        <img src='${baseUrl}/res/images/sdk/msg.png' />\n        <span class=\"redDot\"></span>\n      </span>\n      <span class='line'></span>\n    </span>\n  </a>\n  {/if}\n  <div class=\"op-user j-account {if locale.locale === 'en_US'}f-en-us{/if}\"></div>\n  {if showLocale}\n  <div class=\"op-locale j-locale-c\"></div>\n  {/if}\n</div>");
I$('f40e2fcd3b0d983b183f5b0f5dc62180',"<div class=\"m-top-locale\">\n  {if locale === 'zh_CN'}\n    简体中文\n  {else}\n    English\n  {/if}\n</div>\n<div class=\"locale-list\">\n  <ul>\n    <li class=\"j-locale\" data-locale=\"zh_CN\">简体中文</li>\n    <li class=\"j-locale\" data-locale=\"en_US\">English</li>\n  </ul>\n</div>\n");
I$('a61cb9fc46042759284f455999e739db',"<div class=\"m-yun-base m-yun-loading\">\n  <img src=\"$((baseUrl))/res/images/loading.gif\">\n</div>\n");
I$('936490ea87b05306b352e94b504df50a',function (NEJ,_u,_p,_o,_f,_r){
    /**
     * 设置或者获取cookie
     *
     * * 没有输入第二个参数则表示返回已有cookie
     * * 如果cookie值为空字符串则表示删除cookie
     *
     * 脚本举例
     * ```javascript
     *   NEJ.define([
     *       'util/cookie'
     *   ],function(_j){
     *       // 设置cookie的name=abc
     *       var _cookie = _j._$cookie('name','abc');
     *       _j._$cookie('name',{value:'abc'});
     *
     *       // 设置路径，domain(如果domain不同域，cookie设置不会成功),设置过期时间1天;
     *       var _cookie = _j._$cookie('name',{
     *           value:'abc',
     *           path:'/a/',
     *           domain:'www.163.com',
     *           expires:1
     *       });
     *
     *       // 删除cookie
     *       _j._$cookie('name','');
     *       _j._$cookie('name',{expires:-1});
     *   });
     * ```
     *
     * @method   module:util/cache/cookie._$cookie
     * @param    {String}        arg0    - cookie名称
     * @param    {String|Object} arg1    - cookie值，如果有其他配置信息输入对象，已处理属性包括
     * @property {String}        value   - cookie值
     * @property {String}        path    - 路径
     * @property {String}        domain  - 域名，当前域或者当前域的父域
     * @property {Number}        expires - 过期时间偏移，单位天，负值表示删除cookie
     * @return   {String}                  cookie值
     */
    _p._$cookie = (function(){
        var _date = new Date(),
            _crut = +_date,   // current time milliseconds
            _days = 86400000; // milliseconds of one day
        var _getcookie = function(_name){
            var _cookie = document.cookie,
                _search = '\\b'+_name+'=',
                _index1 = _cookie.search(_search);
            if (_index1<0) return '';
            _index1 += _search.length-2;
            var _index2 = _cookie.indexOf(';',_index1);
            if (_index2<0) _index2 = _cookie.length;
            return _cookie.substring(_index1,_index2)||'';
        };
        return function(_name,_data){
            if (_data===undefined){
                return _getcookie(_name);
            }
            if (_u._$isString(_data)){
                if (!!_data){
                    document.cookie = _name+'='+_data+';';
                    return _data;
                }
                _data = {expires:-100};
            }
            _data = _data||_o;
            var _cookie = _name+'='+(_data.value||'')+';';
            delete _data.value;
            if (_data.expires!==undefined){
                _date.setTime(_crut+_data.expires*_days);
                _data.expires = _date.toGMTString();
            }
            _cookie += _u._$object2string(_data,';');
            //console.log(_cookie);
            document.cookie = _cookie;
        };
    })();

    if (CMPT){
        NEJ.copy(NEJ.P('nej.j'),_p);
    }

    return _p;
},'19c9fc0aab6a6b9db67f02f7d86454f4','3f115371e3e07e18707a0c434f8a73ce');
I$('fd3a9f5970d8303df5e5046c6c297f45',"<!-- Modal -->\n<div class=\"m-yun-base modal fade in show\">\n  <div class=\"modal-dialog\" style=\"width: ${width || 640}px; margin-left: -${(width || 640) / 2}px;\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n        <div class=\"close j-close\"></div>\n        <h4 class=\"modal-title\">${title}</h4>\n      </div>\n      <div class=\"modal-body\">\n        ${content}\n      </div>\n      <div class=\"modal-footer\">\n        {if !onlyClose}\n          <button type=\"button\" class=\"u-btn u-btn-primary j-confirm\">${confirmTitle || \"确认\"}</button>\n          <button type=\"button\" class=\"u-btn u-btn-secondary j-close\">${coloseText || \"关闭\" }</button>\n        {else}\n          <button type=\"button\" class=\"btn btn-default j-close\">${coloseText || \"我知道了\" }</button>\n        {/if}\n      </div>\n    </div>\n  </div>\n</div>");
I$('82de7eaeb19578f576fdc1e5cd4ab162',function (e, v, j, u, sdkUtil, _modal, p) {
  var frameId = 'targetFrame';
  var modalNode

  p.$showModal = function () {
    p.hideScroll(true)

    var id = 'yunBaseModal-' + new Date().getTime()
    modalNode = e._$html2node('<div id="' + id + '" class="m-163yun-modal"></div>')
    document.body.appendChild(modalNode)

    var authServiceType = j._$cookie('authServiceType')

    u.initModule('modal', _modal, id, {
      width: 646,
      title: '用户与权限',
      content: '<div class="modal-auth">' +
        '<div class="tip">网易数帆用户与权限提供了两个服务模块：云计算基础服务的访问控制服务和云安全（易盾）的权限管理服务。设置默认路径后，再次进入用户与权限，系统将直接跳转至已选择的服务模块。各服务页面均可以再次设置默认路径。</div>' +
        '<div class="f-radio">' +
        '<label>选择服务模块</label>' +
        '<div><input id="auth-1" name="authServiceType" value="cloudBase" type="radio" ' + (authServiceType ? authServiceType === 'cloudBase' ? 'checked' : '' : 'checked') + '/><label for="auth-1">云计算基础服务</label></div>' +
        '<div><input id="auth-2" name="authServiceType" value="cloudSafe" type="radio" ' + (authServiceType && authServiceType === 'cloudSafe' ? 'checked' : '') + '/><label for="auth-2">云安全（易盾）</label></div>' +
        '</div>' +
        '<div class="f-check"><input id="auth-check" type="checkbox"/><label for="auth-check">设为默认路径</label></div></div>'
    })

    p.initEvent(modalNode)
  }

  p.initEvent = function (node) {
    v._$addEvent(node, 'click', function (event) {
      var target = v._$getElement(event, 'c:j-close')
      if (target) {
        // close
        p.close(node)
        return
      }

      target = v._$getElement(event, 'c:j-confirm')
      if (target) {
        var data = p.getCheckData()
        if (data.check) {
          sdkUtil._$sendMsg(frameId, {
            name: 'auth',
            authServiceType: data.authServiceType
          })
          // close
          p.close(node)
        } else {
          var authServiceTypeFrameId = 'authServiceTypeFrame'
          var nContainer = e._$html2node('<iframe id="' + authServiceTypeFrameId + '" src="' + window.passportUrl + '/userinfo/seed?authServiceType=' + data.authServiceType + '&timestap=' + new Date().getTime() + '" name="' + authServiceTypeFrameId + '" border="0" frameborder="0" width="0" height="0"></iframe>')
          document.body.appendChild(nContainer)
          v._$addEvent(authServiceTypeFrameId, 'load', function () {
            p.goTarget(data, nContainer)
          })

          setTimeout(function () {
            p.goTarget(data, nContainer)
          }, 3000)

          // sdkUtil._$sendMsg(frameId, {
          //   name: 'authWithCookie',
          //   authServiceType: data.authServiceType
          // }, function () {})
        }
      }
    })
  }

  p.goTarget = function (data, nContainer) {
    if (nContainer) {
      p.close(nContainer)
    }

    if (modalNode) {
      p.close(modalNode)
    }

    if (data.authServiceType === 'cloudSafe') {
      location.href = '$((cloudSafeUrl))'
    } else if (data.authServiceType === 'cloudBase') {
      location.href = '$((cloudBaseUrl))'
    }
  }

  p.getCheckData = function () {
    var temp = {
      authServiceType: e._$get('auth-2').checked ? 'cloudSafe' : 'cloudBase'
    }
    if (e._$get('auth-check').checked) {
      temp.check = true
    }

    return temp
  }

  p.close = function (node) {
    p.hideScroll(false)
    node.parentNode.removeChild(node)
  }

  p.hideScroll = function (isHide) {
    if (isHide) {
      // 隐藏body上的滚动条，163yun,dun
      e._$addClassName(sdkUtil._$getBody(), 'z-yun-base-noScroll')
    } else {
      // 恢复body上的滚动条, 163yun,dun
      e._$delClassName(sdkUtil._$getBody(), 'z-yun-base-noScroll')
    }
  }
},'15fb3eeb129e67b9b1cc98ef8ea8e26d','72b60541618971d03c8b74f45c039218','936490ea87b05306b352e94b504df50a','07295d3d10c258de51c70bf22b7ff622','542fab9973f7cdb3d850d2bdf6833803','fd3a9f5970d8303df5e5046c6c297f45');
I$('e1c8abbc71be152cfd9c0e38b62e41b6',function (_e, _v, _u, _modal, _p) {
  _p._$init = function (parent, baseSignOut) {
    this.parent = parent
    this.baseSignOut = baseSignOut

    this.addEvent()
  }

  _p.addEvent = function () {
    _v._$addEvent(this.parent, 'click', _p.ops)
  }

  _p.ops = function (event) {
    var target = _v._$getElement(event, 'c:j-exit')
    if (target) {
      _p.baseSignOut()
      return
    }

    target = _v._$getElement(event, 'c:j-showModal')
    if (target) {
      _modal.$showModal()
    }
  }
},'15fb3eeb129e67b9b1cc98ef8ea8e26d','72b60541618971d03c8b74f45c039218','542fab9973f7cdb3d850d2bdf6833803','82de7eaeb19578f576fdc1e5cd4ab162');
I$('b11b47df465ec67dbbcb9599adab01c4',function (_e, _p) {
  _p._$init = function (parent) {
    this.parent = parent
    this.timeout()
  }

  _p.timeout = function () {
    var node = _e._$getByClassName(this.parent, 'j-time')[0]
    var time = 5
    var int = setInterval(function () {
      time = time - 1
      if (time <= 0) {
        int = window.clearInterval(int);
        location.href = window.passportUrl + '/improve-info?referrer=' + location.href
        return
      } else {
        node.innerHTML = time
      }
    }, 1000)
  }

  return _p
},'15fb3eeb129e67b9b1cc98ef8ea8e26d');
I$('f0a4fdc005307654ff3b2f09188fd67a',function (_e, _p) {
  _p._$init = function (parent) {
    this.parent = parent
    this.timeout()
  }

  _p.timeout = function () {
    var node = _e._$getByClassName(this.parent, 'j-time')[0]
    var time = 5
    var int = setInterval(function () {
      time = time - 1
      if (time <= 0) {
        int = window.clearInterval(int);
        location.href = window.homesiteUrl
        return
      } else {
        node.innerHTML = time
      }
    }, 1000)
  }

  return _p
},'15fb3eeb129e67b9b1cc98ef8ea8e26d');
I$('4f90e6d4ee11a6259207b3c5f8660b16',function (_e, _v, _u, _p) {
  _p._$init = function (parent, localeChange) {
    this.parent = parent
    this.localeChange = localeChange
    this.addEvent()
  }

  _p.addEvent = function () {
    _v._$addEvent(this.parent, 'click', _p.ops)
  }

  _p.ops = function (event) {
    var target = _v._$getElement(event, 'c:j-locale')
    if (target) {
      var locale = _e._$dataset(target, 'locale')
      _p.localeChange(locale)
    }
  }
},'15fb3eeb129e67b9b1cc98ef8ea8e26d','72b60541618971d03c8b74f45c039218','542fab9973f7cdb3d850d2bdf6833803');
I$('e8f4df6e5619977f936f1165ff618200',{
  "AuthorityManagement": "Authority Management",
  "SignOut": "Sign Out",
  "BasicInformation": "Basic Information"
}
);
I$('4a6e8c1a6ba9099cc0446eb97eef38a4',{
  "AuthorityManagement": "用户与权限",
  "SignOut": "退出账号",
  "BasicInformation": "基本信息"
}
);
I$('01659721d63b2051901a39fe4ffed69b',function (enUs, zhCn) {
  return {
    en_US: enUs,
    zh_CN: zhCn
  }
},'e8f4df6e5619977f936f1165ff618200','4a6e8c1a6ba9099cc0446eb97eef38a4');
I$('6c1a0a707b43b6902581e2bbb836d69c',{
  "products": "Products",
  "logoTitle": "Go to the website homepage"
}
);
I$('92aa8c8a3e8b317048accea21084d1f8',{
  "products": "产品与服务",
  "logoTitle": "到网易数帆首页"
}
);
I$('98597b10e80f920a01458f08d4381f0d',function (enUs, zhCn) {
  return {
    en_US: enUs,
    zh_CN: zhCn
  }
},'6c1a0a707b43b6902581e2bbb836d69c','92aa8c8a3e8b317048accea21084d1f8');
I$('92c4424e74503fcedc8443d6e153bff0',{
  "title": "Improve User Information",
  "desc": "System detects that your account information is not improved yet. In order to ensure your use without difficulty, please improve your information.",
  "btnStr": "Go Immediately",
  "countdownBefore": "Automatically jump in ",
  "countdownAfter": " seconds"
}
);
I$('f730488bb6db5bbb89ffdaeb73a65177',{
  "title": "完善用户信息",
  "desc": "系统检测到您的账号信息尚未完善，为保证您的使用不受影响，建议前往完善信息页面",
  "btnStr": "立刻前往",
  "countdownBefore": "",
  "countdownAfter": "S后自动跳转"
}
);
I$('6b74770df59526d1a0f767d9db22ef95',function (enUs, zhCn) {
  return {
    en_US: enUs,
    zh_CN: zhCn
  }
},'92c4424e74503fcedc8443d6e153bff0','f730488bb6db5bbb89ffdaeb73a65177');
I$('50d35519bbac775b6d2d5bf434367fae',{
  "unKnowErrorMsg": "Network or browser failure, please try again later"
}
);
I$('d22f48f6c6dc558500301be93a3780ab',{
  "unKnowErrorMsg": "网络或浏览器出现问题，请稍后再试"
}
);
I$('f37b8076207da3bf800c8df924fdaec1',function (enUs, zhCn) {
  return {
    en_US: enUs,
    zh_CN: zhCn
  }
},'50d35519bbac775b6d2d5bf434367fae','d22f48f6c6dc558500301be93a3780ab');
I$('339f15ac2dc609db41177afb8d5db3f4',function (account, top, improve, base) {
  return {
    top: top,
    account: account,
    improve: improve,
    base: base
  }
},'01659721d63b2051901a39fe4ffed69b','98597b10e80f920a01458f08d4381f0d','6b74770df59526d1a0f767d9db22ef95','f37b8076207da3bf800c8df924fdaec1');
I$('5f27648084348a2f2d2d582a526e697b',function (_e, _v, _jp, _u, _sd, _Service, _top, _left, _service, _account, _improve, _exclusive, _header, _locale, _loading, _Account, _Improve, _Exclusive, _Locale, _LocaleData, _p) {
  var v = '$((sdkVersion))'
  var msgNames = ['sdList', 'account', 'service'];
  var frameId = 'targetFrame';
  var locale = 'zh_CN'

  window.homesiteUrl = '$((homesiteUrl))'
  window.baseUrl = '$((baseUrl))'
  window.loadingToken = true
  /* eslint-disable */
  // 此处必须用双引号，勿做改动
  window.passportUrl = _u._$getPassportUrl("$((passportUrl))")
  /* eslint-enable */
  var loginUrl = window.passportUrl + '/login'

  _p._$init = function (options) {
    _p.options = options
    _p.ready = false

    setTimeout(function () {
      _p.shLoading(true)
    }, 300)

    // 未确定是否登录时不展示顶部导航
    /* 优先返回本地存的数据
    var userInfo = sessionStorage.getItem('userInfo')
    if (userInfo) {
      userInfo = JSON.parse(userInfo)
      _p.initAccount(userInfo)
    } */

    _u.initModule('top', _top, _p.options.head)
    this.addEvent()
    _e._$get(frameId).src = '$((baseUrl))/frameI18n?v=' + v + '&source=' + options.source + '&useLocale=' + !!options.useLocale + '&location=' + location.href
  }

  _p.addEvent = function () {
    // 监听iframe的load事件
    _v._$addEvent(frameId, 'load', this.frameReady._$bind(this, frameId))
    _v._$addEvent(window, 'hashchange', this.sdChange._$bind(this))

    // 优先监听localStorage的变化
    // _v._$addEvent(document, 'visibilitychange', function () {
    //   if (_p.visibilityState === 'hidden' && document.visibilityState === 'visible') {
    //     _u._$sendMsg(frameId, {
    //       name: 'account',
    //       reset: true
    //     })
    //   }

    //   _p.visibilityState = document.visibilityState
    // })

    if (location.href.indexOf('$((cUrl))') === 0) {
      _v._$addEvent(window, 'hashchange', this.headChange._$bind(this))
    }
  }

  _p.initHeader = function (locale) {
    var data = {
      zl_selected: location.href === '$((baseUrl))/',
      msg_selected: _u._$url2origin(location.href) === '$((baseUrl))' && location.pathname === '/message',
      show_order: location.href.indexOf('$((cUrl))') === 0,
      show_dun_order: _p.options.source === 'dun',
      show_im_order: _p.options.source === 'im',
      order_selected: location.href.indexOf('$((cUrl))/dashboard#/m/ticket/') === 0,
      baseUrl: _u._$SafariChangeUrl('$((baseUrl))'),
      homesiteUrl: _u._$SafariChangeUrl('$((homesiteUrl))'),
      orderUrl: _u._$SafariChangeUrl('$((cUrl))/dashboard#/m/ticket/'),
      // docUrl: _p.options.source === 'dun' ? 'http://support.dun.163.com/' : (_p.options.source === 'im' ? '' : '$((homesiteUrl))/help'),
      docUrl: _p.options.source === 'dun' ? 'http://support.dun.163.com/' : (_p.options.source === 'im' ? '' : _p.options.isCommon ? '' : '$((homesiteUrl))/help'),
      msgHref: _p.options.source === 'im' ? 'https://hubble.netease.com/sl/aaaehx' : _u._$SafariChangeUrl('$((baseUrl))/message#/Subscribe'),
      locale: {
        locale: locale,
        content: _LocaleData.top[locale]
      },
      showLocale: _p.options.useLocale && _p.options.source === 'dun',
      source: _p.options.source
    }

    _u.initModule('head', _header, _e._$getByClassName(_p.options.head, 'j-header')[0], data)

    var parentNode = _e._$getByClassName(_p.options.head, 'j-locale-c')[0]
    if (parentNode) {
      _u.initModule('locale', _locale, parentNode, {
        locale: locale
      })
      _Locale._$init(parentNode, function (locale) {
        _u._$sendMsg(frameId, {
          name: 'locale',
          locale: locale
        })
      })
    }
  }

  /**
   * [frameReady iframe加载完毕事件]
   * @param  {[type]} frameId [frameId]
   * @return {[type]}         []
   */
  _p.frameReady = function () {
    console.log('send frame ready')
    var tempId = frameId
    _v._$addEvent(window, 'message', function (event) { // 开始监听iframe或者自身 传递过来的信息
      _p.analyzeMsg(event.data)
    })

    window.loadingToken = true
    _u._$sendMsg(tempId, {// 触发iframe的ready事件
      name: 'ready'
    })

    var time = 2
    var int = setInterval(function () { // 如果初次ready没有得到反馈，重试两次
      time = time - 1
      console.log(_p.ready)
      if (time <= 0 || _p.ready) {
        int = window.clearInterval(int);
        return
      } else {
        console.log('send frame ready again')
        window.loadingToken = true
        _u._$sendMsg(tempId, {
          name: 'ready'
        })
      }
    }, 1000)
  }

  _p.initFrameMsg = function (frameId) {
    console.log('start frame post msg')
    // ['sdList', 'account', 'service']; 通知iframe执行下面三个事件
    _u._$sendMsg(frameId, {
      name: msgNames
    })
  }

  _p.analyzeLocalMsg = function (name, obj) {
    var temp = {
      name: name,
      msg: obj
    }

    _p.analyzeMsg(temp)
  }

  /**
   * [analyzeMsg 解析返回的数据]
   * @param  {[object]} data [返回的数据]
   * @return {[null]}
   */
  _p.analyzeMsg = function (data) {
    // ie下可能需要多解一次
    try {
      while (_u._$isString(data)) {
        data = JSON.parse(data)
      }
    } catch (e) {
      // 可能收到无法解析的消息，捕获异常避免报错
      console.log('sdk analyzeMsg error:' + e)
      console.log(data)
      return
    }
    switch (data.name) {
      case 'loadingToken':
        window.loadingToken = true

        _p.shLoading(true)

        var time = 7
        var int = setInterval(function () {
          time = time - 1
          if (time <= 0) {
            int = window.clearInterval(int);
            if (window.loadingToken) {
              // 还是没拿到token
              _p.shLoading(false)
              setTimeout(function () {
                alert(_LocaleData.base[locale].unKnowErrorMsg)
              }, 0)
            }
            return
          }
        }, 1000)

        break
      case 'sdList':
        if (_p.options.sdHide) {
          if (!data.msg) {
            data.msg = {}
          }

          data.msg.hide = true
        }

        // key相同，认为数据相同，不更新
        if (_p.options.sdData && _p.options.sdData.key === data.msg.key) {
          return
        }
        _p.options.sdData = data.msg
        _sd.addStyle(data.msg)
        _p.initSd(data.msg)
        break
      case 'account':
        // 已获取到账号信息，展示顶部导航
        _p.shHeader()

        _p.initAccount(data.msg, true)

        if (!data.msg.reset) {
          // 需要获取到子账号信息之后再根据账号信息渲染之后的页面
          _u._$isFunction(_p.options.init) ? _p.options.init({
            locale: locale
          }) : null
        }
        break
      case 'service':
        var sNode = _e._$getByClassName(_p.options.head, 'j-service')[0]
        if (data.msg && data.msg.properties && data.msg.properties._components && data.msg.properties._components.length >= 1) {
          var mainData = { baseUrl: _u._$SafariChangeUrl('$((baseUrl))'), menuList: data.msg.properties._components }
          // var mainData = { baseUrl: 'http://test.163.com:8090', menuList: data.msg.properties._components }
          _e._$delClassName(sNode.parentNode, 'f-dn')
          _u.initModule('service', _service, sNode, mainData)
          _Service._$init(_e._$get(_p.options.head), mainData)
        }
        break
      case 'ready':
        _p.ready = true
        // if (location.hostname.indexOf('localName') === -1) {
        if (window.loadingToken) {
          _p.shLoading(false)
          window.loadingToken = false
          locale = data.locale

          _p.initHeader(locale) // 初始化头部
          _p.initFrameMsg(frameId) // 初始化msg
        }
        break
      case 'newMsg':
        // 英文版可能没有link
        if (data.msg && data.msg.items) {
          var fn = !!data.msg.count ? _e._$addClassName : _e._$delClassName
          var msgDotContainerNode = _e._$getByClassName(_p.options.head, 'dotContainer')[0]
          var container = _e._$getByClassName(_p.options.head, 'j-message-link')[0]
          var href = _p.options.source === 'im' ? 'https://hubble.netease.com/sl/aaaehx' : _u._$SafariChangeUrl('$((baseUrl))/message#/Subscribe')
          if (data.msg.count) href = _u._$SafariChangeUrl('$((baseUrl))/message#/UNREAD/1')
          container.setAttribute('href', href)
          fn(msgDotContainerNode, 'hasMsg')
        }
        break
      case 'signOut':
        var userInfo = sessionStorage.getItem('userInfo')
        if (userInfo) {
          try {
            userInfo = JSON.parse(userInfo)
          } catch (e) {
            console.log(e)
          }
        }
        sessionStorage.removeItem('userInfo')
        _u._$isFunction(_p.options.signOut) ? _p.options.signOut() : (location.href = loginUrl + '?locale=' + locale + (_p.options.useLocale ? '&i18nEnable=true' : '') + '&referrer=' + encodeURIComponent('$((baseUrl))' + (_p.options.useLocale && locale === 'en_US' && userInfo.isSubUser ? '/user#/profile/' : '')))
        break
      case 'improve-info':
        // 已获取到账号信息，需要展示
        _p.shHeader()

        if (location.href.indexOf('$((baseUrl))') === 0) {
          // 此处需要删除token，避免刷新后可用
          _u._$sendMsg(frameId, {
            name: 'removeToken'
          })
          window.loadingToken = false
          _p.shLoading(false)
          var iNode = _e._$getByClassName(_p.options.head, 'j-improve')[0]
          _u.initModule('improve', _improve, iNode, {
            passportUrl: _u._$SafariChangeUrl(window.passportUrl),
            locale: {
              locale: locale,
              content: _LocaleData.improve[locale]
            }
          })
          _Improve._$init(iNode)
        }
        break
      case 'exclusive':
        // 已获取到账号信息，需要展示
        _p.shHeader()

        // 此处需要删除token，避免刷新后可用
        _u._$sendMsg(frameId, {
          name: 'removeToken'
        })
        window.loadingToken = false
        _p.shLoading(false)
        // 与补全信息用相同的容器
        var eNode = _e._$getByClassName(_p.options.head, 'j-improve')[0]
        _u.initModule('exclusive', _exclusive, eNode, {
          homesiteUrl: _u._$SafariChangeUrl(window.homesiteUrl)
        })
        _Exclusive._$init(eNode)
        break
      case 'goHome':
        window.loadingToken = false
        location.href = '$((baseUrl))'
        break
      case 'reload':
        window.loadingToken = false
        location.reload()
        break
      case 'busy':
        _p.shLoading(false)
        _u.showError(_LocaleData.base[locale].unKnowErrorMsg)
        break
      case 'auth':
        if (data.msg.authServiceType === 'cloudSafe') {
          location.href = '$((cloudSafeUrl))'
        } else if (locale === 'en_US' || data.msg.authServiceType === 'cloudBase') {
          location.href = '$((cloudBaseUrl))'
        }
        break
      case 'locale':
        if (locale !== data.locale) {
          locale = data.locale

          if (_u._$isFunction(_p.options.localeChange)) {
            _p.options.localeChange(locale)
          }
          _p.initHeader(locale)

          var userInfo = sessionStorage.getItem('userInfo')
          if (userInfo) {
            _p.initAccount(JSON.parse(userInfo))
          }

          _u._$sendMsg(frameId, {
            name: ['service', 'sdList']
          })
        }
        break
      // case 'authWithCookie':
      //   if (data.msg.authServiceType === 'cloudSafe') {
      //     location.href = '$((cloudSafeUrl))'
      //   } else if (data.msg.authServiceType === 'cloudBase') {
      //     location.href = '$((cloudBaseUrl))'
      //   }
      //   break
      default:
        console.log('no name as ' + name)
    }
  }

  /**
   * [_$showSd 显示/隐藏左侧导航]
   * @param  {[boolean]} status [显示/隐藏]
   * @return {[null]}
   */
  _p._$showSd = function (status) {
    var sd = _e._$getByClassName(_p.options.side, 'm-yun-base')[0]
    if (status) {
      _e._$delClassName(sd, 'z-hide')
    } else {
      _e._$addClassName(sd, 'z-hide')
    }
  }

  _p._$resetSd = function (filterSd) {
    /* 此处重写filter函数 */
    if (filterSd) {
      _p.options.filterSd = filterSd
    }

    _p.sdChange()
  }

  /**
   * [initSd 左侧导航]
   * @param  {[type]} data []
   * @return {[type]}      []
   */
  _p.initSd = function (data) {
    if (_p.options.sdHide || !data) {
      return
    }
    var origin = _u._$url2origin(location.href)
    data.path = location.href.replace(origin, '')
    if (location.search) {
      data.path = data.path.replace(location.search, '')
    }
    data.path = data.path.split('?')[0]
    data.origin = origin
    var leftNode = _e._$getByClassName(_p.options.side, 'm-yun-left')[0]
    var scrollTop = leftNode ? leftNode.scrollTop : 0
    if (_u._$isFunction(_p.options.filterSd)) {
      var newList = []
      _u._$forEach(data.list, function (item) {
        if (item.url) {
          if (_p.options.filterSd(item.url)) {
            newList.push(item)
          }
        } else if (item.list) {
          var lessList = []
          _u._$forEach(item.list, function (lessItem) {
            if (lessItem.url) {
              if (_p.options.filterSd(lessItem.url)) {
                lessList.push(lessItem)
              }
            }
          })
          item.list = lessList
          newList.push(item)
        }
      })
      data.list = newList
    }

    if (_u._$isFunction(_p.options.filterSdAll)) {
      data.list = _p.options.filterSdAll(data.list)
    }

    data.sdOpen = _p.options.sdOpen
    if (_p.options.customSdItem) {
      data.customSdItem = true
    }
    data.locale = {
      locale: locale
    }
    _u.initModule('sd', _left, _p.options.side, data)
    if (_u._$isFunction(_p.options.sdReady)) {
      _p.options.sdReady()
    }
    _sd._$init(_p.options.side, scrollTop, _p.options.customSdItem)
  }

  _p.sdChange = function () {
    if (!_p.ready) {
      return
    }
    // 此处需要做两次判断，一次更新active，一次更新数据
    _p.initSd(_p.options.sdData)
    _u._$sendMsg(frameId, {
      name: 'sdList'
    })
  }

  /**
   * [headChange 蜂巢专用]
   * @return {[type]} [description]
   */
  _p.headChange = function () {
    var order = ''
    var list = _e._$getByClassName(_p.options.head, 'op-order')
    if (list && list[0]) {
      order = list[0]
    } else {
      return
    }
    if (location.href.indexOf('$((cUrl))/dashboard#/m/ticket/') === 0) {
      _e._$addClassName(order, 'z-selected')
    } else {
      _e._$delClassName(order, 'z-selected')
    }
  }

  _p.signOut = function () {
    _u._$sendMsg(frameId, {
      name: 'signOut'
    })
  }

  _p.initAccount = function (data, reset) {
    if (reset) {
      // 不再判断
      /* var userInfo = sessionStorage.getItem('userInfo')
      if (userInfo && JSON.stringify(data) === userInfo) {
        // 数据相同，不覆盖，不处理
        return
      } */
      sessionStorage.setItem('userInfo', JSON.stringify(data))
    }
    var parentNode = _e._$getByClassName(_p.options.head, 'j-account')[0]
    data.infoUrl = _u._$SafariChangeUrl('$((baseUrl))/' + (_p.options.isCommon ? 'userCenter#/' : 'user#/') + (data.isSubUser === 'true' ? 'profile/' : 'info'))
    data.balanceUrl = _u._$SafariChangeUrl('$((baseUrl))/user#/balance')
    data.certifyUrl = _u._$SafariChangeUrl('$((baseUrl))/dashboard#/m/certify/')
    // data.certifyUrl = _u._$SafariChangeUrl('$((baseUrl))/user#/certify')
    data.securityUrl = _u._$SafariChangeUrl('$((cUrl))/dashboard#/account/security')
    data.accesskeyUrl = _u._$SafariChangeUrl(data.isSubUser === 'true' ? '$((baseUrl))/user#/accessKey/' : '$((cUrl))/dashboard#/account/accesskey')

    // if (data.authServiceType === 'cloudBase') {
    data.accessUrl = _u._$SafariChangeUrl('$((cloudBaseUrl))')
    // } else if (locale === 'en_US' || data.authServiceType === 'cloudSafe') {
    //   data.accessUrl = _u._$SafariChangeUrl('$((cloudSafeUrl))')
    // }

    data.channelPanelUrl = _u._$SafariChangeUrl('$((channelUrl))/#/channel/info')
    data.channelBaseOperatorUrl = _u._$SafariChangeUrl('$((channelUrl))$((channelBaseOperatorUrl))')
    data.iotOperatorUrl = _u._$SafariChangeUrl('$((baseUrl))/user#/iot/operator/1')
    data.iotCustomUrl = _u._$SafariChangeUrl('$((baseUrl))/user#/iot/customer/1')

    if (data.isSubUser === 'true') {
      loginUrl = window.passportUrl + '/p-sub-login'
    }

    data.locale = {
      locale: locale,
      content: _LocaleData.account[locale]
    }
    data.isCommon = _p.options.isCommon ? 'true' : ''
    data.baseUrl = '$((baseUrl))'
    _u.initModule('account', _account, parentNode, data)

    _Account._$init(parentNode, _p.signOut)
  }

  _p.shLoading = function (show) {
    // 全局禁用
    if (!_p.options.showLoading) {
      return
    }

    if (!show) {
      // 隐藏
      window.loadingToken = false
    } else if (!window.loadingToken) {
      // 显示时判断是否正在loading
      return
    }

    var node = _e._$getByClassName(_u._$getBody(), 'm-yun-loading')[0]
    if (!node) {
      if (show) {
        node = _e._$create('div', '', _u._$getBody())
        node.innerHTML = _loading
      }
    } else {
      node && show ? _e._$delClassName(node, 'z-hide') : _e._$addClassName(node, 'z-hide')
    }

    return
  }

  _p.shHeader = function () {
    _e._$addClassName(_e._$getByClassName(_p.options.head, 'm-yun-head')[0], 'login')
  }

  return _p
},'15fb3eeb129e67b9b1cc98ef8ea8e26d','72b60541618971d03c8b74f45c039218','ff746cdffa6022e10ac6474410445437','542fab9973f7cdb3d850d2bdf6833803','f9797207da2091aa22c4e79ebd14ba7b','46e728ed94253a743910263e624644a1','c26aac78045e1fe32f4f3df2f2593498','257cd0ef1a97e4f8fd1c1f850779b73b','de00d00d362cfba5215ef005fa813b53','5fae61394280575515a74043cd9268a0','9bcad601fe1a6cd5dc002cc58d7b6095','4a8051dab0be3a135be79caf2c562fee','76768f2557c694f62a86363764ade37b','f40e2fcd3b0d983b183f5b0f5dc62180','a61cb9fc46042759284f455999e739db','e1c8abbc71be152cfd9c0e38b62e41b6','b11b47df465ec67dbbcb9599adab01c4','f0a4fdc005307654ff3b2f09188fd67a','4f90e6d4ee11a6259207b3c5f8660b16','339f15ac2dc609db41177afb8d5db3f4');
I$('3d57b3286a658478169cf011f9afe41d',function (e, v, u) {
  var appkey = 'MA-91DF-2127272A00D5'

  return {
    init: function (node) {
      if (window.DATracker) {
        if (u._$url2origin(location.href).indexOf('163yun.com') !== -1) {
          // 自己域名，存cookie
          DATracker.init(appkey, {})
        } else {
          DATracker.init(appkey, {
            truncateLength: 255,
            persistence: 'localStorage',
            cross_subdomain_cookie: false
          }, 'yun163')
        }

        this.initHubble(node)
      }
    },
    initHubble: function (node) {
      var self = this
      v._$addEvent(node, 'click', function (event) {
        var link = v._$getElement(event, 't:a')
        var href = e._$attr(link, 'href')

        if (link) {
          var moduleId = e._$dataset(link, 'moduleid')

          // 没有moduleId不算统计项，不处理
          if (moduleId) {
            event.preventDefault();
            var target = e._$attr(link, 'target') === '_blank'

            // TODO 获取埋点数据
            var data = {
              targetUrl: href
            }

            moduleId ? data.topMenuId = moduleId : ''

            if (href) {
              if (target) {
                var newTab = window.open(href, '_blank')
                self.track('console-link', data, function () {})
                newTab.opener = null
              } else {
                setTimeout(function () {
                  self.hubbleCallback(href)
                }, 200)
                self.track('console-link', data, function () {
                  self.hubbleCallback(href)
                })
              }
            }
          }
        }
      })
    },
    hubbleCallback: function (href) {
      location.href = href
    },
    /**
     * [track 封装一层]
     * @param  {[type]}   eventName [事件名]
     * @param  {[type]}   data      [数据]
     * @param  {Function} callback  [回调函数]
     * @return {[type]}             [null]
     */
    track: function (eventName, data, callback) {
      var da = DATracker.yun163 || DATracker
      da.track(eventName, data, callback)
    }
  }
},'15fb3eeb129e67b9b1cc98ef8ea8e26d','72b60541618971d03c8b74f45c039218','3f115371e3e07e18707a0c434f8a73ce');
I$('4cfac61cb84f4709d3d3fa32283483f3',function (_e, _u, _base, hubble) {
  window.WYYUN = (function () {
    var instance
    /**
     * [constructor ]
     * @param  {[object]}      option              []
     * @param  {[string|node]} option.head         [顶通]
     * @param  {[string|node]} option.side         [左边导航]
     * @param  {[string]}      option.source       [来源：默认为yun]
     * @param  {[string]}      option.isCommon     [是否为公共页面] // 公共页面用户信息展示的少，文档不展示
     * @param  {[boolean]}     option.sdHide       [是否显示左侧导航]
     * @param  {[boolean]}     option.sdOpen       [是否展开左侧导航]
     * @param  {[boolean]}     option.useLocale    [是否启用多语言，默认false]
     * @param  {[function]}    option.sdReady      [左侧导航渲染完成后触发]
     * @param  {[function]}    option.filterSd     [根据url过滤左侧导航]
     * @param  {[function]}    option.filterSdAll  [过滤完整左侧导航]
     * @param  {[function]}    option.showSd       [显示/关闭左侧导航]
     * @param  {[function]}    option.resetSd      [传入新的filter方法并重置左侧导航 1.0.6]
     * @param  {[function]}    option.customSdItem [自定义组件，目前只支持单个、固定位置 1.0.6]
     * @param  {[function]}    option.init         [登录完成之后的初始化函数]
     * @param  {[function]}    option.localeChange [语言切换之后的回调, useLocale为true时生效]
     * @param  {[function]}    option.signOut      [登出回调]
     * @return {[object]}      window.WYYUN        [构造函数]
     */
    function constructor (option) {
      _base._$init(option)
      hubble.init(option.head)

      return {
        account: option.account,
        head: option.head,
        side: option.side,
        sdOpen: option.sdOpen,
        sdReady: option.sdReady,
        filterSd: option.filterSd,
        filterSdAll: option.filterSdAll,
        showSd: _base._$showSd,
        resetSd: _base._$resetSd,
        showLoading: option.showLoading,
        getUnreadMsg: function (count) {
          _u._$isFunction(option.getUnreadMsg) ? option.getUnreadMsg(count) : undefined
        },
        signOut: function () {
          _u._$isFunction(option.signOut) ? option.signOut() : undefined
        }
      }
    }
    return {
      getInstance: function (option) {
        if (!instance) {
          instance = constructor(option)
        }
        return instance;
      }
    }
  })()

  // 下面要注释掉
  
  // WYYUN.getInstance({
  //   head: 'top',
  //   side: 'left',
  //   signOut: function () {
  //     alert('signOut')
  //   },
  //   init(){
  //     console.log('执行初始化')
  //   },
  //   isCommon:true,
  //   source:'yun'
  // })
},'15fb3eeb129e67b9b1cc98ef8ea8e26d','542fab9973f7cdb3d850d2bdf6833803','5f27648084348a2f2d2d582a526e697b','3d57b3286a658478169cf011f9afe41d');